import React, {Component} from 'react'
import styled, { ThemeProvider } from 'styled-components'
import fire from '../../../database/firebase'
import Tesseract from 'tesseract.js';
import ClipLoader from "react-spinners/ClipLoader";
import { upload } from '@testing-library/user-event/dist/upload';
import Select from 'react-select';
import { Toast } from 'bootstrap';
import { toContainHTML, toHaveStyle } from '@testing-library/jest-dom/matchers';
import _, { reduceRight } from 'lodash';
import SearchBox from "react-search-box";
import shortid from 'shortid';
import { daysInWeek, lastDayOfMonth } from 'date-fns';


const Styles = styled.div `

    

    // - - - - - PARENT CONTAINER - - - - - //

.parentContainer {
    height: auto;
    width: 97%;
    // margin-left: 2.5%;
    text-align: left;
    padding-right: 3%;
    padding-bottom: 3%;
}

.membersContent {
    width: 100%;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    margin-top: 1%;
    border-radius: 8.5px;
    padding-bottom: 3%;
    margin-right: 3%;
}

    // - - - - - TRANSACTIONS DASHBOARD - - - - - //

.transactionsDashboard {
    background-color: #E5E5E5;
    margin-top: 5%;
    width: 100%;
    height: 70vh;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.tranactionsDashboard:after {
    content: "";
    display: table;
    clear: both;
}

.tDashboardLeft {
    float: left;
    text-align: center;
    width: 65.5%;
    padding: 1%;
}

.tDashboardRight {
    float: left;
    text-align: center;
    width: 32.5%;
}

    //? - - DASHBOARD LEFT CONTAINER - - ?//

.tDashboardLeftContainer {
    height: 67vh;
    max-height: 100%;
    width: 100%;
    background-color: white;
    position: relative;
    border-radius: 8px;
}

.tDashboardLeftContainer:after {
    content: "";
    display: table;
    clear: both;
}

    // - LEFT DASHBOARD PLACEHOLDER CONTAINER - //

.tDashboardPlaceholderContainer h1 {
    margin-top: 0px !important;
    text-align: center !important;
    padding-top: 20% !important;
    padding-left: 5% !important;
    padding-right: 5% !important;
}

.tDashboardPlaceholderContainer img {
    margin-top: 5%;
    width: 10%;
}

    // - LEFT DASHBOARD LOADING CONTAINER - //

.tDashboardLeftLoading {
    padding-top: 32.5%;
}

.tReceiptSide {
    float: left;
    width: 48%;
    text-align: center;
}

.tDetailSide {
    float: left;
    width: 52%;
    text-align: center;
    // border-left: 1px solid #0930cb;
    height: 100%;
}

    // - - VALID EARNING POLICIES - - //

.validEarningPolicies {
    margin-top: 4%;
}

    // - - RECEIPT SIDE - - //

.tReceiptSide h3 {
    margin-top: 3.5%;
    margin-bottom: 8%;
    text-align: left;
    margin-left: 3.5%;
    color: #0930cb;
    font-family: gabarito;
}

.receiptImgContainer {
    height: 100%;
    width: 100%;
    
}

.receiptImgContainer img {
    height: 100%;
    width: 92.5%;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.receiptImg {
    transition: transform 0.3s ease-in-out;
    position: relative; /* Ensure the position is set to relative or absolute */
    z-index: 1; /
}

.receiptImg:hover {
    transform: scale(1.35);
    z-index: 999999;
    cursor: zoom-in;
}

    // - - DETAILS SIDE (LOADING) - - //

.transactionDetailsLoading {
    position: relative;
    overflow-y: scroll;
    height: 80%;
    padding-top: 2%;
    margin-top: 10%;
    margin-left: 5%;
    border-left: 1px solid #0930cb;
}

    // - - DETAILS SIDE - - //

.tDetailSide h3 {
    text-align: center;
    margin-left: 2.5%;
    color: #0930cb;
    font-family: gabarito;
}

.transactionDetails {
    position: relative;
    overflow-y: scroll;
    height: 80%;
    padding-top: 2%;
    margin-top: 10%;
    margin-left: 5%;
    border-left: 1px solid #0930cb;
    // padding-bottom: 10%;
}

.tDetailInputs {
    width: 95%;
    margin-left: 2.5%;
}

.tDetailInputs:after {
    content: "";
    display: table;
    clear: both;
}

.tDetailLabel {
    width: 30%;
    float: left;
    text-align: left;
}

.tDetailInput {
    width: 70%;
    float: left;
    text-align: left;
} 

    // - TRANSACTION DETAIL LABEL - //

.tDetailLabel p {
   
}

    // - TRANSACTION DETAIL INPUT - //

.tDetailInput input {
    margin-left: 2.5%;
    width: 86.5%;
    font-size: 100%;
    padding: 1.5%;
    border-radius: 3px;
    outline-color: #0930cb;
    border: 0.5px solid black;
    font-family: gabarito;
}

.tDetailInput button {
    margin-left: 2.5%;
    padding: 2%;
    background-color: #0930cb;
    border: 2px solid transparent;
    border-radius: 8px;
    color: white;
    font-family: gabarito;
    width: 40%;
    font-size: 85%;
    cursor: pointer;
}

.tDetailInput label {
    font-family: gabarito;
    font-weight: bold;
    margin-top: 100%;
}

.tDetailInput span {
    margin-left: 2.5%;
    background-color: #0930cb;
    border-radius: 20px;
    padding: 2.5%;
}

.orderStatus img {
    margin-top: 1.1%;
    margin-right: 5%;
    width: 12.5px;
    height: 12.5px;
    padding: 2%;
    border-radius: 50%;
}

.orderStatus img:hover {
    background-color: #E7E7E7;
    cursor: pointer;
}

.menuOrdersLoading {
    text-align: center;
    margin-top: 2.5%;
    margin-bottom: 2.5%;
}

.rewardCategories {
    width: 100%;
    // padding-bottom: 2%;
}

    // - - REJECTION CUSTOMER MESSAGE - - //

.rejectionCustomerMsg {
    text-align: left;
    margin-left: 2.5%;
}

.rejectionCustomerMsg textarea {
    width: 90.5%;
    resize: none;
    border-radius: 5px;
    border: 1px solid black;
    height: 5em;
    padding: 1.5%;
    margin-bottom: 2%;
    font-family: gabarito;
    outline-color: #0930cb;
}

.rejectionCustomerMsg button {
    margin-bottom: 2.5%;
    background-color: #0930cb;
    padding: 2.5%;
    color: white;
    font-family: gabarito;
    border: 2px solid #0930cb;
    border-radius: 20px;
    cursor: pointer;
    // font-weight: bold;
}

.rejectionCustomerMsg span {

}

.rewardsErrorMsg {
    margin-left: 1.5%;
}

.baselineValueAlert:after {
    content: "";
    display: table;
    clear: both;
}

.baselineValueAlert {
    background-color: white;
    // height: 20px;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10), 0 6px 20px 0 rgba(0, 0, 0, 0.10);
    text-align: right;
    width: 89% !important;
    position: absolute !important;
    bottom: 10% !important;
    right: 7% !important;
    border-radius: 8px;
    border: 1.5px solid #0930cb;
}

.baselineValueMsg {
    float: left;
    width: 90%;
    text-align: left;
}

.baselineValueClose {
    float: left;
    width: 10%;
    text-align: right;
}

.baselineValueMsg h5 {
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 1%;
    padding: 2%;
    font-family: gabarito;
    // font-weight: bold;
    color: #0930cb;
}

.baselineValueMsg label {
    font-weight: bold;
}

.baselineValueClose button {
    all: unset;
    // padding-right: 15%;
    // padding-top: 2%;
    font-family: gabarito;
    font-size: 20px;
}

.baselineValueClose button:hover {
    
}

.baselineValueClose img {
    width: 35%;
    margin-right: 10%;
    border-radius: 50%;
}

.baselineValueClose img:hover {
    background-color: #E7E7E7;
    cursor: pointer;
}

.completeAddOrderBtn {
    text-align: right;
    width: 100%;
    position: absolute;
    bottom: 0.2%;
    right: 7%;
}

.completeAddOrderBtn button {
    width: 40%;
    padding: 3%;
    background-color: #0930cb;
    color: white;
    font-family: gabarito;
    border: 2px solid #0930cb;
    border-radius: 8px;
    cursor: pointer;
}

    // - MENU ORDER LIST DETAILS - //

.menuOrderContainer {
    width: 100%;
}

.menuOrderContainer:after {
    content: "";
    display: table;
    clear: both;
}

.menuOrderQty {
    float: left;
    text-align: center;
    width: 10%;
}

.menuOrderItem {
    float: left;
    text-align: left;
    width: 90%;
}

.menuOrderContainer label {
    font-size: 14px !important;
    font-weight: normal !important; 
}

.transactionDetails p {
    text-align: left;
    margin-top: 3%;
    margin-left: 2.5%;
    font-family: gabarito;
    font-weight: bold;
    color: #0930cb;
}

.transactionDetails label {
    margin-top: 0px;
    color: black;
}

.transactionCompletionBtns {
    // text-align: right;
    margin-top: 3%;
    position: relative;
}

.transactionCompletionBtns button {
    cursor: pointer;
    padding: 3%;
    // border: 2px solid #0930cb;
    border-radius: 8px;
    // background-color: #0930cb;
    // color: white;
    font-family: gabarito;
    font-size: 85%;
    // position: absolute;
    // bottom: 3;
}

.rejectTransactionBtn {
    background-color: white;
    border: 2px solid red;
    color: red;
}

.approveTransactionBtn {
    background-color: white;
    border: 2px solid green;
    color: green;
    margin-right: 7.5%;
}

    //? - - DASHBOARD RIGHT CONTAINER - - ?//

.tDashboardRightContainer {
    width: 100%;
}

.tVerifiedButtons {
    // border: 4px solid white;
    text-align: left;
    margin-top: 3%;
}

.tVerifiedButtons button {
    padding: 5%;
    cursor: pointer;
}

.pendingApprovalBtn {
    width: 50%;
    font-family: gabarito;
    font-size: 95%;
    border-left: 0.5px solid #0930cb;
    border-top: 0.5px solid #0930cb;
    border-bottom: 0.5px solid #0930cb;
    border-right: 0.5px solid #0930cb;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.pendingApprovalBtn label {
    margin-left: 3.5%;
}

.approvalBtn {
    width: 47%;
    font-family: gabarito;
    font-size: 95%;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top: 0.5px solid #0930cb;
    border-right: 0.5px solid #0930cb;
    border-bottom: 0.5px solid #0930cb;
    border-left: 0px solid transparent;
}

.approvalBtn label {
    margin-left: 3.5%;
}

    // - - SEARCH CONTAINER - - //

.tSearchContainer {
    margin-top: 3.5%;
    width: 97.5%;
}

.tSearchContainer:after {
    content: "";
    display: table;
    clear: both;
}

.tSearchBar {
    float: left;
    text-align: left;
    width: 80%;
}

.tSearchButton {
    float: left;
    text-align: right;
    width: 19%;
}

    // - SEARCH BAR - //

.tSearchBar input {
    width: 92.5%;
    font-size: 17px;
    padding: 1.5%;
    border: 0.5px solid #0930cb;
    outline-color: #0930cb;
    border-radius: 5px;
    font-family: gabarito;
}

    // - SEARCH BUTTON - //

.tSearchButton button {
    padding-bottom: 7%;
    padding-top: 7%;
    width: 100%;
    background-color: #0930cb;
    border: 2px solid #0930cb;
    border-radius: 6.5px;
    // font-size: 90%;
    color: white;
    font-family: gabarito;
    cursor: pointer;
}

    // - - RECEIPT LIST - - //

.tReceiptList {
    margin-top: 5%;
    overflow-y: scroll;
    width: 97%;
    background-color: white;
    height: 53.25vh;
    border-radius: 8px;
    border: 1px solid #0930cb;
}

    // - - VERIFIED / NON-VERIFIED RECEIPT LIST - - //

.vReceiptList { 
    cursor: pointer;
    padding-top: 2.5%;
    border-bottom: 1px solid #0930cb;
    text-align: left;
}

.vReceiptList h4 {
    margin-top: 2%;
    margin-left: 2.5%;
    margin-bottom: 0px;
    color: #0930cb;
    font-family: arvo;
}

.vReceiptList h5 {
    margin-top: 2%;
    margin-left: 2.5%;
    margin-bottom: 1.5%;
    font-family: sora;
    font-size: 15px;
}

.vReceiptList label {
    margin-left: 2.5%;
    color: red;
    font-family: gabarito;
    font-weight: bold;
    // font-weig
}

.vReceiptList p {
    text-align: right;
    margin-right: 2.5%;
    font-weight: bold;
    font-family: gabarito;
    color: #0930cb;
    margin-top: 1.5%;
}

    // - - NON VERIFIED RECEIPT LOADING - - //

.nonVerifiedReceiptLoading {
    text-align: center;
    padding-top: 15%;
    padding-bottom: 15%;
}

    // - - - - - - - POINTS MANAGER - - - - - - - - //

.pointsManager {
    margin-top: 4%;
    height: 67.5vh;
    background-color: #cccccc;
    width: 95%;
    border-radius: 8px;
}

.pointsManagerInnerContainer:after {
    content: "";
    clear: both;
    display: table;
}

.pointsManagerCol1 {
    float: left;
    text-align: center;
    width: 35%;
}

.pointsManagerCol2 {
    float: left;
    text-align: center;
    width: 58%;
    background-color: white;
    padding: 2.5%;
    margin-left: 1.5%;
    height: 90%;
    border-radius: 6px;
    border: 1px solid #0930cb;
}

.pointsRedeemInfo:after {
    content: "";
    display: table;
    clear: both;
}

.pointsRedeemInfoCol1 {
    float: left;
    text-align: right;
    width: 35%;
}

.pointsRedeemInfoCol2 {
    float: left;
    text-align: left;
    width: 60%;
}

    // - POINTS REDEEM INFO COL 1 - //

.pointsRedeemInfoCol1 h4 {
    margin-right: 7.5%;
    margin-bottom: 2%;
    font-family: sora;
}

    // - POINTS REDEEM INFO COL 2 - //

.pointsRedeemInfoCol2 h4 {
    font-family: sora;
    margin-bottom: 2%;
    color: #0930cb;
}

    // - - PENDING POINTS CELL - - //

.pendingPointsCell h3 {
    text-align: left;
    margin-left: 2%;
    font-family: sora;
    color: #0930cb;
}

    // - - - - - - - SEARCH BOX RESULTS - - - - - - - //

.memberLoadingScreen {
    padding-top: 22.5%;
    text-align: center;
}

.searchBoxResults {
    margin-top: 1.5%;
    margin-bottom: 2.5%;
}

.searchBoxResults ul {
    list-style: none;
    padding: 0;
}
      
    
.searchBoxResults li {
    background-color: #f8f9fa; /* Light background color */
    border: 1px solid #dee2e6; /* Border color */
    padding: 10px;
    // margin-bottom: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}
      
      /* Hover effect */
.searchBoxResults li:hover {
    background-color: #e9ecef; /* Lighter background color on hover */
}

    // - - - - - - - MEMBERS OPTIONS - - - - - - - //
    
    // - - CHALLENGES CONTAINER - - //

.challengesContainer {
    margin-top: 1.5%;
    margin-bottom: 4.5%;
}

.challengesContainer:after {
    content: "";
    display: table;
    clear: both;
}

.challengeBox {
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    text-align: left;
    width: 30%;
    margin-right: 5%;
    float: left;
    // margin-left: 0.5%;
    height: 36vh;
    position: relative;
    cursor: pointer;
}

.challengeBox:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox2:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox2:hover .innerChallengeBox2 {
    color: white;
}

.challengeBox:hover h4 {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox h1 {
    margin-top: 2.5%;
    margin-bottom: 0px;
    margin-left: 4%;
    font-size: 50px;
}

.challengeBox h4 {
    margin-top: 1%;
    margin-bottom: 2.5%;
    margin-left: 4%;
    font-family: arvo;
    color: #0930cb;
}

.challengeBox h2 {
    // margin-top: 3%;
    // margin-left: 4%;
    font-family: Arvo;
    font-size: 30px;
    margin-bottom: 2.5%;
    position: absolute;
    left: 4%;
    bottom: 3%;
    // color: black;
}

    // - - - - - - - SEGMENTED USERS - - - - - - - //

.segmentedUsers {
    // padding-top: 2.5%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.segmentedUsers h2 {
    // margin-top: 0px;
    padding-top: 0%;
    padding-left: 1.5%;
    font-family: sora;
    color: #0930cb;
    margin-bottom: 0px;
}

.segmentedUsers p {
    margin-top: 0.5%;
    padding-left: 1.5%;
    font-family: sora;
    color: #0930cb;
}

.segmentYear {
    padding-top: 1.65%;
    margin-left: 1%;
}

.segmentType {
    width: 25%;
    margin-right: 1.5%;
}

.segmentTimeline {
    // text-align: right;
    width: 15%;
    margin-left: 1.5%;
}

.segmentMonthTimeline {
    // text-align: right;
    width: 9%;
    margin-left: 1%;
}

.segmentFilters button {
    border-radius: 8px;
    background-color: #0930cb;
    border: 2px solid #0930cb;
    color: white;
    font-familt: sora;
    cursor: pointer;
}

.segmentCSVBtn button {
    padding: 1%;
    width: 20%;
    border-radius: 7px;
    color: white;
    background-color: #0930cb;
    border: 2px solid #0930cb;
    font-family: gabarito;
    cursor: pointer;
    font-size: 90%;
}

.dataDisplayCell {
    padding-bottom: 0.5%;
    border-bottom: 1px solid #0930cb;
}

    // - - - SEGMENT FILTER OPTIONS - - - //

.segmentOptionsCloseBtn {
    margin-top: 1.65%;
    margin-left: 1.5%;
    width: 30%;
}

.segmentOptionsCloseBtn button {
    padding: 2.5%;
    border-color: red;
    background-color: #D40C0C;
    border: 2px solid #D40C0C;
    border-radius: 8px;
    color: white;
    font-family: sora;
    font-size: 75%;
    cursor: pointer;
}

.segmentFilterOptions {
    margin-top: 0px;
    width: 20%;
    margin-left: 1.5%;
    margin-bottom: 1.5%;
}


    // - - - - - - - MEMBER PROFILE - - - - - - - //

.memberBackToSearchBtn button {
    width: 25%; 
    border-radius: 7px; 
    padding: 1%; 
    border: 2px solid #D40C0C; 
    font-family: gabarito; 
    color: #D40C0C; 
    font-weight: bold; 
    cursor: pointer; 
    background-color: white;
}

.memberBackToSearchBtn button:hover {
    background-color: #D40C0C;
    color: white;
}

.memberProfileHeaderContainers {
    width: 97.5%;
    border-bottom: 2px solid #C3C3C3;
}

.memberProfileHeaderContainers: after {
    display: table;
    clear: both;
    content: "";
}

.memberProfileHeaderCol {
    float: left;
    width: 25%;
    text-align: left;
}

.memberProfileHeaderSection {
    margin-top: 10%;
    margin-bottom: 12.5%;
    width: 87.5%;
    height: 7.5vh;
    border: 2px solid #0930cb;
    border-radius: 8px;
}

.memberProfileHeaderSection:after {
    content: "";
    display: table;
    clear: both;
}

.memberProfileHeaderSectionCol1 {
    float: left;
    text-align: right;
    width: 22.5%;
}

.memberProfileHeaderSectionCol2 {
    float: left;
    text-align: left;
    width: 75%;
}
    // - MEMBER PROFILE HEADER SECTION COL 1 - //

.memberProfileHeaderSectionCol1 img {
    margin-top: 31%;
    width: 60%;
}

    // - MEMBER PROFILE HEADER SECTION COL 2 - //

.memberProfileHeaderSectionCol2 h5 {
    font-family: gabarito;
    font-size: 12px;
    margin-top: 7%;
    margin-bottom: 0px;
    margin-left: 7.5%;
}

.memberProfileHeaderSectionCol2 h4 {
    font-family: gabarito;
    color: #0930cb;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 7.5%;
}

    // - - MEMBER PROFILE DATA - - //

.memberProfileData:after {
    content: "";
    display: table;
    clear: both;
}

.memberProfileDataHeader h3 {
    padding-top: 5%;
    font-family: Arvo;
    color: #0930cb;
}

.memberProfileDataCol1 {
    float: left;
    text-align: left;
    width: 70%;
}

.memberProfileDataCol2 {
    float: left;
    text-align: left;
    width: 30%;
}

.memberProfileDataSection {
    width: 85%;
    height: 36.5vh;
    border: 1.5px solid #0930cb;
    border-radius: 8px;
}

.memberTransactionsLoading {
    text-align: center;
    margin-top: 19.5%;
}

    // - PROFILE OPTIONS MENU - //

.profileOptionsMenu

    // - -  MEMBERS TRANSACTION CELL - - //

.memberTransactionsEmpty h2 {
    text-align: center;
    margin-top: 15%;
    font-family: arvo;
    color: #0930cb;
}

.memberTransactionCell {
    border-bottom: 2px solid #0930cb;
}

.memberTransactionPara span {
    width: 100%;
}

.memberTransactionPara p:hover {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
}

    // - - MEMBER TRANSACTION ORDER CELL - - //

.memberTransactionOrderCell p {
    font-family: gabarito;
    color: black;
    margin-left: 2.5%;
    margin-right: 2.5%;
    font-size: 85%;
}

.memberOrderInformationHeader {
    margin-top: 5%;
}

.memberOrderInformationHeader p {
    margin-bottom: 2%;
    margin-top: 0px;
}

.memberOrderInformationHeader span {
    background-color: #0930cb;
    padding-top: 1.5%;
    padding-bottom: 1.5%;
    padding-left: 3%;
    padding-right: 3%;
    border-radius: 20px;
}

.memberOrderInformationHeader h4 {
    text-align: right;
}


`

export default class Members extends Component {
    constructor(props) {
        super(props)
        this.state = {

                //* - - MEMBER SEARCH - - *//
            
            showMemberSearch: true,
            showMemberLoading: false,
            showMemberProfile: false,
            showMemberTransactions: true,
            showNoTransactionsMsg: false,
            searchTerm: '',
            searchingUserID: "",
            searchResults: [],
            memberVerificationStatus: false,
            memberCurrentFirstName: "",
            memberCurrentLastName: "",
            memberCurrentCardNumber: "",
            memberCurrentTotalPoints: 0,
            memberRegistrationDate: "",
            memberLastActive: "",
            memberPhoneNumber: "",
            memberTransactions: [],
            memberTransactionOrder: [],
            memberCurrentOrderDate: "",
            memberCurrentEarningPolicy: "",
            memberCurrentTotal: "",
            memberCurrentPoints: 0,

                //* - - MEMBERS OPTIONS - - *//

            showMembersBtns: true,
            membersLastDisplayed: "",
            showSegmentDashboard: false,
            showMembersDashboardLoading: false,

                //* - - SEGMENT CUSTOMERS - - *//

            selectedTimelineOption: null,
            segmentTimelineOptions : [
                // {value: "empty", label: "..."},
                {value: "jan", label: "January"},
                {value: "feb", label: "February"},
                {value: "mar", label: "March"},
                {value: "apr", label: "April"},
                {value: "may", label: "May"},
                {value: "jun", label: "June"},
                {value: "jul", label: "July"},
                {value: "aug", label: "August"},
                {value: "sep", label: "September"},
                {value: "oct", label: "October"},
                {value: "nov", label: "November"},
                {value: "dec", label: "December"}
            ],

            segmentMonthFromTimelineOptions : [
                // {value: "empty", label: "..."},
                {value: "jan", label: "Jan"},
                {value: "feb", label: "Feb"},
                {value: "mar", label: "Mar"},
                {value: "apr", label: "Apr"},
                {value: "may", label: "May"},
                {value: "jun", label: "Jun"},
                {value: "jul", label: "Jul"},
                {value: "aug", label: "Aug"},
                {value: "sep", label: "Sep"},
                {value: "oct", label: "Oct"},
                {value: "nov", label: "Nov"},
                {value: "dec", label: "Dec"},
            ],

            segmentMonthToTimelineOptions : [
                // {value: "empty", label: "..."},
                {value: "jan", label: "Jan"},
                {value: "feb", label: "Feb"},
                {value: "mar", label: "Mar"},
                {value: "apr", label: "Apr"},
                {value: "may", label: "May"},
                {value: "jun", label: "Jun"},
                {value: "jul", label: "Jul"},
                {value: "aug", label: "Aug"},
                {value: "sep", label: "Sep"},
                {value: "oct", label: "Oct"},
                {value: "nov", label: "Nov"},
                {value: "dec", label: "Dec"},
            ],

            showSegmentOptions: false,
            showCloseSegmentOptionsBtn: false,
            showSegmentOptionsLoading: false,
            showSegmentYear: true,
            showCloseSegmentDashboardBtn: true,
            showSegmentFilterData: true,
            showSegmentTitle: true,
            showSegmentTitleLoading: false,
            showSegmentData: true,
            showSegmentDataLoading: false,
            showSaveSegmentBtn: false,
            showDownloadCSVBtn: false,
            showDownloadCSVBtnLoading: false,
            showSegmentDataBtn: true,
            segmentedMembers: [],
            segmentedOptionsMembers: [],
            segmentCurrentYear: "",
            segmentCurrentTitle: "",
            segmentCurrentType: "",
            segmentCurrentMonth: "",
            segmentFilterFromMonth: "",
            segmentFilterFromDay: "",
            segmentFilterToMonth: "",
            segmentFilterToDay: "",
            segmentSearchErrMsg: "",
            selectedSegmentLabel: "select segment",
            selectedSegment: "select segment",
            segmentFromOptionPlaceholder: "1",
            segmentToOptionPlaceholder: "25",
            segmentOptionFromValue: "",
            segmentOptionToValue: "",
            selectedSegmentBorderColor: "#2584ff",
            segmentOptionFromBorderColor: "#cccccc",
            segmentOptionToBorderColor: "#cccccc",

                //* - - MANAGING POINTS - - *//

            showPointsManager: false,
            showPointsRedeemPlaceholder: true,
            showPointsRedeemLoading: false,
            showPointsClickedInfo: false,
            redeemedPoints: [],
            prevClickedPoints: "",
            rewardName: "",
            rewardNameID: "",
            rewardType: "",
            rawRewardType: "",
            rewardDiscountPrice: "",
            rewardDateDatabase: "",
            rewardUserEmail: "",
            rewardUserName: "",
            rewardUserID: "",
            rewardRedeemID: "",
            rewardCustomerValue: "",
            rewardValue: "",
            rewardPointsValue: 0,


                //* - - MANAGING RECEIPTS - - *//

            showTransactionsDashboard: false,
            showTransactionDetails: true,
            showTransactionDetailsLoading: false,
            showReceiptDashboardPlaceholder: true,
            showReceiptDashboard: false,
            showReceiptDashboardLoading: false,
            showReceiptImage: true,
            showReceiptTotalCost: true,
            showRejectionCustomerMsg: false,
            showReceiptImagePlaceholder: false,
            showApproveRecjetionBtns: true,
            showNonVerifiedReceiptInfo: true,
            showNonVerifiedReceiptLoading: false,
            approvalLoadingMsg: "",
            pendingApprovalBtnBgColor: "#0930cb",
            pendingApprovalBtnTxtColor: "white",
            approvedBtnBgColor: "white",
            approvedBtnTxtColor: "#0930cb",
            menuOrders: [],
            nonVerifiedReceipts: [],
            searchingOrderPeriods: [],
            validEarningPolicies: [],
            currentReceiptID: "",
            currentLocation: "",
            userReceiptID: "",
            userReceiptImg: "",
            userLocation: "",
            userInvoiceNo: "",
            userCardNumber: "",
            userName: "",
            userEmail: "",
            earningPolicy: "",
            earningPolicyEndDate: "",
            earningPolicyMoneyValue: 0,
            earningPolicyPercentageChange: "",
            earningPolicyPointsValue: "",
            currentOrderCount: null,
            clickedReceiptImg: "",
            mealOrderCategory: "",
            mealOrderItem: "",
            mealOrderQuantity: "",
            rejectionCustomerMessage: "",
            prevClicked: "",
            userID: "",
            invoiceNumber: "",
            dateOfPurchase: "",
            storeLocation: "",
            totalCost: "",
            totalQty: 0,
            imageText: '',
            savedPointsValue: 0,
            savedMoneyValue: 0,
        }
    }

    componentDidMount = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        this.setState({
            segmentCurrentYear: currentYear,
            segmentCurrentType: "highest-repeat-purchases",
            segmentCurrentTitle: `${currentYear} Highest Repeat Purchases`
        })
        this.getCurrentYearHighestRepeatPurchases(currentYear)
        this.calculateTimeDifference()
        this.checkForClickedReceiptCellChange()
        this.checkForClickedPointsCellChange()
        this.checkForClickedReceiptOrderCountChange()
        this.loadNonVerifiedReceipts()
        this.loadCompanyPointsInformation()
        this.loadPointsRedeemed()
        fire.auth().onAuthStateChanged((user) => {
            if (user.email === "normanburuchara90@gmail.com") {
                
            }
        })
    }

    loadCompanyPointsInformation = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .get().then(doc => {
            const pointsValueInt = parseInt(doc.data().pointsValue)
            const moneyValueInt = parseInt(doc.data().moneyValue)
            this.setState({
                savedPointsValue: pointsValueInt,
                savedMoneyValue: moneyValueInt
            })
        })
    }

    loadNonVerifiedReceipts = () => {
        class Receipt {
            constructor (backgroundColor, cardNumber, dateOfPurchase, earningPolicy, earningPolicyEndDate, earningPolicyMoneyValue, earningPolicyPercentageChange, earningPolicyPointsValue, email, invoiceNumber, location, name, receiptID, receiptImg, uploadTime, userID) {
                this.backgroundColor = backgroundColor
                this.cardNumber = cardNumber
                this.dateOfPurchase = dateOfPurchase
                this.earningPolicy = earningPolicy
                this.earningPolicyEndDate = earningPolicyEndDate
                this.earningPolicyMoneyValue = earningPolicyMoneyValue
                this.earningPolicyPercentageChange = earningPolicyPercentageChange
                this.earningPolicyPointsValue = earningPolicyPointsValue
                this.email = email
                this.invoiceNumber = invoiceNumber
                this.location = location
                this.name = name
                this.receiptID = receiptID
                this.receiptImg = receiptImg
                this.uploadTime = uploadTime
                this.userID = userID
            }
            toString () {
                return this.backgroundColor + ', ' +
                this.cardNumber + ', ' +
                this.dateOfPurchase + ', ' +
                this.earningPolicy + ', ' +
                this.earningPolicyEndDate + ', ' +
                this.earningPolicyMoneyValue + ', ' +
                this.earningPolicyPercentageChange + ', ' +
                this.earningPolicyPointsValue + ', ' +
                this.email + ', ' +
                this.invoiceNumber + ', ' +
                this.location + ', ' + 
                this.name + ', ' +
                this.receiptID + ', ' +
                this.receiptImg + ', ' +
                this.uploadTime + ', ' +
                this.userID 
            }
        }
        var receiptConverter = {
            toFirestore : function(receipt) {
                return {
                    backgroundColor: receipt.backgroundColor,
                    cardNumber: receipt.cardNumber,
                    dateOfPurchase: receipt.dateOfPurchase,
                    earningPolicy: receipt.earningPolicy,
                    earningPolicyEndDate: receipt.earningPolicyEndDate,
                    earningPolicyMoneyValue: receipt.earningPolicyMoneyValue,
                    earningPolicyPercentageChange: receipt.earningPolicyPercentageChange,
                    earningPolicyPointsValue: receipt.earningPolicyPointsValue,
                    email: receipt.email,
                    invoiceNumber: receipt.invoiceNumber,
                    location: receipt.location,
                    name: receipt.name,
                    receiptID: receipt.receiptID,
                    receiptImg: receipt.receiptImg,
                    uploadTime: receipt.uploadTime,
                    userID: receipt.userID
                }
            },
            fromFirestore: function(snapshot, options) {
                const data = snapshot.data(options)
                return new Receipt(data.backgroundColor, data.cardNumber, data.dateOfPurchase, data.earningPolicy, data.earningPolicyEndDate, data.earningPolicyMoneyValue, data.earningPolicyPercentageChange, data.earningPolicyPointsValue, data.email, data.invoiceNumber, data.location, data.name, data.receiptID, data.receiptImg, data.uploadTime, data.userID)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .withConverter(receiptConverter)
        .get().then(snapshot => {
            let data = snapshot.docs.map(doc => doc.data())
            data.shift()
            console.log(data)
            this.setState({
                nonVerifiedReceipts: data
            })
        })

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .get().then(doc => {
            this.setState({
                prevClicked: doc.data().lastClicked
            })
        })
    }

    handleFileChange = async (event) => {
        // const storageRef = fire.storage().ref();
        // const imageRef = storageRef.child('clients/artcaffe/admin/transactions/receipts/user-vmXR1gWdo_AaNhbjGCqf/receipt-2023-11-16-07-54-39.jpeg'); // Adjust the path accordingly

        let file = "/assets/b10-receipt.jpeg"
        if (file) {

            const { data } = await Tesseract.recognize(file, 'eng');
            this.setState({ imageText: data.text });
            // data.text = data.text.replace(/\n/g, ' ');
            if (data.text) {
                if (data.text.includes("ARTCAFFE") || data.text.includes("ARTCRFFE") || data.text.includes("RRTCRFFE") || data.text.includes("RRTCAFFE") || data.text.includes("ARTCARFE")) {
                    console.log("huh?")
                    //* - - INVOICE NO. / DATE / LOCATION - - *//
                    let invoiceNumber = this.getInvoiceNumber(data.text)
                    let dateOfPurchase = this.getDateOfPurchase(data.text)
                    this.getOrderDetails(data.text)
                    let totalCost = this.getTotalCostOfOrder(data.text)
                    let storeLocation = ""
                    if (data.text.includes("THE HUB")) {
                        storeLocation = "The Hub"
                    }
                    // this.getDateOfPurchase(data.text)
                    this.setState({
                        invoiceNumber: invoiceNumber,
                        dateOfPurchase: dateOfPurchase,
                        storeLocation: storeLocation,
                        totalCost: totalCost
                    })
                }
            }
        }
    };

    getInvoiceNumber = (receipt) => {
        receipt = receipt.replace(/\n/g, ' ');
        // Define the pattern to match number values before "Chk"
        const regex = /(\d+)(?=\s*(Chk|OpenTine))/g;
    
        // Use the regular expression to extract all number values
        const matches = receipt.match(regex);
    
        // Extracted number values will be in the matches array
        const extractedValues = matches ? matches.map(Number) : [];
        console.log(extractedValues);
        return extractedValues;
    }
    
    getDateOfPurchase = (receipt) => {
        receipt = receipt.replace(/\n/g, ' ');
        // Define the pattern to match the values between "Chk OpenTine" and "Table"
        const regex = /Chk Open(Tine|Time): (.+?)(?: Table:|\b)/;
    
        // Use the regular expression to extract the values
        const match = receipt.match(regex);
    
        // Extracted values will be in match[2] (if there is a match)
        const dateTimeValues = match ? match[2] : null;
        // console.log(dateTimeValues)
        // Check if the time value needs correction
        if (dateTimeValues) {
            // Remove any letters from the time values
            console.log(dateTimeValues)
            const timeValuesWithoutLetters = dateTimeValues.replace(/[A-Za-z]/g, '');
            // Extract the substring after the first space
            const timeSubstring = timeValuesWithoutLetters.split(' ')[1];
            // console.log(`TIME SUBSTRING: ${timeSubstring}`)
            // Check if the third last character is a colon
            if (timeSubstring) {
                const correctedTime = timeSubstring.slice(0, 5);
                const correctedDateTimeValues = timeValuesWithoutLetters.replace(timeSubstring, correctedTime);
                return correctedDateTimeValues;
            }
        } else {
            console.log('No match found');
        }
    }

    getOrderDetails = (receipt) => {
        const inputString = "AMOUNT Kenyan Tea 1 270.00 270400 Almond Milk 1 150.00 150400 Extra Caramel Syrup 1 110.00 110400 Whole Wheat Bread 1 250.00 250400 Whole Uheat Oats Bread 1 260.00 2000 Total 1,040.00 Payment";
        receipt = receipt.replace(/\n/g, ' ');
                // Define the pattern to match the substring between "AMOUNT" or "ANOUNT" and "Payment" or "payment"
        const regex = /AMOUNT (.*?) Payment|payment/gi;

        // Use the regular expression to extract the substring
        const match = regex.exec(receipt);

        // Extracted substring will be in match[1] (if there is a match)
        const extractedSubstring = match ? match[1] : null;

        console.log(extractedSubstring);
    }

    getTotalCostOfOrder = (receipt) => {
        receipt = receipt.replace(/\n/g, ' ');
        // Define the pattern to match the substring between "al ow" and ". Paynent"
        const regex = /al ow (.+?)\. Paynent/;

        // Use the regular expression to extract the substring
        const match = receipt.match(regex);

        // Extracted substring will be in match[1] (if there is a match)
        const extractedSubstring = match ? match[1] : null;
        console.log(extractedSubstring)
        return extractedSubstring
    }

    tPendingApprovalBtnClicked = () => {
        this.setState({
            pendingApprovalBtnBgColor: "#0930cb",
            pendingApprovalBtnTxtColor: "white",
            approvedBtnBgColor: "white",
            approvedBtnTxtColor: "#0930cb"
        })
    }

    tApprovedBtnClicked = () => {
        this.setState({
            approvedBtnBgColor: "#0930cb",
            approvedBtnTxtColor: "white",
            pendingApprovalBtnBgColor: "white",
            pendingApprovalBtnTxtColor: "#0930cb"
        })
    }

    renderNonVerifiedReceipts = () => {
        if (this.state.nonVerifiedReceipts.length !== 0) {
            return (this.state.nonVerifiedReceipts.map(receipts => {
                var {backgroundColor, cardNumber, dateOfPurchase, earningPolicy, earningPolicyEndDate, earningPolicyMoneyValue, earningPolicyPercentageChange, 
                    earningPolicyPointsValue, email, invoiceNumber, location, name, receiptID, receiptImg, uploadTime, userID} = receipts

                        //* - - CONVERT LOCATION STRING (FOR DATABASE USE) - - *//

                    let locationDatabase = location.toLowerCase().replace(/\s/g, '_');

                        //* - - TIME UPLOADED - - *//
                    let timeUploaded
                    // Convert the string to an array of characters
                    let charArray = uploadTime.split('');
                    // Iterate through the array from the last character to the first
                    for (let i = charArray.length - 1; i >= 0; i--) {
                        // Replace the first '-' with a colon
                        if (charArray[i] === '-') {
                            charArray[i] = ':';
                            break; // Stop iterating after the first '-' is replaced
                        }
                    }
                    // Convert the array back to a string
                    timeUploaded = charArray.join('');

                        //* - - RECEIPT BACKGROUND COLOR - - //
                    let bgColor = backgroundColor

                    return (
                        <div onClick={() => this.clickedReceiptCell(backgroundColor, receiptID, userID, locationDatabase, location, receiptImg, dateOfPurchase, invoiceNumber, cardNumber, name, earningPolicy, earningPolicyEndDate, earningPolicyMoneyValue, earningPolicyPercentageChange, earningPolicyPointsValue, email)} style={{backgroundColor: `${bgColor}`}} className='vReceiptList'>
                            <h5><span style={{color: "#0930cb", marginRight: "1.5%"}}>Name:</span>{name}</h5>
                            <h5><span style={{color: "#0930cb", marginRight: "1.5%"}}>Card No.</span>{cardNumber}</h5>
                            <label>Pending approval</label>
                            <p>{timeUploaded}</p>
                        </div>
                    )
            }))
        }
    }

    checkIfOrderCountZero = (receiptDatabaseID, location, orderCount) => {
        class Order {
            constructor (category, item, qty, total) {
                this.category = category
                this.item = item
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.category + ', ' +
                this.item + ', ' +
                this.qty + ', ' + 
                this.total
            }
        }
        var orderConverter = {
            toFirestore : function(order) {
                return {
                    category: order.category,
                    item: order.item,
                    qty: order.qty,
                    total: order.total
                }
            },
            fromFirestore: function(snapshot, options) {
                const data = snapshot.data(options)
                return new Order(data.category, data.item, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection(location)
        .doc("nonVerified")
        .collection("orderList")
        .doc(receiptDatabaseID)
        .collection("list")
        .withConverter(orderConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            // Extract numeric values from each "item" property and calculate the total
            const totalCost = data.reduce((total, order) => {
                // Extract numeric value from the "item" property using a regular expression
                const match = order.item.match(/\(KES (\d+)/);
                const itemCost = match ? parseInt(match[1]) * parseInt(order.qty) : 0;
            
                // Add the numeric value to the total
                return total + itemCost;
            }, 0);
            const totalQty = data.reduce((acc, obj) => {
                // Convert 'qty' from string to integer using parseInt
                // const qtyAsInt = parseInt(, 10);
              
                // Add the integer 'qty' to the accumulator
                return acc + obj.qty;
              }, 0);
            if (data.length > 0) {
                this.setState({
                    showOrderInputFields: false,
                    showOrderStatus: false,
                    showOrderAddedConfirmation: false,
                    showReceiptTotalCost: false,
                    showOrderAlertMessage: "",
                    showCompleteAddOrderButton: false,
                    showMenuOrdersLoading: true,
                }, () => {
                    setTimeout(() => {
                        if (this.state.earningPolicy !== "") {
                            this.setState({
                                showEarningPolicy : true
                            })
                        }
                        this.setState({
                            showReceiptDashboard: true,
                            showTransactionDetails: true,
                            showApproveRecjetionBtns: true,
                            showMenuOrdersLoading: false,
                            showAddOrderBtn: true,
                            showReceiptTotalCost: true,
                            showReceiptOrders: true,
                            showClearMenuOrdersBtn: true,
                            menuOrders: data,
                            totalCost: totalCost,
                            totalQty: totalQty,
                        })
                    }, 2000)
                })
            } else {
                this.setState({
                    showOrderInputFields: false,
                    showOrderStatus: false,
                    showOrderAddedConfirmation: false,
                    showOrderAlertMessage: "",
                    showCompleteAddOrderButton: false,
                    showReceiptTotalCost: false,
                    showMenuOrdersLoading: true,
                }, () => {
                    setTimeout(() => {
                        if (this.state.earningPolicy !== "") {
                            this.setState({
                                showEarningPolicy: true,
                            })
                        }
                        this.setState({
                            showReceiptDashboard: true,
                            showTransactionDetails: true,
                            showApproveRecjetionBtns: true,
                            showMenuOrdersLoading: false,
                            showAddOrderBtn: true,
                            showReceiptTotalCost: true,
                            showReceiptOrders: false,
                            showClearMenuOrdersBtn: false,
                            totalCost: 0
                        })
                    }, 2000)
                })
            }
        })
    }

    clickedReceiptCell = (bgColor, receiptID, userID, locationDB, location, receiptImg, dateOfPurchase, invoiceNumber, cardNumber, name, earningPolicy, EPEndDate, EPMoneyValue, EPPercentage, EPPointsValue, email) => {
        console.log(dateOfPurchase)
        this.setState({
            menuOrders: [],
            showReceiptOrders: false,
            showClearMenuOrdersBtn: false,
            showRejectionConfirmBtns: false,
            showApproveConfirmBtns: false,
            showApproveRecjetionBtns: true,
            showRejectionCustomerMsg: false,
            rejectionCustomerMessage: ""
        })
        let receiptDatabaseID = `${receiptID}-${userID}`
        this.checkIfOrderCountZero(receiptDatabaseID, locationDB)
        if (EPEndDate !== "") {
            this.setState({
                showEarningPolicy: true
            })
        }
        this.setState({
            currentReceiptID: receiptDatabaseID,
            currentLocation: locationDB,
            userReceiptID: receiptID,
            userReceiptImg: receiptImg,
            userLocation: location,
            userInvoiceNo: invoiceNumber,
            userCardNumber: cardNumber,
            userName: name,
            userEmail: email,
            userID: userID,
            earningPolicy: earningPolicy,
            earningPolicyEndDate: EPEndDate,
            earningPolicyMoneyValue: parseInt(EPMoneyValue),
            earningPolicyPercentageChange: EPPercentage,
            earningPolicyPointsValue: parseInt(EPPointsValue)
        })
        this.hideAllOrderOptions()
        this.updateClickedReceiptCellUI(receiptDatabaseID, locationDB)
        this.loadClickedReceiptCellInformation(receiptDatabaseID, locationDB, location, receiptImg, dateOfPurchase, invoiceNumber, userID)
    }

    loadClickedReceiptCellInformation = (receiptDatabaseID, locationDB, location, receiptImg, dateOfPurchase, invoiceNumber, userID) => {
        let purchaseDate 
        if (dateOfPurchase != null || dateOfPurchase != "") {
            purchaseDate = dateOfPurchase
        }
        this.setState({
            showOrderStatus: false,
            showReceiptDashboardPlaceholder: false,
            showReceiptDashboard: false,
            showReceiptDashboardLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showReceiptDashboardLoading: false,
                showReceiptDashboard: true,
                showAddOrderBtn: true,
                userID: userID,
                clickedReceiptImg: receiptImg,
                invoiceNumber: invoiceNumber,
                dateOfPurchase: purchaseDate,
                storeLocation: location
               })
            }, 3000)
        })
    }

    checkForClickedReceiptCellChange = () => {
        const receiptRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        receiptRef.onSnapshot((snapshot) => {
            const updatedReceipts = this.state.nonVerifiedReceipts.map(receipt => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === receipt.id);
                if (snapshotPolicy) {
                    return {
                        ...receipt,
                        backgroundColor: snapshotPolicy.data().backgroundColor
                    }
                }
                return receipt
            })
            this.setState({
                nonVerifiedReceipts: updatedReceipts
            })
        })
    }

    checkForClickedPointsCellChange = () => {
        const rewardRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        rewardRef.onSnapshot((snapshot) => {
            const updatedRewards = this.state.redeemedPoints.map(user => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === user.id);
                if (snapshotPolicy) {
                    return {
                        ...user,
                        bgColor: snapshotPolicy.data().bgColor
                    }
                }
                return user
            })
            this.setState({
                redeemedPoints: updatedRewards
            })
        })
    }

    checkForClickedReceiptOrderCountChange = () => {
        const receiptRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        receiptRef.onSnapshot((snapshot) => {
            const updatedReceipts = this.state.nonVerifiedReceipts.map(receipt => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === receipt.id);
                if (snapshotPolicy) {
                    return {
                        ...receipt,
                        orderCount: snapshotPolicy.data().orderCount
                    }
                }
                return receipt
            })
            this.setState({
                nonVerifiedReceipts: updatedReceipts
            })
        })
    }

    updateClickedReceiptCellUI = (receiptDatabaseID, locationDB) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection(locationDB)
        .doc("nonVerified")
        .collection("list")
        .doc(receiptDatabaseID)
        .update({
            backgroundColor: "#E7ECFE"
        })
        if (this.state.prevClicked !== "" && this.state.prevClicked !== receiptDatabaseID) {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("transactions")
            .doc("locations")
            .collection(locationDB)
            .doc("nonVerified")
            .collection("list")
            .doc(this.state.prevClicked)
            .update({
                backgroundColor: "white"
            })

            // prevClickedRef.get().then(doc => {
            //     if (doc.exists) {
                    
            //     }
            // })
        }
        if (this.state.prevClicked !== receiptDatabaseID || this.state.prevClicked == "") {
            //! - - SAVE CURRENT CLICKED RECEIPT DATABASE ID TO DATABASE - SO WE KNOW WHERE LEFT OF - - !//
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("transactions")
            .doc("locations")
            .collection(locationDB)
            .doc("nonVerified")
            .set({
                lastClicked: receiptDatabaseID
            })
            .then(() => {
            
                this.loadNonVerifiedReceipts()
            })
            this.setState({
                prevClicked: receiptDatabaseID
            })
        }
        
    }

    addReceiptOrderClicked = () => {
        this.loadOrderCount(this.state.currentReceiptID)
        this.loadMenuItems()
        this.setState({
            showRejectionConfirmBtns: false,
            showApproveConfirmBtns: false,
            showApproveRecjetionBtns: false,
            showAddOrderBtn: false,
            showClearMenuOrdersBtn: false,
            showReceiptOrders: false,
            showEarningPolicy: false,
            showMenuOrdersLoading: true,
            showReceiptTotalCost: false,
        }, () => {
            setTimeout(() => {
               this.setState({
                showMenuOrdersLoading: false,
                showOrderStatus: true,
                showOrderInputFields: true,
                showRewardsCategories: true,
               })
            }, 2000)
        })
    }

    loadOrderCount = (receiptDatabseID) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection(this.state.currentLocation)
        .doc("nonVerified")
        .collection("orderList")
        .doc(`${receiptDatabseID}`)
        .get().then(doc => {
            this.setState({
                currentOrderCount: doc.data().orderCount
            })
        })
    }

    loadMenuItems = () => {
        class Menu {
            constructor(label, value) {
                this.label = label
                this.value = value
            }
            toString() {
                return this.label + ', ' +
                this.value
            }
        }
        var menuConverter = {
            toFirestore : function(menu) {
                return {
                    label: menu.label,
                    value: menu.value
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Menu(data.label, data.value)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("menu")
        .doc("categories")
        .collection("list")
        .withConverter(menuConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                menuCategories: data
            })
        })
    }

    handleMenuCategoryClicked = (selectedOptions) => {
        
        var coffee_and_tea = "coffee_and_tea"
        var iced_coffee_and_tea = "iced_coffee_and_tea"
        var breakfast = "breakfast"
        var starters_and_sharing = "starters_and_sharing"
        var lunch_and_dinner = "lunch_and_dinner"
        var burgers = "burgers"
        var chips = "chips"
        var wings = "wings"
        var sandwiches = "sandwiches"
        var salads = "salads"
        var art_pizzas = "art_pizzas"
        var pasta = "pasta"
        var bakery = "bakery"
        var cakes_and_desserts = "cakes_and_desserts"
        var cold_press_juices = "cold_press_juices"
        var soft_drinks = "soft_drinks"
        var kids_menu = "kids_menu"
        var whole_cakes = "whole_cakes"
        var power_smoothies = "power_smoothies"
        var steaks = "steaks"
        var soup = "soup"
        var mocktails = "mocktails"
        var hot_n_boozy = "hot_n_boozy"
        var beer = "beer"
        var white_wine = "white_wine"
        var sangria = "sangria"
        var red_wine = "red_wine"
        var sparkling = "sparkling"
        var rose = "rose"
        var art_cocktails = "art_cocktails"
        var cocktails = "cocktails"
        var spirits_and_liquer = "spirits_and_liquer"
        var milkshakes = "milkshakes"
        var quiches = "quiches"

        this.setState({
            mealOrderItem: "",
            mealOrderQuantity: "",
            showOrderAddedConfirmation: false
        })

        if (selectedOptions.value == coffee_and_tea) {
            this.getSelectedMenuCategory(coffee_and_tea)
            this.setState({
                rewardMenuCategory: coffee_and_tea,
                showCoffeeAndTea: true,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == iced_coffee_and_tea) {
            this.getSelectedMenuCategory(iced_coffee_and_tea)
            this.setState({
                rewardMenuCategory: iced_coffee_and_tea,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: true,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == breakfast) {
            this.getSelectedMenuCategory(breakfast)
            this.setState({
                rewardMenuCategory: breakfast,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: true,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == starters_and_sharing) {
            this.getSelectedMenuCategory(starters_and_sharing)
            this.setState({
                rewardMenuCategory: starters_and_sharing,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: true,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == lunch_and_dinner) {
            this.getSelectedMenuCategory(lunch_and_dinner)
            this.setState({
                rewardMenuCategory: lunch_and_dinner,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: true,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == burgers) {
            this.getSelectedMenuCategory(burgers)
            this.setState({
                rewardMenuCategory: burgers,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: true,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == chips) {
            this.getSelectedMenuCategory(chips)
            this.setState({
                rewardMenuCategory: chips,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: true,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == wings) {
            this.getSelectedMenuCategory(wings)
            this.setState({
                rewardMenuCategory: wings,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: true,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == sandwiches) {
            this.getSelectedMenuCategory(sandwiches)
            this.setState({
                rewardMenuCategory: sandwiches,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: true,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == salads) {
            this.getSelectedMenuCategory(salads)
            this.setState({
                rewardMenuCategory: salads,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: true,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == art_pizzas) {
            this.getSelectedMenuCategory(art_pizzas)
            this.setState({
                rewardMenuCategory: art_pizzas,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: true,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == pasta) {
            this.getSelectedMenuCategory(pasta)
            this.setState({
                rewardMenuCategory: pasta,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: true,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == bakery) {
            this.getSelectedMenuCategory(bakery)
            this.setState({
                rewardMenuCategory: bakery,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: true,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == cakes_and_desserts) {
            this.getSelectedMenuCategory(cakes_and_desserts)
            this.setState({
                rewardMenuCategory: cakes_and_desserts,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: true,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == cold_press_juices) {
            this.getSelectedMenuCategory(cold_press_juices)
            this.setState({
                rewardMenuCategory: cold_press_juices,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: true,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == soft_drinks) {
            this.getSelectedMenuCategory(soft_drinks)
            this.setState({
                rewardMenuCategory: soft_drinks,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: true,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == kids_menu) {
            this.getSelectedMenuCategory(kids_menu)
            this.setState({
                rewardMenuCategory: kids_menu,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: true,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == whole_cakes) {
            this.getSelectedMenuCategory(whole_cakes)
            this.setState({
                rewardMenuCategory: whole_cakes,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: true,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == power_smoothies) {
            this.getSelectedMenuCategory(power_smoothies)
            this.setState({
                rewardMenuCategory: power_smoothies,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: true,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == steaks) {
            this.getSelectedMenuCategory(steaks)
            this.setState({
                rewardMenuCategory: steaks,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: true,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == soup) {
            this.getSelectedMenuCategory(soup)
            this.setState({
                rewardMenuCategory: soup,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: true,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == mocktails) {
            this.getSelectedMenuCategory(mocktails)
            this.setState({
                rewardMenuCategory: mocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: true,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == hot_n_boozy) {
            this.getSelectedMenuCategory(hot_n_boozy)
            this.setState({
                rewardMenuCategory: hot_n_boozy,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: true,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == beer) {
            this.getSelectedMenuCategory(beer)
            this.setState({
                rewardMenuCategory: beer,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: true,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == white_wine) {
            this.getSelectedMenuCategory(white_wine)
            this.setState({
                rewardMenuCategory: white_wine,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: true,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == sangria) {
            this.getSelectedMenuCategory(sangria)
            this.setState({
                rewardMenuCategory: sangria,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: true,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == red_wine) {
            this.getSelectedMenuCategory(red_wine)
            this.setState({
                rewardMenuCategory: red_wine,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: true,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategory: sparkling,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: true,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategory: sparkling,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: true,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == rose) {
            this.getSelectedMenuCategory(rose)
            this.setState({
                rewardMenuCategory: rose,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: true,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == art_cocktails) {
            this.getSelectedMenuCategory(art_cocktails)
            this.setState({
                rewardMenuCategory: art_cocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: true,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == cocktails) {
            this.getSelectedMenuCategory(cocktails)
            this.setState({
                rewardMenuCategory: cocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: true,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == spirits_and_liquer) {
            this.getSelectedMenuCategory(spirits_and_liquer)
            this.setState({
                rewardMenuCategory: spirits_and_liquer,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: true,
                showMilkshakes: false,
                showQuiches: false
            })
        } else if (selectedOptions.value == milkshakes) {
            this.getSelectedMenuCategory(milkshakes)
            this.setState({
                rewardMenuCategory: milkshakes,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: true,
                showQuiches: false
            })
        } else if (selectedOptions.value == quiches) {
            this.getSelectedMenuCategory(quiches)
            this.setState({
                rewardMenuCategory: quiches,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: true
            })
        }
    }

    getSelectedMenuCategory = (category) => {
        class Menu {
            constructor(label, value) {
                this.label = label
                this.value = value
            }
            toString() {
                return this.label + ', ' +
                this.value
            }
        }
        var menuConverter = {
            toFirestore : function(menu) {
                return {
                    label: menu.label,
                    value: menu.value
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Menu(data.label, data.value)
            }
        }
        fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("menu")
            .doc("list")
            .collection(category)
            .withConverter(menuConverter)
            .get().then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data())
                this.setState({
                    selectedMenuCategory: data
                })
            })
    }

    rewardMenuItemSelected = (selectedOption) => {
        console.log(selectedOption.label)
        this.setState({
            mealOrderItem: selectedOption.label
        })
    }

    selectedMenuItemQuantity = (selectedOption) => {
        console.log(selectedOption.label)
        this.setState({
            mealOrderQuantity: selectedOption.value,
            showCompleteAddOrderButton: true
        })
    }

    hideAllOrderOptions = () => {
        this.setState({
            rewardMenuCategory: "",
            mealOrderItem: "",
            mealOrderQuantity: "",
            showRewardsCategories: false,
            showWings: false,
            showWholeCakes: false,
            showStartersAndSharing: false,
            showSoftDrinks: false,
            showSandwiches: false,
            showSalads: false,
            showPasta: false,
            showLunchAndDinner: false,
            showKidsMenu: false,
            showIcedCoffeeAndTea: false,
            showColdPressJuices: false,
            showCoffeeAndTea: false,
            showChips: false,
            showCakesAndDesserts: false,
            showBurgers: false,
            showBreakfast: false,
            showBakery: false,
            showArtPizzas: false,
            showPowerSmoothies: false,
            showSteaks: false,
            showSoup: false,
            showMocktails: false,
            showHotNBoozy: false,
            showBeer: false,
            showWhiteWine: false,
            showSangria: false,
            showRedWine: false,
            showSparkling: false,
            showRose: false,
            showArtCocktails: false,
            showCocktails: false,
            showSpiritsAndLiquer: false,
            showMilkshakes: false,
            showQuiches: false,
        })
    }

    hideAllOrderOptionsKeepVariables = () => {
        this.setState({
            showRewardsCategories: false,
            showWings: false,
            showWholeCakes: false,
            showStartersAndSharing: false,
            showSoftDrinks: false,
            showSandwiches: false,
            showSalads: false,
            showPasta: false,
            showLunchAndDinner: false,
            showKidsMenu: false,
            showIcedCoffeeAndTea: false,
            showColdPressJuices: false,
            showCoffeeAndTea: false,
            showChips: false,
            showCakesAndDesserts: false,
            showBurgers: false,
            showBreakfast: false,
            showBakery: false,
            showArtPizzas: false,
            showPowerSmoothies: false,
            showSteaks: false,
            showSoup: false,
            showMocktails: false,
            showHotNBoozy: false,
            showBeer: false,
            showWhiteWine: false,
            showSangria: false,
            showRedWine: false,
            showSparkling: false,
            showRose: false,
            showArtCocktails: false,
            showCocktails: false,
            showSpiritsAndLiquer: false,
            showMilkshakes: false,
            showQuiches: false
        })
    }

    completeAddOrderClicked = async () => {
        this.hideAllOrderOptionsKeepVariables()
        this.setState({
            showCompleteAddOrderButton: false,
            showCompleteAddOrderButtonLoading: true
        })
        let orderExists = true
        if (this.state.mealOrderItem != "" && this.state.mealOrderQuantity != "" && this.state.rewardMenuItemSelected != "") {
             orderExists = await this.checkIfOrderExists()
        } else {
            this.hideAllOrderOptions()
            console.log("FIRST ORDER INFORMATION ERROR MSG")
            this.setState({
                showOrderAddedConfirmation: true,
                showOrderAlertMessage: "Please enter all order information",
                showCompleteAddOrderButtonLoading: false,
                showCompleteAddOrderButton: true,
                showRewardsCategories: true
            })
        }
        
        
        if (!orderExists) {
            if (this.state.mealOrderItem != "" && this.state.mealOrderQuantity != "" && this.state.rewardMenuItemSelected !="") {
                await this.addToOrderList()
            } else {
                console.log("SECOND ORDER INFORMATION ERROR MSG")
                this.setState({
                    showOrderAddedConfirmation: true,
                    showOrderAlertMessage: "Please enter all order information",
                    showCompleteAddOrderButtonLoading: false,
                    showCompleteAddOrderButton: true,
                    showRewardsCategories: true
                })
            }
        } else {
            if (this.state.mealOrderItem != "" || this.state.mealOrderQuantity != "" || this.state.rewardMenuItemSelected !="") {
                console.log("THIRD ORDER INFORMATION ERROR MSG")
                this.setState({
                    showOrderAddedConfirmation: true,
                    showOrderAlertMessage: "Order already exists.",
                    showCompleteAddOrderButtonLoading: false,
                    showCompleteAddOrderButton: true,
                    showRewardsCategories: true
                })
            } else {
                // this.hideAllOrderOptions()
                this.setState({
                    showRewardsCategories: true,
                    showCompleteAddOrderButtonLoading: false,
                    showCompleteAddOrderButton: true,
                    showOrderAddedConfirmation: true,
                    showOrderAlertMessage: "Please enter all order information"
                })
            }
            
        }
        
    }

    addToOrderList = async () => {
        // Add your Firestore update logic here
        let mealTotal = this.state.mealOrderItem.split('(KES')
        let mealPrice = parseInt(mealTotal[1].slice(0, -1))
        // console.log(mealTotal[1])
        try {
            await fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("transactions")
                .doc("locations")
                .collection(this.state.currentLocation)
                .doc("nonVerified")
                .collection("orderList")
                .doc(this.state.currentReceiptID)
                .collection("list")
                .doc(this.state.mealOrderItem)
                .set({
                    item: this.state.mealOrderItem,
                    qty: parseInt(this.state.mealOrderQuantity),
                    category: this.state.rewardMenuCategory,
                    total: mealPrice
                });
    
            await fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("transactions")
                .doc("locations")
                .collection(this.state.currentLocation)
                .doc("nonVerified")
                .collection("orderList")
                .doc(this.state.currentReceiptID)
                .update({
                    orderCount: this.state.currentOrderCount + 1,
                });
            this.setState({
                rewardMenuCategory: "",
                showRewardsCategories: true,
                showCompleteAddOrderButtonLoading: false,
                showCompleteAddOrderButton: true,
                showOrderAddedConfirmation: true,
                showOrderAlertMessage: `✅ ORDER ADDED: ${this.state.mealOrderQuantity}x ${this.state.mealOrderItem}`
            });
    
            this.loadOrderCount(this.state.currentReceiptID);
        } catch (error) {
            console.error("Error in addToOrderList:", error);
            // Handle the error appropriately
        }
    };

    checkIfOrderExists = () => {
        return new Promise((resolve, reject) => {
            fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("transactions")
                .doc("locations")
                .collection(this.state.currentLocation)
                .doc("nonVerified")
                .collection("orderList")
                .doc(this.state.currentReceiptID)
                .collection("list")
                .doc(this.state.mealOrderItem)
                .get()
                .then(doc => {
                    resolve(doc.exists);
                })
                .catch(error => {
                    console.error("Error in checkIfOrderExists:", error);
                    reject(error);
                });
        });
    }

    closeOrderNotification = () => {
        this.setState({
            showOrderAddedConfirmation: false,
            showOrderAlertMessage: ""
        })
    }

    closeOrderWindow = () => {
        this.hideAllOrderOptions()
        this.checkIfOrderCountZero(this.state.currentReceiptID, this.state.currentLocation, this.state.currentOrderCount)
    }

    renderReceiptOrders = () => {
        if (this.state.menuOrders.length != 0) {
            return (this.state.menuOrders.map(orders => {
                var {category, item, qty} = orders
                return (
                    <div className='menuOrderContainer'>
                        <div className='menuOrderQty'>
                            <label>{qty}x</label>
                        </div>
                        <div className='menuOrderItem'>
                            <label>{item}</label>
                        </div>
                    </div>
                )
            }))
        }
    }

    clearMenuOrders = () => {
        this.deleteOrdersDatabaseData()
        this.setState({
            showAddOrderBtn: false,
            showClearMenuOrdersBtn: false,
            showReceiptOrders: false,
            showReceiptTotalCost: false,
            showMenuOrdersLoading: true,
        }, () => {
            setTimeout(() => {
               this.setState({
                showMenuOrdersLoading: false,
                showAddOrderBtn: true,
                showClearMenuOrdersBtn: false,
                showReceiptOrders: false,
                showReceiptTotalCost: true,
                totalCost: 0
               })
            }, 2000)
        })
    }

    deleteOrdersDatabaseData = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection(this.state.currentLocation)
        .doc("nonVerified")
        .collection("orderList")
        .doc(this.state.currentReceiptID)
        .update({
            orderCount: 0
        })
        .then(() => {
            const collectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("transactions")
            .doc("locations")
            .collection(this.state.currentLocation)
            .doc("nonVerified")
            .collection("orderList")
            .doc(this.state.currentReceiptID)
            .collection("list")
    
            collectionRef.get().then((querySnapshot) => {
                // Loop through the documents in the collection
                querySnapshot.forEach((doc) => {
                    // Delete each document
                    doc.ref.delete();
                });
                
            }).catch((error) => {
                console.error("Error deleting collection:", error);
            });
        })
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    rejectOrderClicked = () => {
        this.handleScrollToRejectionMsg()
        this.setState({
            showApproveRecjetionBtns: false,
            showRejectionCustomerMsg: true,
            showRejectionConfirmBtns: true
        })
    }

    approveOrderClicked = () => {
        this.setState({
            showApproveRecjetionBtns: false,
            showApproveConfirmBtns: true
        })
    }

    rejectionReason1Clicked = () => {
        this.setState({
            rejectionCustomerMessage: "The image submitted was not clear. Please re-submit a receipt photo."
        })
    }

    rejectionReason2Clicked = () => {
        this.setState({
            rejectionCustomerMessage: "The image submitted did not include all required info. Your image must include all details from the TOP of the receipt until the cumulative 'Total'."
        })
    }

    rejectionReason3Clicked = () => {
        this.setState({
            rejectionCustomerMessage: "This restaurant branch is not registered for rewards yet."
        })
    }

    handleScrollToRejectionMsg = () => {
        setTimeout(() => {
            const element = document.getElementById('rejectionCustomerMsgScroll');
            if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 500)
    }

    cancelRejectRequest = () => {
        this.setState({
            showRejectionCustomerMsg: false,
            showRejectionConfirmBtns: false,
            showApproveRecjetionBtns: true,
            rejectionCustomerMessage: ""
        })
    }

    cancelApproveRequest = () => {
        this.setState({
            showApproveConfirmBtns: false,
            showApproveRecjetionBtns: true
        })
    }

    formatDate2 = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
    
        // Get the time (HH:MM)
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const returnTime = `${hours}:${minutes}:${seconds}`;
    
        return `${month}-${day}-${year} ${returnTime}`;
    };

    rejectConfirmClicked = async () => {
        const notificationRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
    
        await notificationRef.get().then(async doc => {
            if (doc.exists) {
                if (doc.data().pointsNotificationCount === 0) {
                    await notificationRef.set({
                        pointsNotificationCount: 1
                    })
                    await fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("notifications")
                    .collection("points")
                    .doc(`notification-${1}`)
                    .set({
                        msg: `Your receipt was not approved. ${this.state.rejectionCustomerMessage}`,
                        date: this.formatDate2(new Date()).slice(0, -3)
                    })
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("purchaseHistory")
                    .collection("nonVerified")
                    .doc(this.state.userReceiptID)
                    .update({
                        adminMsg: `Your receipt was not approved. ${this.state.rejectionCustomerMessage}`
                    })
                } else {
                    const currentNotificationCount = doc.data().pointsNotificationCount
                    const updatedNotificationCount = currentNotificationCount + 1
                    await notificationRef.update({
                        pointsNotificationCount: updatedNotificationCount
                    })
                    await fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("notifications")
                    .collection("points")
                    .doc(`notification-${updatedNotificationCount}`)
                    .set({
                        msg: `Your receipt was not approved. ${this.state.rejectionCustomerMessage}`,
                        date: this.formatDate2(new Date()).slice(0, -3)
                    })
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("purchaseHistory")
                    .collection("nonVerified")
                    .doc(this.state.userReceiptID)
                    .update({
                        adminMsg: `Your receipt was not approved. ${this.state.rejectionCustomerMessage}`
                    })
                }
            }
        })
        this.deleteNonVerifiedReceipt2()
        this.setState({
            showTransactionDetails: false,
            showTransactionDetailsLoading: false,
            approvalLoadingMsg: "deleting",
            showReceiptDashboard: false,
            showReceiptDashboardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showReceiptDashboardLoading: false,
                    showReceiptDashboardPlaceholder: true
                });
            }, 2000);
        });
    }

    deleteNonVerifiedReceipt2 = async () =>{
        let nonVerifiedID = `${this.state.userReceiptID}-${this.state.userID}`

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .update({
            lastClicked: ""
        })
        
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(nonVerifiedID)
        .delete()
        .then(() => {
            this.loadNonVerifiedReceipts()
        })
    }

    deleteNonVerifiedReceipt = async () => {
        let nonVerifiedID = `${this.state.userReceiptID}-${this.state.userID}`

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .update({
            lastClicked: ""
        })
        
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(nonVerifiedID)
        .delete()

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("orderList")
        .doc(nonVerifiedID)

        const collectionRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("orderList")
        .doc(nonVerifiedID)
        .collection("list")

       await collectionRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                doc.ref.delete().then(() => {
                    console.log('Document successfully deleted!');
                }).catch((error) => {
                    console.error('Error removing document: ', error);
                });
            });
        })
        
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("orderList")
        .doc(nonVerifiedID)
        .delete()
        .then(() => {
            this.loadNonVerifiedReceipts()
        })
    }

    approveConfirmClicked = async () => {
        let doesReceiptExist = await this.checkIfReceiptExists()
        if (doesReceiptExist === "false") {
            await this.pushDataToAdmin()
            await this.checkIfEarningPoliciesApply()
            // await this.addReceiptToAdminDatabase(); ✅ ⭐️ //* REPLACED *// 
            await this.pushDataToTransactions() 
            // await this.compareOrderDataToEarningPolicies(); ✅ ⭐️ //* REPLACED *// 
            this.pushReceiptApprovedNotification() 
            
        } else {
            alert("Receipt already exists in system")
        }
    }

    pushReceiptApprovedNotification = async () => {
        const notificationRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("notifications")
    
        await notificationRef.get().then(async doc => {
            if (doc.exists) {
                if (doc.data().pointsNotificationCount === 0) {
                    await notificationRef.set({
                        pointsNotificationCount: 1
                    })
                    await fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("notifications")
                    .collection("points")
                    .doc(`notification-${1}`)
                    .set({
                        msg: `Your receipt for your order made on ${this.state.dateOfPurchase} has been approved.`,
                        date: this.formatDate2(new Date()).slice(0, -3)
                    })
                } else {
                    const currentNotificationCount = doc.data().pointsNotificationCount
                    const updatedNotificationCount = currentNotificationCount + 1
                    await notificationRef.update({
                        pointsNotificationCount: updatedNotificationCount
                    })
                    await fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection("list")
                    .doc(this.state.userID)
                    .collection("data")
                    .doc("notifications")
                    .collection("points")
                    .doc(`notification-${updatedNotificationCount}`)
                    .set({
                        msg: `Your receipt for your order made on ${this.state.dateOfPurchase} has been approved.`,
                        date: this.formatDate2(new Date()).slice(0, -3)
                    })
                }
            }
        })
    }

    checkIfReceiptExists = async () => {
            //* - - ORDER DATE - - *//
        let doesReceiptExist = ""
        const orderDate = this.state.dateOfPurchase.split(' ')[0];
        const timeOfOrder = this.state.dateOfPurchase.split(' ')[1];
        const timeComponents = timeOfOrder.split(':');
        const dateComponents = orderDate.split('/');
        const invoiceID = `invoice-${this.state.invoiceNumber}-${dateComponents[0]}-${dateComponents[1]}-${dateComponents[2]}-${timeComponents[0]}-${timeComponents[1]}`

        const invoiceRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("verified")
        .collection("list")
        .doc(invoiceID)

        const doc = await invoiceRef.get()
            if (doc.exists) {
                // alert("Receipt already in system")
                doesReceiptExist = "true"
            } else {
                doesReceiptExist = "false"
                await this.addToVerifiedReceipts(invoiceID)
            }
        return doesReceiptExist
    }

    addToVerifiedReceipts = async (invoiceID) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("transactions")
        .doc("locations")
        .collection("the_hub")
        .doc("verified")
        .collection("list")
        .doc(invoiceID)
        .set({
            backgroundColor: "white",
            cardNumber: this.state.userCardNumber,
            dateOfPurchase: this.state.dateOfPurchase,
            invoiceID: invoiceID,
            invoiceNumber: this.state.invoiceNumber,
            location: this.state.userLocation,
            name: this.state.userName,
            receiptImg: this.state.userReceiptImg,
            userID: this.state.userID
        })
        .then(() => {
            this.setState({
                showTransactionDetails: false,
                showTransactionDetailsLoading: true,
                approvalLoadingMsg: "saving receipt information",
                userInvoiceID: invoiceID
            })
        })

    }

    addReceiptToAdminDatabase = async () => {
        await this.thisDaySaveInfo()
        await this.thisWeekSaveInfo()
        await this.thisMonthSaveInfo()
        await this.month1SaveInfo()
        await this.month2SaveInfo()
        await this.month3SaveInfo()
        await this.month4SaveInfo()
        await this.month5SaveInfo()
        await this.month6SaveInfo()
        await this.month7SaveInfo()
        await this.month8SaveInfo()
        await this.month9SaveInfo()
        await this.month10SaveInfo()
        await this.month11SaveInfo()
        this.pushOrderInformationToCustomer()
    }

    pushDataToAdmin = async () => {
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');

        let month
        let year = `20${components[2]}`
        let day = components[1]

        if (components[0] === "01") {
            month = "jan"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "02") {
            month = "feb"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "03") {
            month = "mar"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "04") {
            month = "apr"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "05") {
            month = "may"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "06") {
            month = "jun"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "07") {
            month = "jul"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "08") {
            month = "aug"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "09") {
            month = "sep"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "10") {
            month = "oct"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "11") {
            month = "nov"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        } else if (components[0] === "12") {
            month = "dec"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushYearReceiptDataToAdmin(year)
            await this.pushMonthReceiptDataToAdmin(year,month)
            await this.pushDayReceiptDataToAdmin(year,month,day)
        }
        this.pushOrderInformationToCustomer()
    }

    pushYearReceiptDataToAdmin = async (year) => {

        const promises = []

        const totalInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        
        const totalInfoPromise = totalInfoRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().totalSpend
                const updatedTotal = currentTotal + this.state.totalCost

                const currentQty = doc.data().totalQty
                const updatedQty = currentQty + this.state.totalQty

                totalInfoRef.update({
                    totalSpend: updatedTotal,
                    totalQty: updatedQty
                })
            } else {
                totalInfoRef.set({
                    totalSpend: this.state.totalCost,
                    totalQty: this.state.totalQty
                })
            }
        })

        promises.push(totalInfoPromise)

        const quantitiesByItem = {};
        const quantitiesByCategory = {};

        const totalByItem = {};
        const totalByCategory = {};

        this.state.menuOrders.forEach(order => {
            const itemName = order.item;
            const category = order.category;
            const qty = order.qty;
            const total = order.total;
    
            quantitiesByItem[itemName] = (quantitiesByItem[itemName] || 0) + qty;
            quantitiesByCategory[category] = (quantitiesByCategory[category] || 0) + qty;

            totalByItem[itemName] = (totalByItem[itemName] || 0) + total * qty;
            totalByCategory[category] = (totalByCategory[category] || 0) + total * qty;
        });

        //* - - 0category DATA PUSH - - &//

        for (const category in quantitiesByCategory) {

            const categoryInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection("0categories")
            .doc(category)

            const categoryInfoPromise = categoryInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentQty = doc.data().totalQty
                    const updatedQty = currentQty + quantitiesByCategory[category]

                    const currentTotal = doc.data().totalSpend
                    const updatedTotal = currentTotal + totalByCategory[category]

                    categoryInfoRef.update({
                        totalQty: updatedQty,
                        totalSpend: updatedTotal
                    })
                } else {
                    categoryInfoRef.set({
                        totalQty: quantitiesByCategory[category],
                        totalSpend: totalByCategory[category]
                    })
                }
            })
            promises.push(categoryInfoPromise)
        }
        
        //* - - 0meals DATA PUSH - - *//

        for (const item in quantitiesByItem) {
            const mealsInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection("0meals")
            .doc(item)

            const mealsInfoPromise = mealsInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentMealQty = doc.data().qty
                    const updatedMealQty = currentMealQty + quantitiesByItem[item]
    
                    const currentMealTotal = doc.data().total
                    const updatedMealTotal = currentMealTotal + totalByItem[item]
    
                    mealsInfoRef.update({
                        totalSpend: updatedMealTotal,
                        totalQty: updatedMealQty
                    })
                } else {
                    mealsInfoRef.set({
                        totalSpend: totalByItem[item],
                        totalQty: quantitiesByItem[item]
                    })
                }
            })
            promises.push(mealsInfoPromise)
        }

        //* - - 0orders DATA PUSH - - *//

        const orderInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        .collection("0orders")
        .doc(this.state.userReceiptID)
        
        const orderInfoPromise = orderInfoRef.set({
            id: this.state.userReceiptID,
            date: this.state.dateOfPurchase,
            totalCost: this.state.totalCost,
            totalQty: this.state.totalQty,
            earningPolicy: this.state.earningPolicy,
            earningPolicyEndDate: this.state.earningPolicyEndDate,
            earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
            earningPolicyPercentageChange: this.state.earningPolicyPercentageChange,
            earningPolicyPointsValue: this.state.earningPolicyPointsValue
        })

        promises.push(orderInfoPromise)

        for (let i = 0; i < this.state.menuOrders.length; i++) { 

            const orderInfoListRef = orderInfoRef.collection("list")
            .doc(this.state.menuOrders[i].item)
            
            const orderInfoListPromise = orderInfoListRef.set({
                category: this.state.menuOrders[i].category,
                item: this.state.menuOrders[i].item,
                qty: this.state.menuOrders[i].qty,
                total: this.state.menuOrders[i].total
            })
            promises.push(orderInfoListPromise)
        }
        await Promise.all(promises)
    }

    pushMonthReceiptDataToAdmin = async (year, month) => {

        const promises = []

        const totalInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc("0monthInfo")
        
        const totalInfoPromise = totalInfoRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().totalSpend
                const updatedTotal = currentTotal + this.state.totalCost

                const currentQty = doc.data().totalQty
                const updatedQty = currentQty + this.state.totalQty

                totalInfoRef.update({
                    totalSpend: updatedTotal,
                    totalQty: updatedQty
                })
            } else {
                totalInfoRef.set({
                    totalSpend: this.state.totalCost,
                    totalQty: this.state.totalQty
                })
            }
        })

        promises.push(totalInfoPromise)

        const quantitiesByItem = {};
        const quantitiesByCategory = {};

        const totalByItem = {};
        const totalByCategory = {};

        this.state.menuOrders.forEach(order => {
            const itemName = order.item;
            const category = order.category;
            const qty = order.qty;
            const total = order.total;
    
            quantitiesByItem[itemName] = (quantitiesByItem[itemName] || 0) + qty;
            quantitiesByCategory[category] = (quantitiesByCategory[category] || 0) + qty;

            totalByItem[itemName] = (totalByItem[itemName] || 0) + total * qty;
            totalByCategory[category] = (totalByCategory[category] || 0) + total * qty;
        });

        //* - - 0category DATA PUSH - - &//

        for (const category in quantitiesByCategory) {

            const categoryInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("0monthInfo")
            .collection("0categories")
            .doc(category)

            const categoryInfoPromise = categoryInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentQty = doc.data().totalQty
                    const updatedQty = currentQty + quantitiesByCategory[category]

                    const currentTotal = doc.data().totalSpend
                    const updatedTotal = currentTotal + totalByCategory[category]

                    categoryInfoRef.update({
                        totalQty: updatedQty,
                        totalSpend: updatedTotal
                    })
                } else {
                    categoryInfoRef.set({
                        totalQty: quantitiesByCategory[category],
                        totalSpend: totalByCategory[category]
                    })
                }
            })
            promises.push(categoryInfoPromise)
        }
        
        //* - - 0meals DATA PUSH - - *//

        for (const item in quantitiesByItem) {
            const mealsInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("0monthInfo")
            .collection("0meals")
            .doc(item)

            const mealsInfoPromise = mealsInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentMealQty = doc.data().qty
                    const updatedMealQty = currentMealQty + quantitiesByItem[item]
    
                    const currentMealTotal = doc.data().total
                    const updatedMealTotal = currentMealTotal + totalByItem[item]
    
                    mealsInfoRef.update({
                        totalSpend: updatedMealTotal,
                        totalQty: updatedMealQty
                    })
                } else {
                    mealsInfoRef.set({
                        totalSpend: totalByItem[item],
                        totalQty: quantitiesByItem[item]
                    })
                }
            })
            promises.push(mealsInfoPromise)
        }

        //* - - 0orders DATA PUSH - - *//

        const orderInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc("0monthInfo")
        .collection("0orders")
        .doc(this.state.userReceiptID)
        
        const orderInfoPromise = orderInfoRef.set({
            id: this.state.userReceiptID,
            date: this.state.dateOfPurchase,
            totalCost: this.state.totalCost,
            totalQty: this.state.totalQty,
            earningPolicy: this.state.earningPolicy,
            earningPolicyEndDate: this.state.earningPolicyEndDate,
            earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
            earningPolicyPercentageChange: this.state.earningPolicyPercentageChange,
            earningPolicyPointsValue: this.state.earningPolicyPointsValue
        })

        promises.push(orderInfoPromise)

        for (let i = 0; i < this.state.menuOrders.length; i++) { 

            const orderInfoListRef = orderInfoRef.collection("list")
            .doc(this.state.menuOrders[i].item)
            
            const orderInfoListPromise = orderInfoListRef.set({
                category: this.state.menuOrders[i].category,
                item: this.state.menuOrders[i].item,
                qty: this.state.menuOrders[i].qty,
                total: this.state.menuOrders[i].total
            })
            promises.push(orderInfoListPromise)
        }
        await Promise.all(promises)

    }

    pushDayReceiptDataToAdmin = async (year, month, day) => {

        const promises = []

        const totalInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc(day)
        
        const totalInfoPromise = totalInfoRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().totalSpend
                const updatedTotal = currentTotal + this.state.totalCost

                const currentQty = doc.data().totalQty
                const updatedQty = currentQty + this.state.totalQty

                totalInfoRef.update({
                    totalSpend: updatedTotal,
                    totalQty: updatedQty
                })
            } else {
                totalInfoRef.set({
                    totalSpend: this.state.totalCost,
                    totalQty: this.state.totalQty
                })
            }
        })

        promises.push(totalInfoPromise)

        const quantitiesByItem = {};
        const quantitiesByCategory = {};

        const totalByItem = {};
        const totalByCategory = {};

        this.state.menuOrders.forEach(order => {
            const itemName = order.item;
            const category = order.category;
            const qty = order.qty;
            const total = order.total;
    
            quantitiesByItem[itemName] = (quantitiesByItem[itemName] || 0) + qty;
            quantitiesByCategory[category] = (quantitiesByCategory[category] || 0) + qty;

            totalByItem[itemName] = (totalByItem[itemName] || 0) + total * qty;
            totalByCategory[category] = (totalByCategory[category] || 0) + total * qty;
        });

        //* - - 0category DATA PUSH - - &//

        for (const category in quantitiesByCategory) {

            const categoryInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc(day)
            .collection("0categories")
            .doc(category)

            const categoryInfoPromise = categoryInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentQty = doc.data().totalQty
                    const updatedQty = currentQty + quantitiesByCategory[category]

                    const currentTotal = doc.data().totalSpend
                    const updatedTotal = currentTotal + totalByCategory[category]

                    categoryInfoRef.update({
                        totalQty: updatedQty,
                        totalSpend: updatedTotal
                    })
                } else {
                    categoryInfoRef.set({
                        totalQty: quantitiesByCategory[category],
                        totalSpend: totalByCategory[category]
                    })
                }
            })
            promises.push(categoryInfoPromise)
        }
        
        //* - - 0meals DATA PUSH - - *//

        for (const item in quantitiesByItem) {
            const mealsInfoRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc(day)
            .collection("0meals")
            .doc(item)

            const mealsInfoPromise = mealsInfoRef.get().then(doc => {
                if (doc.exists) {
                    const currentMealQty = doc.data().qty
                    const updatedMealQty = currentMealQty + quantitiesByItem[item]
    
                    const currentMealTotal = doc.data().total
                    const updatedMealTotal = currentMealTotal + totalByItem[item]
    
                    mealsInfoRef.update({
                        totalSpend: updatedMealTotal,
                        totalQty: updatedMealQty
                    })
                } else {
                    mealsInfoRef.set({
                        totalSpend: totalByItem[item],
                        totalQty: quantitiesByItem[item]
                    })
                }
            })
            promises.push(mealsInfoPromise)
        }

        //* - - 0orders DATA PUSH - - *//

        const orderInfoRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.userID)
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc(day)
        .collection("0orders")
        .doc(this.state.userReceiptID)
        
        const orderInfoPromise = orderInfoRef.set({
            id: this.state.userReceiptID,
            date: this.state.dateOfPurchase,
            totalCost: this.state.totalCost,
            totalQty: this.state.totalQty,
            earningPolicy: this.state.earningPolicy,
            earningPolicyEndDate: this.state.earningPolicyEndDate,
            earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
            earningPolicyPercentageChange: this.state.earningPolicyPercentageChange,
            earningPolicyPointsValue: this.state.earningPolicyPointsValue
        })

        promises.push(orderInfoPromise)

        for (let i = 0; i < this.state.menuOrders.length; i++) { 

            const orderInfoListRef = orderInfoRef.collection("list")
            .doc(this.state.menuOrders[i].item)
            
            const orderInfoListPromise = orderInfoListRef.set({
                category: this.state.menuOrders[i].category,
                item: this.state.menuOrders[i].item,
                qty: this.state.menuOrders[i].qty,
                total: this.state.menuOrders[i].total
            })
            promises.push(orderInfoListPromise)
        }
        await Promise.all(promises)
    }

    pushOrderInformationToCustomer = async () => {
            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let timeOfOrder = this.state.dateOfPurchase.split(' ')[1];
        let timeComponents = timeOfOrder.split(':');
        let dateComponents = orderDate.split('/');
        const newFormatOrderDate = `${dateComponents[0]}-${dateComponents[1]}-20${dateComponents[2]}`;
        let newReceiptID = `receipt-20${dateComponents[2]}-${dateComponents[1]}-${dateComponents[0]}-${timeComponents[0]}-${timeComponents[1]}`

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("verified")
        .doc(newReceiptID)
        .set({
            receiptID: newReceiptID,
            receiptImg: this.state.userReceiptImg,
            location: this.state.userLocation,
            date: newFormatOrderDate,
        })
        .then(() => {
            const promises = []
            for (let i = 0; i < this.state.menuOrders.length; i++) {
                const order = this.state.menuOrders[i]
                let orderPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("members")
                .doc("members_list")
                .collection("list")
                .doc(this.state.userID)
                .collection("data")
                .doc("purchaseHistory")
                .collection("verified")
                .doc(newReceiptID)
                .collection("order")
                .doc(order.item)
                .set({
                    item: order.item,
                    qty: order.qty,
                })
                promises.push(orderPromise)
            }
                //? - - CHANGE THIS TO DLEETE!!!! - - //
            let deleteNonVerifiedPromise = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("purchaseHistory")
            .collection("nonVerified")
            .doc(this.state.userReceiptID)
            .delete()

            promises.push(deleteNonVerifiedPromise)

            let pointsAdding = parseInt(this.state.totalCost) * (this.state.savedPointsValue / this.state.savedMoneyValue)

            if (this.state.earningPolicyEndDate !== "") {
                pointsAdding = parseInt(this.state.totalCost) * (this.state.earningPolicyPointsValue / this.state.earningPolicyMoneyValue)
            }

            let customerPointsPromise = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("pointsInfo")

            customerPointsPromise.get().then(async doc => {
                if (doc.exists) {
                    const currentPoints = doc.data().points
                    let updatedPoints = currentPoints + pointsAdding
                    customerPointsPromise.update({
                        points: updatedPoints
                    })
                }   
            })
            promises.push(customerPointsPromise)
            return Promise.all(promises);
        })
    }
    //* To use this function or re-create a separate one... hmmm *//

    checkIfEarningPoliciesApply = async () => {
        //* - - ORDER DATE - - *//
        this.setState({
            showTransactionDetails: false,
            showTransactionDetailsLoading: true,
            approvalLoadingMsg: "checking if earning policies apply"
        });
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

        try {
            const querySnapshot = await fire.firestore().collection('clients')
                .doc('artcaffe')
                .collection('admin')
                .doc('points')
                .collection('earning')
                .doc('parameters')
                .collection('purchase')
                .get();

            const promises = querySnapshot.docs.map(async(doc) => {
                if (doc.data().status === true && this.isDateBefore(newFormatOrderDate, doc.data().filterOptionEndDate)) {

                    //* - - MEAL ONLY - - *//
                    if (doc.data().mealOnly === true) {
                        if (await this.checkEPMealQuantity(doc.data().id, doc.data().rewardMenuItem, doc.data().rewardQuantity, doc.data().dateStatusActive, doc.data().filterOptionEndDate)) {
                            await this.pushEarningPoliciesToCustomer(doc.data().id);
                        }
                    }

                    //* - - PRICE ONLY - - *//
                    if (doc.data().priceOnly === true) {
                        if (await this.checkEPTotalSpend(doc.data().id, doc.data().filterOptionPricing, doc.data().dateStatusActive, doc.data().filterOptionEndDate)) {
                            await this.pushEarningPoliciesToCustomer(doc.data().id);
                        }
                    }

                    //* - - MEAL & PRICE - - *//
                    if (doc.data().mealOnly === false && doc.data().priceOnly === false) {
                        if (await this.checkEPMealQuantity(doc.data().id, doc.data().rewardMenuItem, doc.data().rewardQuantity, doc.data().dateStatusActive, doc.data().filterOptionEndDate) && await this.checkEPTotalSpend(doc.data().id, doc.data().filterOptionPricing, doc.data().dateStatusActive, doc.data().filterOptionEndDate)) {
                            await this.pushEarningPoliciesToCustomer(doc.data().id);
                        }
                    }
                }
            });
            await Promise.all(promises)
            this.deleteNonVerifiedReceipt()
            this.setState({
                showTransactionDetails: false,
                showTransactionDetailsLoading: false,
                approvalLoadingMsg: "save complete",
                showReceiptDashboard: false,
                showReceiptDashboardLoading: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showReceiptDashboardLoading: false,
                        showReceiptDashboardPlaceholder: true
                    });
                }, 2000);
            });
        } catch (error) {
            alert("Something went wrong: ", error)
        }
    }

    checkEPMealQuantity = async (id, meal, qty, startDate, endDate) => {

        const year = new Date(startDate).getFullYear();
        const month = new Date(startDate).getMonth();
        
        const yearString = year.toString()

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const startSearchMonth = monthAbbreviations[new Date(startDate).getMonth()];
        const endSearchMonth = monthAbbreviations[new Date(endDate).getMonth()];

        const startDateFlex = new Date(startDate)
        startDateFlex.setMonth(startDateFlex.getMonth() + 1, 1);
        startDateFlex.setDate(startDateFlex.getDate() - 1);

        const startDateEndOfMonth = startDateFlex.getDate()

        const startSearchDate = new Date(startDate).getDate()
        const endSearchDate = new Date(endDate).getDate();

        if (startSearchMonth !== endSearchMonth) {

            const promises = []

            let totalQty = 0

            for (let i = startSearchDate; i <= startDateEndOfMonth; i++) {
        
                const dailyMealsRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(startSearchMonth)
                .doc(`${i}`)
                .collection("0meals")
                .doc(meal)
                
                const dailyMealsPromise = dailyMealsRef.get().then(doc => {
                    if (doc.exists) {
                        totalQty += doc.data().totalQty
                    }
                })
                promises.push(dailyMealsPromise)
            }

            await Promise.all(promises)
            
            let startSearchIndex = monthAbbreviations.indexOf(startSearchMonth) + 1
            let endSearchIndex = monthAbbreviations.indexOf(endSearchMonth) + 1
            console.log(startSearchIndex)
            console.log(endSearchIndex)
            //     //* - - If there is AT LEAST a full month between
            if (startSearchIndex+1 < endSearchIndex) {
                for (let i = startSearchIndex+1; i < endSearchIndex; i++) {
                    const monthlyMealsRef = fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("members")
                    .collection("full_list")
                    .doc(this.state.userID)
                    .collection("orders")
                    .doc(yearString)
                    .collection(monthAbbreviations[i-1])
                    .doc("0monthInfo")
                    .collection("0meals")
                    .doc(meal)

                    const monthlyMealsPromise = monthlyMealsRef.get().then(doc => {
                        if (doc.exists) {
                            totalQty += doc.data().totalQty
                        }
                    })
                    promises.push(monthlyMealsPromise)
                }
                await Promise.all(promises)
            }

            for (let i = 1; i <= endSearchDate; i++) {
                
                const dailyMealRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(endSearchMonth)
                .doc(`${i}`)
                .collection("0meals")
                .doc(meal)

                const dailyMealsPromise = dailyMealRef.get().then(doc => {
                    if (doc.exists) {
                        totalQty += doc.data().totalQty
                    }
                })
                promises.push(dailyMealsPromise)
            }
            await Promise.all(promises)

            if (totalQty >= qty) {
                console.log(`${id}: MEAL EARNING POLICY APPLIED`)
                return true
            }

        } else {

            let totalQty = 0

            const promises = []

            for (let i = startSearchDate; i <= endSearchDate; i++) {
                
                const dailyMealRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(startSearchMonth)
                .doc(`${i}`)
                .collection("0meals")
                .doc(meal)
                const dailyMealPromise = dailyMealRef.get().then(doc => {
                    if (doc.exists) {
                        totalQty += doc.data().totalQty
                    }
                })

                promises.push(dailyMealPromise)
            }
            await Promise.all(promises)
            if (totalQty >= qty) {
                console.log(`${id}: MEAL EARNING POLICY APPLIED`)
                return true
            }
        }
    }

    checkEPTotalSpend = async (id, spend, startDate, endDate) => {

        const year = new Date(startDate).getFullYear();
        const month = new Date(startDate).getMonth();
        
        const yearString = year.toString()

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const startSearchMonth = monthAbbreviations[new Date(startDate).getMonth()];
        const endSearchMonth = monthAbbreviations[new Date(endDate).getMonth()];

        const startDateFlex = new Date(startDate)
        startDateFlex.setMonth(startDateFlex.getMonth() + 1, 1);
        startDateFlex.setDate(startDateFlex.getDate() - 1);

        const startDateEndOfMonth = startDateFlex.getDate()

        const startSearchDate = new Date(startDate).getDate()
        const endSearchDate = new Date(endDate).getDate();

        if (startSearchMonth !== endSearchMonth) {

            const promises = []

            let totalSpend = 0

            for (let i = startSearchDate; i <= startDateEndOfMonth; i++) {
        
                const dailySpendRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(startSearchMonth)
                .doc(`${i}`)
                
                const dailySpendPromise = dailySpendRef.get().then(doc => {
                    if (doc.exists) {
                        totalSpend += doc.data().totalSpend
                    }
                })
                promises.push(dailySpendPromise)
            }

            await Promise.all(promises)
            
            let startSearchIndex = monthAbbreviations.indexOf(startSearchMonth) + 1
            let endSearchIndex = monthAbbreviations.indexOf(endSearchMonth) + 1
            console.log(startSearchIndex)
            console.log(endSearchIndex)
            //     //* - - If there is AT LEAST a full month between
            if (startSearchIndex+1 < endSearchIndex) {
                for (let i = startSearchIndex+1; i < endSearchIndex; i++) {
                    const monthlySpendRef = fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("members")
                    .collection("full_list")
                    .doc(this.state.userID)
                    .collection("orders")
                    .doc(yearString)
                    .collection(monthAbbreviations[i-1])
                    .doc("0monthInfo")

                    const monthlySpendPromise = monthlySpendRef.get().then(doc => {
                        if (doc.exists) {
                            totalSpend += doc.data().totalSpend
                        }
                    })
                    promises.push(monthlySpendPromise)
                }
                await Promise.all(promises)
            }

            for (let i = 1; i <= endSearchDate; i++) {
                
                const dailySpendRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(endSearchMonth)
                .doc(`${i}`)

                const dailySpendPromise = dailySpendRef.get().then(doc => {
                    if (doc.exists) {
                        totalSpend += doc.data().totalSpend
                    }
                })
                promises.push(dailySpendPromise)
            }
            await Promise.all(promises)
            if (totalSpend >= spend) {
                console.log(`${id}: SPENDING EARNING POLICY APPLIED`)
                return true
            }
        } else {

            let totalSpend = 0

            const promises = []

            for (let i = startSearchDate; i <= endSearchDate; i++) {
                
                const dailySpendRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(yearString)
                .collection(startSearchMonth)
                .doc(`${i}`)
                
                const dailySpendPromise = dailySpendRef.get().then(doc => {
                    if (doc.exists) {
                        totalSpend += doc.data().totalSpend
                    }
                })

                promises.push(dailySpendPromise)
            }
            await Promise.all(promises)
            if (totalSpend >= spend) {
                console.log(`${id}: SPENDING EARNING POLICY APPLIED`)
                return true
            }
        }
    }

    compareOrderDataToEarningPolicies = async () => {
        //* - - ORDER DATE - - *//
        this.setState({
            showTransactionDetails: false,
            showTransactionDetailsLoading: true,
            approvalLoadingMsg: "checking if earning policies apply"
        })
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

        try {
            const querySnapshot = await fire.firestore().collection('clients')
            .doc('artcaffe')
            .collection('admin')
            .doc('points')
            .collection('earning')
            .doc('parameters')
            .collection('purchase')
            .get()
        
        
            const promises = querySnapshot.docs.map(async doc => {
                const resultPromises = []
                const startDate = doc.data().dateCreated;
                const endDate = doc.data().filterOptionEndDate;
                let docStatus = doc.data().status
                // Check if earning policy is active
                if (docStatus === true) {
                    let policyID = doc.data().id
                    let priceValid = false
                    let mealValid = false
                    // Check if newFormatOrderDate falls between start and end dates
                    if (this.isDateBetween(startDate, endDate, newFormatOrderDate)) {
                        let mealOnlyPolicy = doc.data().mealOnly
                        let priceOnlyPolicy = doc.data().priceOnly
                        let priceTotal = 0
                        let mealQuantity = 0
                        let priceComparison = doc.data().priceFilterComparative
                        let priceThreshold = parseInt(doc.data().filterOptionPricing) 
                        let mealThreshold = parseInt(doc.data().rewardQuantity) 
                        console.log(`Date falls between: ${startDate} and ${endDate}`);
                        // Perform actions if the date falls between
                        let searchingArrays = this.checkOrderPeriodsForEarningPolicy(startDate, endDate)
                        console.log(this.checkOrderPeriodsForEarningPolicy(startDate, endDate))
                        console.log(`CHECKING POLICY: ${policyID}`)
                        if (searchingArrays.length > 1) {
                            let startPoint = searchingArrays[1]
                            startPoint = parseInt(startPoint.replace(/\D/g, ''), 10);
                            // console.log(`START POINT MONTH: ${startPoint}`)
                            if (priceOnlyPolicy === true || (mealOnlyPolicy === false && priceOnlyPolicy === false)) {
                                resultPromises.push(
                                    this.checkPriceTotalFromStartingPoint(startPoint, startDate).then(result => {
                                        // console.log(result);
                                        priceTotal = parseInt(result);
                                    })
                                );
                            }
                            if ((mealOnlyPolicy === true && mealThreshold !== "") || (mealOnlyPolicy === false && priceOnlyPolicy === false)) {
                                resultPromises.push(
                                    this.checkMealQuantityFromStartingPoint(startPoint, doc.data().rewardMenuItem, startDate).then(result => {
                                        // console.log(result);
                                        mealQuantity = parseInt(result);
                                    })
                                ); 
                            }
                            // console.log(`PRICE TOTAL: ${foundPriceTotal}`)
                            // console.log(`MEAL QUANTITY: ${foundMealTotal}`) 
                        } else {
                            resultPromises.push(
                                this.checkPriceForSingleOrderPeriod(searchingArrays[0]).then(result => {
                                    // console.log(result);
                                    priceTotal = result;
                                })
                            );
                
                            resultPromises.push(
                                this.checkMealQuantityForSingleOrderPeriod(doc.data().rewardMenuItem, searchingArrays[0]).then(result => {
                                    // console.log(result);
                                    mealQuantity = result;
                                })
                            );
                            // console.log(`FOUND PRICE TOTAL: ${foundPriceTotal}`)
                            // console.log(`FOUND MEAL QUANTITY: ${foundMealTotal}`)
                        }
                            //* - - HANDLING PRICE COMPARISON - - *//


                            await Promise.all(resultPromises);


                        if (priceComparison !== "" && priceComparison === "equal") {
                            if (priceThreshold === priceTotal) {
                                // console.log("Price threshold has been met")
                                priceValid = true
                            }
                        } else if (priceComparison !== "" && priceComparison === "greater") {
                            if (priceThreshold < priceTotal) {
                                // console.log("Price threshold has been met")
                                priceValid = true
                            }
                        } else if (priceComparison !== "" && priceComparison === "equal-greater") {
                            if (priceThreshold <= priceTotal) {
                                // console.log("Price threshold has been met")
                                priceValid = true
                            }
                        } else {
                            priceValid = false
                            // console.log("Price threshold not met")
                        }

                            //* - - HANDLING MEAL COMPARISON - - *//

                        if (mealQuantity >= mealThreshold) {
                            // console.log("Meal threshold has been met")
                            mealValid = true
                        }

                        if ((mealOnlyPolicy && mealThreshold !== "") && priceOnlyPolicy === false) {
                            // console.log(`POLICY ${policyID} VALID? ${mealValid}`);
                            if (mealValid) {
                                console.log(`ADDING: ${policyID}`)
                                await this.pushEarningPoliciesToCustomer(policyID)
                            } 
                        } else if (priceOnlyPolicy && (mealOnlyPolicy === false)) {
                            // console.log(`POLICY ${policyID} VALID? ${priceValid}`);
                            if (priceValid) {
                                console.log(`ADDING: ${policyID}`)
                                await this.pushEarningPoliciesToCustomer(policyID)
                            } 
                        } else if (priceOnlyPolicy === false && mealOnlyPolicy === false) {
                            // console.log(`POLICY ${policyID} VALID? ${mealValid && priceValid ? true : false}`);
                            if (mealValid && priceValid) {
                                console.log(`ADDING: ${policyID}`)
                                await this.pushEarningPoliciesToCustomer(policyID)
                            }
                        }
                    } else {
                        console.log(`Date does not fall between: ${startDate} and ${endDate}`);
                    }
                }
            });
            await Promise.all(promises);
            this.deleteNonVerifiedReceipt()
            this.setState({
                showTransactionDetails: false,
                showTransactionDetailsLoading: false,
                approvalLoadingMsg: "save complete",
                showReceiptDashboard: false,
                showReceiptDashboardLoading: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showReceiptDashboardLoading: false,
                        showReceiptDashboardPlaceholder: true
                    });
                }, 2000);
            });
        } catch (error) {
            alert(error)
        }
        
    }

    pushDataToTransactions = async () => {
            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');

        let month
        let year = `20${components[2]}`
        let day = components[1]

        if (components[0] === "01") {
            month = "jan"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "02") {
            month = "feb"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "03") {
            month = "mar"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "04") {
            month = "apr"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "05") {
            month = "may"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "06") {
            month = "jun"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "07") {
            month = "jul"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "08") {
            month = "aug"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "09") {
            month = "sep"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "10") {
            month = "oct"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "11") {
            month = "nov"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        } else if (components[0] === "12") {
            month = "dec"
            if (day.charAt(0) === '0') {
                day = day.slice(1)
            }
            await this.pushMonthlyOrders(year, month, day)
            await this.pushMonthlyRevenue(year, month, day)
            this.pushMonthlyMemberData(year, month, day)
        }
    }

    pushMonthlyOrders = async (year, month, day) => {
        const quantitiesByItem = {};
        const quantitiesByCategory = {};

        const totalQuantity = this.state.menuOrders.reduce((total, order) => {
            return total + parseInt(order.qty, 10);
        }, 0);
    
        //* - - Aggregate quantities - - *//
        this.state.menuOrders.forEach(order => {
            const itemName = order.item;
            const category = order.category;
            const qty = parseInt(order.qty);
    
            quantitiesByItem[itemName] = (quantitiesByItem[itemName] || 0) + qty;
            quantitiesByCategory[category] = (quantitiesByCategory[category] || 0) + qty;
        });
    
        const promises = [];

        const monthlyQuantityRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc("qty")

        const monthlyQuantityPromise = monthlyQuantityRef.get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                const updatedQuantity = currentQuantity + totalQuantity
                return monthlyQuantityRef.update({
                    qty: updatedQuantity
                })
            } else {
                return monthlyQuantityRef.set({
                    qty: totalQuantity
                })
            }
        })

        promises.push(monthlyQuantityPromise)

        const dailyQuantityRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection(month)
        .doc("byItem")
        .collection(day)
        .doc("0qty")

        const dailyQuantityPromise = dailyQuantityRef.get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                const updatedQuantity = currentQuantity + this.state.totalQty
                return dailyQuantityRef.update({
                    qty: updatedQuantity
                })
            } else {
                return dailyQuantityRef.set({
                    qty: this.state.totalQty
                })
            }
        })

        promises.push(dailyQuantityPromise)
    
        //* - - Update quantities in Firestore - - *//
        for (const itemName in quantitiesByItem) {
            const orderRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(year)
                .collection(month)
                .doc("byItem")
                .collection(day)
                .doc(itemName);
    
            const orderPromise = orderRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByItem[itemName];
                    return orderRef.update({
                        qty: updatedQuantity
                    });
                } else {
                    return orderRef.set({
                        item: itemName,
                        qty: quantitiesByItem[itemName]
                    });
                }
            });

            promises.push(orderPromise);

            const allOrdersRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection("allOrders")
            .doc(itemName)

            const allOrdersPromise = allOrdersRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByItem[itemName];
                    return allOrdersRef.update({
                        qty: updatedQuantity
                    })
                } else {
                    return allOrdersRef.set({
                        item: itemName,
                        qty: quantitiesByItem[itemName],
                        total: 0
                    })
                }
            });

            promises.push(allOrdersPromise)

            const allMontlyOrdersRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("allOrders")
            .collection("list")
            .doc(itemName)

            const allMonthlyOrdersPromise = allMontlyOrdersRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByItem[itemName];
                    return allMontlyOrdersRef.update({
                        qty: updatedQuantity
                    })
                } else {
                    return allMontlyOrdersRef.set({
                        item: itemName,
                        qty: quantitiesByItem[itemName],
                        total: 0
                    })
                }
            });
            promises.push(allMonthlyOrdersPromise)
        }
    
        for (const category in quantitiesByCategory) {

            const allCategoriesRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection("allCategories")
            .doc(category)

            const allCategoriesPromise = allCategoriesRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByCategory[category];
                    return allCategoriesRef.update({
                        qty: updatedQuantity
                    })
                } else {
                    return allCategoriesRef.set({
                        category: category,
                        qty: quantitiesByCategory[category],
                        total: 0
                    })
                }
            })

            promises.push(allCategoriesPromise)

            const allCategoriesMonthlyRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("allCategories")
            .collection("list")
            .doc(category)

            const allCategoriesMonthlyPromise = allCategoriesMonthlyRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByCategory[category];
                    return allCategoriesMonthlyRef.update({
                        qty: updatedQuantity
                    })
                } else {
                    return allCategoriesMonthlyRef.set({
                        category: category,
                        qty: quantitiesByCategory[category],
                        total: 0
                    })
                }
            })

            promises.push(allCategoriesMonthlyPromise)

            const categoryRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("byCategory")
            .collection(day)
            .doc(category);
    
            const categoryPromise = categoryRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    const updatedQuantity = currentQuantity + quantitiesByCategory[category];
                    return categoryRef.update({
                        qty: updatedQuantity
                    });
                } else {
                    return categoryRef.set({
                        qty: quantitiesByCategory[category]
                    });
                }
            });
            promises.push(categoryPromise);
        }
    
        await Promise.all(promises);
    }

    pushMonthlyRevenue = async (year, month, day) => {
        const promises = [];
    
        const monthlyTotalRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection(month)
        .doc("total")

        const monthlyTotalPromise = monthlyTotalRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                return monthlyTotalRef.update({
                    total: updatedTotal
                })
            } else {
                return monthlyTotalRef.set({
                    total: parseInt(this.state.totalCost)
                })
            }
        })

        promises.push(monthlyTotalPromise)
        
        const dailyTotalRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("byItem")
            .collection(day)
            .doc("0total");
    
        const dailyTotalPromise = dailyTotalRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                const updatedTotal = currentTotal + parseInt(this.state.totalCost);
                return dailyTotalRef.update({
                    total: updatedTotal
                });
            } else {
                return dailyTotalRef.set({
                    total: parseInt(this.state.totalCost)
                });
            }
        });
    
        promises.push(dailyTotalPromise);
    
        const quantitiesByCategory = {};
    
        //* - - Aggregate quantities by category - - *//
        this.state.menuOrders.forEach(order => {
            const category = order.category;
            const match = order.item.match(/\(KES (\d+)/);
            const itemCost = match ? parseInt(match[1]) * parseInt(order.qty) : 0;
    
            quantitiesByCategory[category] = (quantitiesByCategory[category] || 0) + itemCost;
        });
    
        //* - - Update quantities in Firestore for categories - - *//
        for (const category in quantitiesByCategory) {

            const allCategoriesRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection("allCategories")
            .doc(category)

            const allCategoriesPromise = allCategoriesRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + quantitiesByCategory[category];
                    return allCategoriesRef.update({
                        total: updatedTotal
                    })
                }
            })

            promises.push(allCategoriesPromise)

            const allCategoriesMonthlyRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("allCategories")
            .collection("list")
            .doc(category)

            const allCategoriesMonthlyPromise = allCategoriesMonthlyRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + quantitiesByCategory[category];
                    return allCategoriesMonthlyRef.update({
                        total: updatedTotal
                    })
                }
            })

            promises.push(allCategoriesMonthlyPromise)

            const categoryRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(year)
                .collection(month)
                .doc("byCategory")
                .collection(day)
                .doc(category);
    
            const categoryPromise = categoryRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + quantitiesByCategory[category];
                    return categoryRef.update({
                        total: updatedTotal
                    });
                } else {
                    return categoryRef.set({
                        total: quantitiesByCategory[category]
                    });
                }
            });
    
            promises.push(categoryPromise);
        }
    
        //* - - Update quantities in Firestore for individual items - - *//
        for (let i = 0; i < this.state.menuOrders.length; i++) {
            const order = this.state.menuOrders[i];
            const match = order.item.match(/\(KES (\d+)/);
            const itemCost = match ? parseInt(match[1]) * parseInt(order.qty) : 0;
    
            const orderRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(year)
                .collection(month)
                .doc("byItem")
                .collection(day)
                .doc(order.item);
    
            const orderPromise = orderRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + itemCost;
                    return orderRef.update({
                        total: updatedTotal
                    });
                } else {
                    return orderRef.set({
                        item: order.item,
                        total: itemCost
                    });
                }
            });
    
            promises.push(orderPromise);

            const allOrdersRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection("allOrders")
            .doc(order.item)

            const allOrdersPromise = allOrdersRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + itemCost;
                    return allOrdersRef.update({
                        total: updatedTotal
                    })
                }
            });
            promises.push(allOrdersPromise)

            const allMontlyOrdersRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("orders")
            .doc(year)
            .collection(month)
            .doc("allOrders")
            .collection("list")
            .doc(order.item)

            const allMonthlyOrdersPromise = allMontlyOrdersRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + itemCost;
                    return allMontlyOrdersRef.update({
                        total: updatedTotal
                    })
                }
            });
            promises.push(allMonthlyOrdersPromise)
        }
    
        await Promise.all(promises);
    }

    pushMonthlyMemberData = async (year, month, day) => {

        const promises = []

        const memberActivityDayCollectionRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection(month)
        .doc("activity")
        .collection(day)
        .doc(this.state.userID)

        const memberActivityDayCollectionPromise = memberActivityDayCollectionRef.get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                const updatedQuantity = currentQuantity + this.state.totalQty
    
                const currentTotal = doc.data().total || 0;
                const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                return memberCollectionRef.update({
                    qty: updatedQuantity,
                    total: updatedTotal
                })
            } else {
                return memberActivityDayCollectionRef.set({
                    id: this.state.userID,
                    email: this.state.userEmail,
                    name: this.state.userName,
                    qty: this.state.totalQty,
                    total: parseInt(this.state.totalCost)
                })
            }  
        })

        promises.push(memberActivityDayCollectionPromise)

        const memberCollectionRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .doc(this.state.userID)
        
        const memberCollectionPromise = memberCollectionRef.get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                const updatedQuantity = currentQuantity + this.state.totalQty
    
                const currentTotal = doc.data().total || 0;
                const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                return memberCollectionRef.update({
                    qty: updatedQuantity,
                    total: updatedTotal
                })
            } else {
                return memberCollectionRef.set({
                    id: this.state.userID,
                    email: this.state.userEmail,
                    name: this.state.userName,
                    qty: this.state.totalQty,
                    total: parseInt(this.state.totalCost)
                })
            }  
        })

        promises.push(memberCollectionPromise)

        const memberCollectionMonthlyRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection(month)
        .doc(this.state.userID)

        const membersCollectionMonthlyPromise = memberCollectionMonthlyRef.get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                const updatedTotal = currentTotal + parseInt(this.state.totalCost)

                const currentQuantity = doc.data().qty || 0;
                const updatedQuantity = currentQuantity + this.state.totalQty
                return memberCollectionMonthlyRef.update({
                    total: updatedTotal,
                    qty: updatedQuantity
                })
            } else {
                return memberCollectionMonthlyRef.set({
                    id: this.state.userID,
                    email: this.state.userEmail,
                    name: this.state.userName,
                    qty: this.state.totalQty,
                    total: parseInt(this.state.totalCost)
                })
            }
        })

        promises.push(membersCollectionMonthlyPromise)

        await Promise.all(promises);
    }

    pushEarningPoliciesToCustomer = async (policyID) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("pointsInfo")
        .collection("earningPolicies")
        .doc(policyID)
        .set({
            policyID: policyID,
        })
    }

    checkPriceForSingleOrderPeriod = async (orderPeriod) => {

        let total = 0;

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;
            
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)
    

        if (orderPeriod === "thisDay") {
            const doc = await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(orderPeriod)
            .get()
            if (doc.exists) {
                total = doc.data().total
            }
        } 

        if (orderPeriod === "thisWeek") {

            let weekStarting = this.getFirstDayOfWeek(formattedDate)
            let weekEnding = this.getLastDayOfWeek(formattedDate)

            let orderDateOfWeek = this.getDayOfWeek(weekStarting, weekEnding, newFormatOrderDate)

            for (let i = 1; i <= orderDateOfWeek; i++) {
                const doc = await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(orderPeriod)
                .collection("weeklySpend")
                .doc(`${i}`)
                .get()
                if (doc.exists) {
                    total += doc.data().total
                }
            }
        }

        if (orderPeriod === "thisMonth") {

            let currentDateParts = newFormatOrderDate.split("-");
            const currentDateDay = parseInt(currentDateParts[1], 10);

            for (let i = 1; i <= currentDateDay; i++) {
                const doc = await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(orderPeriod)
                .collection("monthlySpend")
                .doc(`${i}`)
                .get()
                if (doc.exists) {
                    total += doc.data().total
                }
            }
        }

        return total
    }

    checkMealQuantityForSingleOrderPeriod = async (meal, orderPeriod) => {

        let quantity = 0;

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;
            
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)
    

        if (orderPeriod === "thisDay" && meal != "") {
            const doc = await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(orderPeriod)
            .collection("dailyMeals")
            .doc(meal)
            .get()
            if (doc.exists) {
                quantity = doc.data().qty
            }
        } 

        if (orderPeriod === "thisWeek" && meal !== "") {

            const doc = await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(orderPeriod)
            .collection("weeklyMeals")
            .doc(meal)
            .get()
            if (doc.exists) {
                quantity += doc.data().qty
            }
            
        }

        if (orderPeriod === "thisMonth" && meal !== "") {

            const doc = await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(orderPeriod)
            .collection("monthlyMeals")
            .doc(meal)
            .get()
            if (doc.exists) {
                quantity += doc.data().qty
            }
        }

        return quantity
    }

    checkPriceTotalFromStartingPoint = async (startPoint, policyStartDate) => {
        let totalFromGetMonthTotal = 0;
        let totalFromCheckPreviousMonths = 0;
        let totalFromCurrentMonth = 0;
    
        // START DATE
        const parts = policyStartDate.split("-");
        const day = parseInt(parts[1], 10);
    
        const getMonthTotal = async (month, currentDay) => {
            const startPointCollectionRef = fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(month)
                .collection(`${month}Spend`);
    
            const promises = [];
    
            for (let i = currentDay; i < 32; i++) {
                promises.push(startPointCollectionRef.doc(`${i}`).get());
            }
    
            const snapshot = await Promise.all(promises);
    
            snapshot.forEach(doc => {
                totalFromGetMonthTotal += doc.data().total || 0;
            });
        };
    
        const checkPreviousMonths = async (startPointNumber) => {
            // PRICE TOTAL VARIABLE
            totalFromCheckPreviousMonths = 0;
    
            for (let i = startPointNumber - 1; i > 0; i--) {
                const doc = await fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(`month${i}`)
                .get();
                if (doc.exists) {
                    totalFromCheckPreviousMonths += doc.data().total || 0;
                }
            }
        };

        const checkCurrentMonth = async () => {
                //* - - CURRENT DATE - - *//
            let currentDate = new Date()
            let formattedDate = this.formatDate(currentDate)
            
            let currentDateParts = formattedDate.split("-");
            const currentDateDay = parseInt(currentDateParts[1], 10);

            totalFromCurrentMonth = 0;

            for (let i = 1; i <= currentDateDay; i++) {
                const doc = await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("thisMonth")
                .collection("monthlySpend")
                .doc(`${i}`)
                .get()
                if (doc.exists) {
                    totalFromCurrentMonth += doc.data().total || 0;
                }
            }
        }
    
        try {
            const doc = await fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(`month${startPoint}`)
                .get();
    
            if (doc.exists) {
                await getMonthTotal(`month${startPoint}`, day);
            } 
    
            await checkPreviousMonths(startPoint);
            await checkCurrentMonth()
    
            // Combine the totals and log the result
            const combinedTotal = totalFromGetMonthTotal + totalFromCheckPreviousMonths + totalFromCurrentMonth;
            return combinedTotal
        } catch (error) {
            console.error("Error getting document:", error);
        }
    };

    checkMealQuantityFromStartingPoint = async (startPoint, meal, policyStartDate) => {
        let totalFromGetMonthTotal = 0;
        let totalFromCheckPreviousMonths = 0;
        let totalFromCurrentMonth = 0;
    
        // START DATE
        const parts = policyStartDate.split("-");
        const day = parseInt(parts[1], 10);
    
        const getMonthMealQuantity = async (month, currentDay) => {
            const monthMealsCollectionRef = fire.firestore()
                .collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc(month)
                .collection(`${month}Meals`);
    
            const doc = await monthMealsCollectionRef.doc(meal).get();
            if (doc.exists) {
                totalFromGetMonthTotal += doc.data().qty || 0;
            }
        };
    
        const checkPreviousMonths = async (startPointNumber) => {
            // PRICE TOTAL VARIABLE
            totalFromCheckPreviousMonths = 0;
    
            for (let i = startPointNumber - 1; i > 0; i--) {
                const doc = await fire.firestore()
                    .collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("members")
                    .collection("full_list")
                    .doc(this.state.userID)
                    .collection("orders")
                    .doc(`month${i}`)
                    .collection(`month${i}Meals`)
                    .doc(meal)
                    .get();
    
                if (doc.exists) {
                    totalFromCheckPreviousMonths += doc.data().qty || 0;
                }
            }
        };
    
        const checkCurrentMonth = async () => {

            totalFromCurrentMonth = 0;

            const doc = await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisMonth")
            .collection("monthlyMeals")
            .doc(meal)
            .get();
            if (doc.exists) {
                totalFromCurrentMonth += doc.data().qty || 0;
            }

        };
    
        try {
            const doc = await fire.firestore()
            .collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc(`month${startPoint}`)
            .get();
    
            if (doc.exists) {
                await getMonthMealQuantity(`month${startPoint}`, day);
            }
    
            await checkPreviousMonths(startPoint);
            await checkCurrentMonth();
    
            // Combine the totals and return the result
            const combinedTotal = totalFromGetMonthTotal + totalFromCheckPreviousMonths + totalFromCurrentMonth;
            return combinedTotal;
        } catch (error) {
            console.error("Error getting document:", error);
        }
    };
    
    checkOrderPeriodsForEarningPolicy = (policyStartDate, policyEndDate) => {
        let searchingOrderPeriods = []

            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)
        

            //* - - ORDER DATE - - *//
        let ordrDate = this.state.dateOfPurchase.split(' ')[0];
        let components = ordrDate.split('/');
        const orderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //! - - THIS DAY CHECK - - *//
        if (policyStartDate === orderDate && policyEndDate === orderDate && orderDate == formattedDate) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("thisDay")
            // })
            searchingOrderPeriods.push("thisDay")
        } 

            //! - - THIS WEEK CHECK - - *// 
            //* If we put this week in the array - we are searching the WHOLE week.
        let weekStarting = this.getFirstDayOfWeek(formattedDate)
        let weekEnding = this.getLastDayOfWeek(formattedDate)
        if (this.isDateBetween(weekStarting, weekEnding, orderDate)) {
            // if (!this.state.searchingOrderPeriods.includes("thisWeek")) {
            //     this.setState({
            //         searchingOrderPeriods: this.state.searchingOrderPeriods.push("thisWeek")
            //     })
            // }
            searchingOrderPeriods.push("thisWeek")
        }

            //! - - THIS MONTH CHECK - - *//
        let monthStarting = this.getFirstDayOfMonth(formattedDate)
        let monthEnding = this.getLastDayOfMonth(formattedDate)
        if ((this.isDateBetween(policyStartDate, policyEndDate, monthStarting) || this.isDateBetween(monthStarting, monthEnding, orderDate)) && this.isDateBefore(formattedDate, policyEndDate)) {
            // if (!this.state.searchingOrderPeriods.includes("thisMonth")) {
            //     this.setState({
            //         searchingOrderPeriods: this.state.searchingOrderPeriods.push("thisMonth")
            //     })
            // }
            searchingOrderPeriods.push("thisMonth")
        }

            //! - - MONTH 1 CHECK - - *//
        let month1Starting = this.getFirstDayXMonthsPrior(formattedDate, 1)
        let month1Ending = this.getLastDayXMonthsPrior(formattedDate, 1)
        if (this.isDateBetween(month1Starting, month1Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month1")
            // })
            searchingOrderPeriods.push("month1")
        }

            //! - - MONTH 2 CHECK - - *//
        let month2Starting = this.getFirstDayXMonthsPrior(formattedDate, 2)
        let month2Ending = this.getLastDayXMonthsPrior(formattedDate, 2)
        if (this.isDateBetween(month2Starting, month2Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month2")
            // })
            searchingOrderPeriods.push("month2")
        }

            //! - - MONTH 3 CHECK - - *//
        let month3Starting = this.getFirstDayXMonthsPrior(formattedDate, 3)
        let month3Ending = this.getLastDayXMonthsPrior(formattedDate, 3)
        if (this.isDateBetween(month3Starting, month3Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month3")
            // })
            searchingOrderPeriods.push("month3")
        }

            //! - - MONTH 4 CHECK - - *//
        let month4Starting = this.getFirstDayXMonthsPrior(formattedDate, 4)
        let month4Ending = this.getLastDayXMonthsPrior(formattedDate, 4)
        if (this.isDateBetween(month4Starting, month4Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month4")
            // })
            searchingOrderPeriods.push("month4")
        }

            //! - - MONTH 5 CHECK - - *//
        let month5Starting = this.getFirstDayXMonthsPrior(formattedDate, 5)
        let month5Ending = this.getLastDayXMonthsPrior(formattedDate, 5)
        if (this.isDateBetween(month5Starting, month5Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month5")
            // })
            searchingOrderPeriods.push("month5")
        }

            //! - - MONTH 6 CHECK - - *//
        let month6Starting = this.getFirstDayXMonthsPrior(formattedDate, 6)
        let month6Ending = this.getLastDayXMonthsPrior(formattedDate, 6)
        if (this.isDateBetween(month6Starting, month6Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month6")
            // })
            searchingOrderPeriods.push("month6")
        }

            //! - - MONTH 7 CHECK - - *//
        let month7Starting = this.getFirstDayXMonthsPrior(formattedDate, 7)
        let month7Ending = this.getLastDayXMonthsPrior(formattedDate, 7)
        if (this.isDateBetween(month7Starting, month7Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month7")
            // })
            searchingOrderPeriods.push("month7")
        }

            //! - - MONTH 8 CHECK - - *//
        let month8Starting = this.getFirstDayXMonthsPrior(formattedDate, 8)
        let month8Ending = this.getLastDayXMonthsPrior(formattedDate, 8)
        if (this.isDateBetween(month8Starting, month8Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month8")
            // })
            searchingOrderPeriods.push("month8")
        }

            //! - - MONTH 9 CHECK - - *//
        let month9Starting = this.getFirstDayXMonthsPrior(formattedDate, 9)
        let month9Ending = this.getLastDayXMonthsPrior(formattedDate, 9)
        if (this.isDateBetween(month9Starting, month9Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month9")
            // })
            searchingOrderPeriods.push("month9")
        }

            //! - - MONTH 10 CHECK - - *//
        let month10Starting = this.getFirstDayXMonthsPrior(formattedDate, 10)
        let month10Ending = this.getLastDayXMonthsPrior(formattedDate, 10)
        if (this.isDateBetween(month10Starting, month10Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month10")
            // })
            searchingOrderPeriods.push("month10")
        }

            //! - - MONTH 3 CHECK - - *//
        let month11Starting = this.getFirstDayXMonthsPrior(formattedDate, 11)
        let month11Ending = this.getLastDayXMonthsPrior(formattedDate, 11)
        if (this.isDateBetween(month11Starting, month11Ending, policyStartDate) && this.isDateBefore(formattedDate, policyEndDate)) {
            // this.setState({
            //     searchingOrderPeriods: this.state.searchingOrderPeriods.push("month11")
            // })
            searchingOrderPeriods.push("month11")
        }


        if (searchingOrderPeriods.length > 1 && searchingOrderPeriods.includes("thisWeek") && searchingOrderPeriods.includes("thisMonth")) {
            searchingOrderPeriods = searchingOrderPeriods.filter(item => item !== "thisMonth")
        } else if (searchingOrderPeriods.length > 1 && searchingOrderPeriods.includes("thisDay") && searchingOrderPeriods.includes("thisMonth")) {
            searchingOrderPeriods = searchingOrderPeriods.filter(item => item !== "thisMonth")
        }

        // if (searchingOrderPeriods.length <= 2 && searchingOrderPeriods.includes("thisWeek") && searchingOrderPeriods.includes("thisMonth")) {
        //     searchingOrderPeriods = searchingOrderPeriods.filter(item => item !== "thisMonth")
        // }

        return searchingOrderPeriods
    }  
    
    isDateBefore = (date1, date2) => {
        // Convert date strings to Date objects
        const dateObject1 = new Date(date1);
        const dateObject2 = new Date(date2);
    
        // Compare the two dates
        return dateObject1 <= dateObject2;
    }

    isDateBeforeOnly = (date1, date2) => {
        // Convert date strings to Date objects
        const dateObject1 = new Date(date1);
        const dateObject2 = new Date(date2);

        // Compare the two dates
        return dateObject1 < dateObject2;
    }

    getFirstDayXMonthsPrior = (inputDate, months) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
      
        // Set the date to the first day of the current month
        date.setDate(1);
      
        // Subtract two months to get the first day of the month two months prior
        date.setMonth(date.getMonth() - months);
      
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
      
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
      
        return formattedResult;
    }

    getLastDayXMonthsPrior = (inputDate, months) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
    
        // Subtract months and handle negative values
        const newMonth = date.getMonth() - months + 1;
        date.setMonth(newMonth >= 0 ? newMonth : 0);
    
        // Set the date to the last day of the calculated month
        date.setDate(0);
    
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
    
        return formattedResult;
    }

    getFirstDayNextXMonths = (inputDate, months) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
      
        // Set the date to the first day of the current month
        date.setDate(1);
      
        // Add X months to get the first day of the month X months in the future
        date.setMonth(date.getMonth() + months);
      
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
      
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
      
        return formattedResult;
    }

    getFirstDayOfMonth = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
      
        // Set the date to the first day of the month
        date.setDate(1);
      
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
      
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
      
        return formattedResult;
    }

    getLastDayOfMonth = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
      
        // Set the date to the first day of the next month
        date.setMonth(date.getMonth() + 1, 1);
      
        // Subtract one day to get the last day of the current month
        date.setDate(date.getDate() - 1);
      
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
      
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
      
        return formattedResult;
    }

    getFirstDayOfWeek = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
    
        // Calculate the difference in days between the current day and Monday
        let diff = date.getDay() - 1;
    
        // If the current day is Sunday (0), set the difference to 6 (to get the previous Monday)
        if (diff === -1) {
            diff = 6;
        }
    
        // Adjust the date to get the first day (Monday) of the week
        date.setDate(date.getDate() - diff);
    
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
    
        return formattedResult;
    }

    getLastDayOfWeek = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
    
        // Check if the input date is a Sunday
        if (date.getDay() === 0) {
            // If it's a Sunday, set the date to the previous Monday
            date.setDate(date.getDate());
        } else {
            // Find the last day of the week (Sunday) following the given date
            date.setDate(date.getDate() + (6 - date.getDay()) + 1);
        }
    
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
    
        return formattedResult;
    }

    calculateTimeDifference = () => {
        // const { startDate, endDate } = this.state;

        let startDate = "11/23/2023"
        let endDate  = "12/24/2023"
    
        // Parse the date strings into Date objects
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
    
        // Calculate the time difference in milliseconds
        const timeDifferenceInMs = endDateObj - startDateObj;
    
        // Convert milliseconds to days, weeks, and months
        const days = Math.floor(timeDifferenceInMs / (1000 * 60 * 60 * 24));
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
    
        // Determine the appropriate time unit
        let timeUnit;
        let timeValue;
        if (months >= 1) {
          timeUnit = 'month';
          timeValue = months;
        } else if (weeks >= 1) {
          timeUnit = 'week';
          timeValue = weeks;
        } else {
          timeUnit = 'day';
          timeValue = days;
        }
    
        // Create a string representation of the time difference
        const timeDifferenceString = `${timeValue} ${timeUnit}${timeValue !== 1 ? 's' : ''}`;
    
        // Update the state with the calculated time difference
        console.log(`TIME GAP: ${timeDifferenceString}`)
        this.setState({ timeDifference: timeDifferenceString });
    };

    formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    }

    isDateBetween = (startDate, endDate, checkDate) => {
        // Convert date strings to Date objects
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        checkDate = new Date(checkDate);
    
        // Check if checkDate is between startDate and endDate
        return startDate <= checkDate && checkDate <= endDate;
    }

    getDayOfWeek = (weekStartingDate, endingDate, checkDate) => {
        // Convert input strings to Date objects
        const startDate = new Date(weekStartingDate);
        const endDate = new Date(endingDate);
        const dateToCheck = new Date(checkDate);
    
        // Ensure checkDate is within the specified week range
        if (dateToCheck >= startDate && dateToCheck <= endDate) {
        // Get the day of the week (0 - 6, where Sunday is 0)
        const dayOfWeek = dateToCheck.getDay();
    
        // Convert Sunday (0) to 7
        return dayOfWeek === 0 ? 7 : dayOfWeek;
        } else {
        // If checkDate is outside the specified week range, return null or an appropriate value
        return null;
        }
    }

    getDayOfMonth = (monthStartingDate, monthEndingDate, checkDate) => {
        // Convert input strings to Date objects
        const startDate = new Date(monthStartingDate);
        const endDate = new Date(monthEndingDate);
        const dateToCheck = new Date(checkDate);
      
        // Ensure checkDate is within the specified month range
        if (dateToCheck >= startDate && dateToCheck <= endDate) {
          // Get the day of the month (1 - 31)
          const dayOfMonth = dateToCheck.getDate();
      
          return dayOfMonth;
        } else {
          // If checkDate is outside the specified month range, return null or an appropriate value
          return null;
        }
    }

    thisDaySaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (formattedDate == newFormatOrderDate) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisDay")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisDay")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let todayMealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisDay")
            .collection("todayMeals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost)
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("thisDay")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let todayMealDocumentRef = todayMealCollectionRef.doc(order.item)
                    let todayMealPromise = todayMealDocumentRef
                    .get().then(async doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return todayMealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return todayMealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return todayMealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, todayMealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    thisWeekSaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF CURRENT WEEK - - *//
        let weekStarting = this.getFirstDayOfWeek(formattedDate)
        let weekEnding = this.getLastDayOfWeek(formattedDate)

        console.log(`WEEK STARTING: ${weekStarting}` )
        console.log(`WEEK ENDING: ${weekEnding}` )

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(weekStarting, weekEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })
            
            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisWeek")
    
            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisWeek")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")
    
            let weeklyMealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisWeek")
            .collection("weeklyMeals")

            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        weekStarting: weekStarting,
                        weekEnding: weekEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("thisWeek")
                .collection("weeklySpend")

                let weekSpendingDate = this.getDayOfWeek(weekStarting, weekEnding, newFormatOrderDate)
                console.log(weekSpendingDate)

                return priceSpendPromise.doc("1")
                .get().then(doc => {
                    if (doc.exists) {
                        return priceSpendPromise.doc(weekSpendingDate.toString())
                            .get().then(doc => {
                                const currentTotal = doc.data().total || 0;
                                const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                                return priceSpendPromise.doc(weekSpendingDate.toString())
                                    .update({
                                        total: updatedTotal
                                    })
                            })
                    } else {
                        // Use Array.from to generate an array of length 7
                        const dayNumbers = Array.from({ length: 7 }, (_, i) => i + 1);

                        // Create an array of promises for setting values in parallel
                        const dayPromises = dayNumbers.map(dayNumber =>
                            priceSpendPromise.doc(`${dayNumber}`)
                                .set({
                                    total: 0
                                })
                        );

                        // Execute promises in parallel
                        return Promise.all(dayPromises)
                            .then(() => {
                                // Update the total for the specific day
                                return priceSpendPromise.doc(weekSpendingDate.toString())
                                    .update({
                                        total: parseInt(this.state.totalCost)
                                    });
                            });
                    }
                })
                .then(() => {
                    promises.push(priceSpendPromise);

                    const listSetPromise = fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("members")
                    .collection("full_list")
                    .doc(this.state.userID)
                    .collection("orders")
                    .doc("thisWeek")
                    .collection("list")
                    .doc(orderDocumentID)
                    .set({
                        id: orderDocumentID,
                        total: parseInt(this.state.totalCost),
                        date: newFormatOrderDate,
                        earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                        earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                        earningPolicy: this.state.earningPolicy,
                        earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                    })
                    promises.push(listSetPromise)
                    for (let i = 0; i < this.state.menuOrders.length; i++) {
                        const order = this.state.menuOrders[i]
                        let orderPromise = ordersCollection
                        .doc(order.item)
                        .set({
                            date: newFormatOrderDate,
                            item: order.item,
                            qty: order.qty,
                            category: order.category
                        })
                        let weeklyMealDocumentRef = weeklyMealCollectionRef.doc(order.item)
                        let weeklyMealPromise = weeklyMealDocumentRef
                        .get().then(async doc => {
                            if (doc.exists) {
                                const currentQuantity = doc.data().qty || 0;
                                const updatedQuantity = currentQuantity + parseInt(order.qty)
                                const typeOfUpdatedQuantity = typeof updatedQuantity;
                                // Check the type and update the document accordingly
                                if (typeOfUpdatedQuantity === 'number') {
                                // Perform the update with confidence that updatedQuantity is a number
                                return weeklyMealDocumentRef.update({
                                    qty: updatedQuantity
                                });
                                } else {
                                    alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                                }
                                // return weeklyMealDocumentRef.update({
                                //     qty: updatedQuantity
                                // });
                            } else {
                                return weeklyMealDocumentRef
                                .set({
                                    qty: parseInt(order.qty)
                                })
                            }
                        })
                        promises.push(orderPromise, weeklyMealPromise);
                    }
                    return Promise.all(promises);
                })
            });      
        }
    }

    thisMonthSaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF CURRENT MONTH - - *//
        let monthStarting = this.getFirstDayOfMonth(formattedDate)
        let monthEnding = this.getLastDayOfMonth(formattedDate)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisMonth")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisMonth")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let monthlyMealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("thisMonth")
            .collection("monthlyMeals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("thisMonth")
                .collection("monthlySpend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("thisMonth")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let monthlyMealDocumentRef = monthlyMealCollectionRef.doc(order.item)
                    let monthlyMealPromise = monthlyMealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return monthlyMealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return monthlyMealDocumentRef.update({
                            //     total: updatedQuantity
                            // });
                        } else {
                            return monthlyMealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, monthlyMealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month1SaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 1)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 1)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })


            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month1")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month1")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month1MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month1")
            .collection("month1Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month1")
                .collection("month1Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month1")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month1MealDocumentRef = month1MealCollectionRef.doc(order.item)
                    let month1MealPromise = month1MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month1MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month1MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month1MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month1MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month2SaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 2)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 2)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month2")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month2")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month2MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month2")
            .collection("month2Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month2")
                .collection("month2Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month2")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month2MealDocumentRef = month2MealCollectionRef.doc(order.item)
                    let month2MealPromise = month2MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month2MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month2MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month2MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month2MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month3SaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 3)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 3)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month3")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month3")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month3MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month3")
            .collection("month3Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month3")
                .collection("month3Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month3")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month3MealDocumentRef = month3MealCollectionRef.doc(order.item)
                    let month3MealPromise = month3MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month3MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month3MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month3MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month3MealPromise);
                }
                return Promise.all(promises);
            })
        } else {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month3")
            .get().then(doc => {
                if (!doc.exists) {
                    
                }
            })
        }
    }

    month4SaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 4)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 4)

        console.log(monthStarting)
        console.log(monthEnding)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month4")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month4")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month4MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month4")
            .collection("month4Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month4")
                .collection("month4Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month4")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month4MealDocumentRef = month4MealCollectionRef.doc(order.item)
                    let month4MealPromise = month4MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month4MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month4MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month4MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month4MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month5SaveInfo = () => {
        //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 5)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 5)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month5")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month5")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month5MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month5")
            .collection("month5Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month5")
                .collection("month5Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month5")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month5MealDocumentRef = month5MealCollectionRef.doc(order.item)
                    let month5MealPromise = month5MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month5MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month5MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month5MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month5MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month6SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 6)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 6)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month6")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month6")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month6MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month6")
            .collection("month6Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month6")
                .collection("month6Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month6")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month6MealDocumentRef = month6MealCollectionRef.doc(order.item)
                    let month6MealPromise = month6MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month6MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month6MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month6MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month6MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month7SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 7)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 7)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month7")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month7")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month7MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month7")
            .collection("month7Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month7")
                .collection("month7Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month7")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month7MealDocumentRef = month7MealCollectionRef.doc(order.item)
                    let month7MealPromise = month7MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month7MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month7MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month7MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month7MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month8SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 8)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 8)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month8")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month8")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month8MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month8")
            .collection("month8Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month8")
                .collection("month8Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month8")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month8MealDocumentRef = month8MealCollectionRef.doc(order.item)
                    let month8MealPromise = month8MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month8MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month8MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month8MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month8MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month9SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 9)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 9)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month9")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month9")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month9MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month9")
            .collection("month9Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month9")
                .collection("month9Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month9")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month9MealDocumentRef = month9MealCollectionRef.doc(order.item)
                    let month9MealPromise = month9MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month9MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month9MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month9MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month9MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month10SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 10)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 10)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month10")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month10")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month10MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month10")
            .collection("month10Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month10")
                .collection("month10Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month10")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month10MealDocumentRef = month10MealCollectionRef.doc(order.item)
                    let month10MealPromise = month10MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month10MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month10MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month10MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month10MealPromise);
                }
                return Promise.all(promises);
            })
        }
    }

    month11SaveInfo = () => {
            //* - - CURRENT DATE - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)

            //* - - GET FIRST AND LAST DAY OF PREVIOUS MONTH - - *//
        let monthStarting = this.getFirstDayXMonthsPrior(formattedDate, 11)
        let monthEnding = this.getLastDayXMonthsPrior(formattedDate, 11)

            //* - - ORDER DATE - - *//
        let orderDate = this.state.dateOfPurchase.split(' ')[0];
        let components = orderDate.split('/');
        const newFormatOrderDate = `${components[0]}-${components[1]}-20${components[2]}`;

            //* - - ORDER DOCUMENT ID - - *//
        let orderDocumentID = `order-${this.state.dateOfPurchase.replace(/[\/:]/g, '-')}`
        orderDocumentID = orderDocumentID.replace(/ /g, '-')

        if (this.isDateBetween(monthStarting, monthEnding, newFormatOrderDate)) {

            let userRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            
            userRef.get().then(async doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    const typeOfUpdatedTotal = typeof updatedTotal;
                        // Check the type and update the document accordingly
                    if (typeOfUpdatedTotal === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                        return await userRef.update({
                            total: updatedTotal
                        });
                    }
                } else {
                    return await userRef.set({
                        total: parseInt(this.state.totalCost),
                        name: this.state.userName,
                        userID: this.state.userID
                    })
                }
            })

            let currentDocRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month11")

            let ordersCollection = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month11")
            .collection("list")
            .doc(orderDocumentID)
            .collection("list")

            let month11MealCollectionRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("members")
            .collection("full_list")
            .doc(this.state.userID)
            .collection("orders")
            .doc("month11")
            .collection("month11Meals")
            return currentDocRef.get().then(doc => {
                let updatePromise;
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                    updatePromise = currentDocRef.update({
                        total: updatedTotal
                    })
                } else {
                    updatePromise = currentDocRef.set({
                        currentDate: formattedDate,
                        total: parseInt(this.state.totalCost),
                        monthStarting: monthStarting,
                        monthEnding: monthEnding
                    })
                }
                return updatePromise
            })
            .then(() => { 
                const promises = [];
                const priceSpendPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month11")
                .collection("month11Spend")

                let monthSpendingDate = this.getDayOfMonth(monthStarting, monthEnding, newFormatOrderDate)

                priceSpendPromise.doc("1")
                .get().then(doc =>{
                    if (doc.exists) {
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .get().then(doc => {
                            const currentTotal = doc.data().total || 0;
                            const updatedTotal = currentTotal + parseInt(this.state.totalCost)
                            return priceSpendPromise.doc(monthSpendingDate.toString())
                            .update({
                                total: updatedTotal
                            })
                        })
                    } else {
                        for (let i = 1; i < 32; i++) {
                            priceSpendPromise.doc(`${[i]}`)
                            .set({
                                total: 0
                            })
                        }
                        priceSpendPromise.doc(monthSpendingDate.toString())
                        .update({
                            total: parseInt(this.state.totalCost)
                        })
                    }
                })
                promises.push(priceSpendPromise)
                const listSetPromise = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(this.state.userID)
                .collection("orders")
                .doc("month11")
                .collection("list")
                .doc(orderDocumentID)
                .set({
                    id: orderDocumentID,
                    total: parseInt(this.state.totalCost),
                    date: newFormatOrderDate,
                    earningPolicyPointsValue: this.state.earningPolicyPointsValue,
                    earningPolicyMoneyValue: this.state.earningPolicyMoneyValue,
                    earningPolicy: this.state.earningPolicy,
                    earningPolicyPercentageChange: this.state.earningPolicyPercentageChange
                })
                promises.push(listSetPromise)
                for (let i = 0; i < this.state.menuOrders.length; i++) {
                    const order = this.state.menuOrders[i]
                    let orderPromise = ordersCollection
                    .doc(order.item)
                    .set({
                        date: newFormatOrderDate,
                        item: order.item,
                        qty: order.qty,
                        category: order.category
                    })
                    let month11MealDocumentRef = month11MealCollectionRef.doc(order.item)
                    let month11MealPromise = month11MealDocumentRef
                    .get().then(doc => {
                        if (doc.exists) {
                            const currentQuantity = doc.data().qty || 0;
                            const updatedQuantity = currentQuantity + parseInt(order.qty)
                            const typeOfUpdatedQuantity = typeof updatedQuantity;
                            // Check the type and update the document accordingly
                            if (typeOfUpdatedQuantity === 'number') {
                            // Perform the update with confidence that updatedQuantity is a number
                            return month11MealDocumentRef.update({
                                qty: updatedQuantity
                            });
                            } else {
                                alert(`Error: updatedQuantity is not a number. Type: ${typeOfUpdatedQuantity}`);
                            }
                            // return month11MealDocumentRef.update({
                            //     qty: updatedQuantity
                            // });
                        } else {
                            return month11MealDocumentRef
                            .set({
                                qty: parseInt(order.qty)
                            })
                        }
                    })
                    promises.push(orderPromise, month11MealPromise);
                }
                return Promise.all(promises);
            })
        }
        console.log("last add completed")
    }

    renderValidEarningPolicies = () => {
        if (this.state.validEarningPolicies.length !== 0) {
            return (
                <div>
                    {this.state.validEarningPolicies.map((item, index) => (
                        <div key={index}>{item}</div>
                    ))}
                </div>
            )
        }
    }

        //* - - POINTS MANAGER - - *//

    saveRewardData = async () => {
        this.setState({
            showPointsClickedInfo: false,
            showPointsRedeemLoading: true
        })

        await this.pushRedeemRewardToVerified()
        await this.pushDataToRewards()

        this.setState({
            showPointsRedeemLoading: false,
            showPointsRedeemPlaceholder: true
        })

    }

    pushRedeemRewardToVerified = async () => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("verified")
        .collection("list")
        .doc(this.state.rewardRedeemID)
        .set({
            bgColor: "white",
            customerRewardValue: this.state.rewardCustomerValue,
            date: this.state.rewardDateDatabase,
            email: this.state.rewardUserEmail,
            id: this.state.rewardRedeemID,
            name: this.state.rewardUserName,
            rewardDiscountPrice: this.state.rewardDiscountPrice,
            rewardName: this.state.rewardName,
            rewardPoints: this.state.rewardPointsValue,
            rewardType: this.state.rawRewardType,
            rewardValue: this.state.rewardValue,
            userID: this.state.rewardUserID
        })
    }

    pushDataToRewards = async () => {
        let orderDate = this.state.rewardDateDatabase.split(' ')[0];
        let components = orderDate.split('-');

        let month
        let year = components[2]
        let day = components[1]

        if (components[0] === "01") {
            month = "jan"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "02") {
            month = "feb"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "03") {
            month = "mar"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "04") {
            month = "apr"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "05") {
            month = "may"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "06") {
            month = "jun"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "07") {
            month = "jul"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "08") {
            month = "aug"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "09") {
            month = "sep"
            day = day.slice(1)
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "10") {
            month = "oct"
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "11") {
            month = "nov"
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        } else if (components[0] === "12") {
            month = "dec"
            await this.pushRewardMemberData(year, month, day)
            this.pushRewardData(year, month, day)
        }
    }

    pushRewardMemberData = async (year, month, day) => {

        const promises = []

            //* - - YEARLY DATA PUSH - - *//

        const rewardMemberYearRedeemDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc("activity")
        .collection(this.state.rewardUserID)
        .doc("redeem")

        const rewardMemberYearRedeemDataPromise = rewardMemberYearRedeemDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardRedeemed = doc.data().rewards
                const updatedRewardRedeemed = currentRewardRedeemed + 1

                const currentPointsUsed = doc.data().pointsUsed
                const updatedPointsUsed = currentPointsUsed + this.state.rewardPointsValue
                
                rewardMemberYearRedeemDataRef.update({
                    rewards: updatedRewardRedeemed, 
                    pointsUsed: updatedPointsUsed
                })
            } else {
                rewardMemberYearRedeemDataRef.set({
                    rewards: 1,
                    pointsUsed: this.state.rewardPointsValue
                })
            }
        })

        promises.push(rewardMemberYearRedeemDataPromise)

        const rewardMemberYearSaveRewardRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc("activity")
        .collection(this.state.rewardUserID)
        .doc("rewards")
        .collection(this.state.rewardName)
        .doc(this.state.rewardNameID)

        const rewardMemberYearSaveRewardPromise = rewardMemberYearSaveRewardRef.set({
            date: this.state.rewardDateDatabase,
            rewardName: this.state.rewardName,
            rewardNameID: this.state.rewardNameID,
            rewardType: this.state.rewardType,
            rewardValue: this.state.rewardValue,
            pointsToRedeem: this.state.rewardPointsValue,
            customerRewardValue: this.state.rewardCustomerValue
        })

        promises.push(rewardMemberYearSaveRewardPromise)

            //* - - MONTHLY DATA PUSH - - *//

        const rewardMemberMonthlyRedeemDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc(month)
        .collection("0activity")
        .doc(this.state.rewardUserID)
        
        const rewardMemberMonthlyRedeemDataPromise = rewardMemberMonthlyRedeemDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardRedeemed = doc.data().rewards
                const updatedRewardRedeemed = currentRewardRedeemed + 1

                const currentPointsUsed = doc.data().pointsUsed
                const updatedPointsUsed = currentPointsUsed + this.state.rewardPointsValue

                rewardMemberMonthlyRedeemDataRef.update({
                    rewards: updatedRewardRedeemed,
                    pointsUsed: updatedPointsUsed
                })
            } else {
                rewardMemberMonthlyRedeemDataRef.set({
                    rewards: 1,
                    pointsUsed: this.state.rewardPointsValue
                })
            }
        })

        promises.push(rewardMemberMonthlyRedeemDataPromise)

        const rewardMemberMonthlySaveRewardRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc(month)
        .collection(day)
        .doc(this.state.rewardUserID)
        .collection(this.state.rewardName)
        .doc(this.state.rewardNameID)

        const rewardMemberMonthlySaveRewardPromise = rewardMemberMonthlySaveRewardRef.set({
            date: this.state.rewardDateDatabase,
            rewardName: this.state.rewardName,
            rewardNameID: this.state.rewardNameID,
            rewardType: this.state.rewardType,
            rewardValue: this.state.rewardValue,
            pointsToRedeem: this.state.rewardPointsValue,
            customerRewardValue: this.state.rewardCustomerValue
        })

        promises.push(rewardMemberMonthlySaveRewardPromise)

            //* - - DAILY DATA PUSH - - *//

        const rewardMemberDayRedeemDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc(month)
        .collection(day)
        .doc(this.state.rewardUserID)
        
        const rewardMemberDayRedeemDataPromise = rewardMemberDayRedeemDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardRedeemed = doc.data().rewards
                const updatedRewardRedeemed = currentRewardRedeemed + 1

                const currentPointsUsed = doc.data().pointsUsed
                const updatedPointsUsed = currentPointsUsed + this.state.rewardPointsValue

                rewardMemberDayRedeemDataRef.update({
                    rewards: updatedRewardRedeemed,
                    pointsUsed: updatedPointsUsed
                })
            } else {
                rewardMemberDayRedeemDataRef.set({
                    rewards: 1,
                    pointsUsed: this.state.rewardPointsValue
                })
            }
        })

        promises.push(rewardMemberDayRedeemDataPromise)

        const rewardMemberDaySaveRewardRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("members")
        .collection(year)
        .doc(month)
        .collection(day)
        .doc(this.state.rewardUserID)
        .collection(this.state.rewardName)
        .doc(this.state.rewardNameID)
        
        const rewardMemberDaySaveRewardPromise = rewardMemberDaySaveRewardRef.set({
            date: this.state.rewardDateDatabase,
            rewardName: this.state.rewardName,
            rewardNameID: this.state.rewardNameID,
            rewardType: this.state.rewardType,
            rewardValue: this.state.rewardValue,
            pointsToRedeem: this.state.rewardPointsValue,
            customerRewardValue: this.state.rewardCustomerValue
        })

        promises.push(rewardMemberDaySaveRewardPromise)

        Promise.all(promises)
    }

    pushRewardData = async (year, month, day) => {

        const promises = []

        const rewardYearTotalDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc("0total")

        const rewardyearTotalDataPromise = rewardYearTotalDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedDataTotal = currentRewardTotal + 1

                rewardYearTotalDataRef.update({
                    total: updatedDataTotal
                })
            } else {
                rewardYearTotalDataRef.set({
                    total: 1,
                })
            }
        })

        promises.push(rewardyearTotalDataPromise)

        const rewardYearRewardDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc("activity")
        .collection("total")
        .doc(this.state.rewardName)

        const rewardYearRewardDataPromise = rewardYearRewardDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedRewardTotal = currentRewardTotal + 1

                rewardYearRewardDataRef.update({
                    total: updatedRewardTotal
                })
            } else {
                rewardYearRewardDataRef.set({
                    total: 1,
                    date: this.state.rewardDateDatabase,
                    rewardName: this.state.rewardName,
                    rewardType: this.state.rewardType,
                    rewardValue: this.state.rewardValue,
                    pointsToRedeem: this.state.rewardPointsValue,
                    customerRewardValue: this.state.rewardCustomerValue
                })
            }
        })
        promises.push(rewardYearRewardDataPromise)

            //* - - MONTHLY DATA PUSH - - *//
        
        const rewardMonthlyTotalDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc(month)
        
        const rewardMonthlyTotalDataPromise = rewardMonthlyTotalDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedRewardTotal = currentRewardTotal + 1

                rewardMonthlyTotalDataRef.update({
                    total: updatedRewardTotal
                })
            } else {
                rewardMonthlyTotalDataRef.set({
                    total: 1
                })
            }
        })

        promises.push(rewardMonthlyTotalDataPromise)

        const rewardMonthlyRewardDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc(month)
        .collection("0activity")
        .doc(this.state.rewardName)
        
        const rewardMonthlyRewardDataPromise = rewardMonthlyRewardDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedRewardTotal = currentRewardTotal + 1

                rewardMonthlyRewardDataRef.update({
                    total: updatedRewardTotal
                })
            } else {
                rewardMonthlyRewardDataRef.set({
                    total: 1,
                    date: this.state.rewardDateDatabase,
                    rewardName: this.state.rewardName,
                    rewardType: this.state.rewardType,
                    rewardValue: this.state.rewardValue,
                    pointsToRedeem: this.state.rewardPointsValue,
                    customerRewardValue: this.state.rewardCustomerValue
                })
            }
        })

        promises.push(rewardMonthlyRewardDataPromise)

            //* - - DAILY DATA PUSH - - *//

        const rewardDayTotalDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc(month)
        .collection(day)
        .doc("0total")

        const rewardDayTotalDataPromise = rewardDayTotalDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedRewardTotal = currentRewardTotal + 1

                rewardDayTotalDataRef.update({
                    total: updatedRewardTotal
                })
            } else {
                rewardDayTotalDataRef.set({
                    total: 1
                })
            }
        })

        promises.push(rewardDayTotalDataPromise)

        const rewardDayRewardDataRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("rewards")
        .collection("redeemed")
        .doc("rewards")
        .collection(year)
        .doc(month)
        .collection(day)
        .doc(this.state.rewardName)

        const rewardDayRewardDataPromise = rewardDayRewardDataRef.get().then(doc => {
            if (doc.exists) {
                const currentRewardTotal = doc.data().total
                const updatedRewardTotal = currentRewardTotal + 1

                rewardDayRewardDataRef.update({
                    total: updatedRewardTotal
                })
            } else {
                rewardDayRewardDataRef.set({
                    total: 1,
                    date: this.state.rewardDateDatabase,
                    rewardName: this.state.rewardName,
                    rewardType: this.state.rewardType,
                    rewardValue: this.state.rewardValue,
                    pointsToRedeem: this.state.rewardPointsValue,
                    customerRewardValue: this.state.rewardCustomerValue
                })
            }
        })

        promises.push(rewardDayRewardDataPromise)

        Promise.all(promises)

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .update({
            lastClicked: ""
        })
        .then(() => {
            this.setState({
                prevClickedPoints: ""
            })
        })

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(this.state.rewardRedeemID)
        .delete()
        .then(() => {
            this.loadPointsRedeemed()
        })
    }

        //* - - MEMBER SEARCH - - *//

    handleSearch = async (value) => {
        if (value) {
            if (this.state.showMembersBtns === true) {
                this.setState({
                    showMembersBtns: false,
                    membersLastDisplayed: "Members Btn"
                })
            } else if (this.state.showSegmentDashboard === true) {
                this.setState({
                    showSegmentDashboard: false,
                    membersLastDisplayed: "Members Dashboard"
                })
            }
            this.setState({ searchTerm: value});
    
            // Perform the search
            const results = await this.searchFirestore(value);
        
            // Debugging: Print the search results to console
            this.setState({ searchResults: results });
        } else {
            if (this.state.membersLastDisplayed === "Members Btn") {
                this.setState({
                    showMembersBtns: true
                })
            } else if (this.state.membersLastDisplayed === "Members Dashboard") {
                this.setState({
                    showSegmentDashboard: true
                })
            }
            this.setState({
                searchTerm: "",
                searchResults: [],
            })
        }
        
    };
        
    searchFirestore = async (searchTerm) => {
        if (searchTerm !== "") {
            try {
                const snapshot = await fire.firestore()
                    .collection("clients")
                    .doc("artcaffe")
                    .collection("members")
                    .doc("members_list")
                    .collection('search_list')
                    .doc(searchTerm.charAt(0).toUpperCase())
                    .collection('list')
                    .get();
        
                const results = snapshot.docs.map(doc => ({
                    key: `💳 - ${doc.data().key}`,
                    value: `${doc.data().value}`,
                    id: doc.data().id,
                }));
        
                return results;
            } catch (error) {
                console.error('Error searching Firestore:', error);
                return [];
            }
        }
    };

    searchResultClicked = (userID) => {
        if (userID !== "") {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(userID)
            .collection("data")
            .doc("pointsInfo")
            .get().then(doc => {
                this.setState({
                    memberCurrentTotalPoints: Math.round(doc.data().points)
                })
            }) 

            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(userID)
            .get().then(doc => {
                this.setState({
                    memberCurrentCardNumber: doc.data().cardNumber,
                    memberCurrentFirstName: doc.data().firstName,
                    memberCurrentLastName: doc.data().lastName,
                    memberPhoneNumber: doc.data().phone,
                    memberLastActive: doc.data().lastActive,
                    memberRegistrationDate: doc.data().registrationDate,
                    memberVerificationStatus: doc.data().verified ? "Verified" : "Not verified"
                })
            })
            this.setState({
                searchingUserID: userID,
                searchResults: [],
                showMemberSearch: false,
                showMemberLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showMemberLoading: false,
                        showMemberProfile: true
                    })
                    this.loadMemberOrderInformation("thisWeek")
                }, 2000)
            })
        }
    };

    renderMemberCardNumber = () => {
        const firstPart = this.state.memberCurrentCardNumber.slice(0, 3);
        const secondPart = this.state.memberCurrentCardNumber.slice(3, 7);
        const remainingPart = this.state.memberCurrentCardNumber.slice(7);

        const cardNumber = `${firstPart} ${secondPart} ${remainingPart}`
        return (
            <span>{cardNumber}</span>
        )
    }

    getOrdersCurrentWeek = async (weekStarting, weekEnding, userID) => {

        //* - - MONTH - - *//
            //? - - WEEK STARTING
        const weekStartingMonth = new Date(weekStarting).getMonth();
        const weekStartingYear = new Date(weekStarting).getFullYear();
        const firstDayOfNextMonth = new Date(weekStartingYear, weekStartingMonth + 1, 1);
        const weekStartingLastDayOfMonth = new Date(firstDayOfNextMonth - 1);
        const lastDayOfWeekStartingMonth = weekStartingLastDayOfMonth.getDate()

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const weekStartingMonthString = monthAbbreviations[weekStartingLastDayOfMonth.getMonth()];

            //! - - WEEK ENDING
        const weekEndingMonthString = monthAbbreviations[new Date(weekEnding).getMonth()];

        //* - - - - YEAR - - - - *//
            //? - - WEEK STARTING
        // const weekStartingYear = new Date(weekStarting).getFullYear();
        const weekStartingYearString = weekStartingYear.toString();

            //! - - WEEK ENDING
        const weekEndingYear = new Date(weekEnding).getFullYear();
        const weekEndingYearString = weekEndingYear.toString();

        //* - - DAY - - *//
            //? - - WEEK STARTING
        const weekStartingDay =new Date(weekStarting).getDate()

            //! - - WEEK ENDING
        const weekEndingDay = new Date(weekEnding).getDate()

        console.log(`WEEK STARTING YEAR: ${weekStartingYearString}`)
        console.log(`WEEK STARTING MONTH: ${weekStartingMonthString}`)
        console.log(`WEEK STARTING DAY: ${weekStartingDay}`)
        console.log(`WEEK STARTING LAST DAY OF MONTH: ${lastDayOfWeekStartingMonth}`)

        console.log(`WEEK ENDING YEAR: ${weekEndingYearString}`)
        console.log(`WEEK ENDING MONTH: ${weekEndingMonthString}`)
        console.log(`WEEK ENDING DAY: ${weekEndingDay}`)

        let weeklyOrders = []
        const promises = []

        if (weekStartingMonthString !== weekEndingMonthString) {
            
            for (let i = weekStartingDay; i <= lastDayOfWeekStartingMonth; i++) {
                
                const dailyOrderRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekStartingYearString)
                .collection(weekStartingMonth)
                .doc(`${i}`)
                .collection("0orders")

                const dailyPromise = dailyOrderRef.get().then(snapshot => {
                    if (snapshot.size !== 0) {
                        const data = snapshot.docs.map(doc => doc.data())
                        weeklyOrders.push(...data)
                    }
                })
                promises.push(dailyPromise)
            }

            await Promise.all(promises)

            for (let i = 1; i <= weekEndingDay; i++) {
                
                const dailyOrderRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekEndingYearString)
                .collection(weekEndingMonthString)
                .doc(`${i}`)
                .collection("0orders")

                const dailyOrderPromise = dailyOrderRef.get().then(snapshot => {
                    if (snapshot.size !== 0) {
                        const data = snapshot.docs.map(doc => doc.data())
                        weeklyOrders.push(...data)
                    }
                })
                promises.push(dailyOrderPromise)
            }

            await Promise.all(promises)

        } else {

            for (let i = weekStartingDay; i <= weekEndingDay; i++) {
                const dailyOrderRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekEndingYearString)
                .collection(weekEndingMonthString)
                .doc(`${i}`)
                .collection("0orders")

                const dailyOrderPromise = dailyOrderRef.get().then(snapshot => {
                    const data = snapshot.docs.map(doc => doc.data())
                    weeklyOrders.push(...data)
                })
                promises.push(dailyOrderPromise)
            }

            await Promise.all(promises)

        }

        weeklyOrders = weeklyOrders.map(order => ({
            ...order,
            items: []
        }));

        if (weekStartingYearString !== weekEndingYearString) {
            
            for (let i = 0; i < weeklyOrders.length; i++) {
                const weeklyOrdersRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekStartingYearString)
                .collection("0orders")
                .doc(weeklyOrders[i].id)
                .collection("list")

                const weeklyOrdersPromise = weeklyOrdersRef.get().then(snapshot => {
                    const data = snapshot.docs.map(doc => doc.data())
                    weeklyOrders[i].items = data
                })
                promises.push(weeklyOrdersPromise)
            }

            await Promise.all(promises)

            for (let i = 0; i < weeklyOrders.length; i++) {
                const weeklyOrdersRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekEndingYearString)
                .collection("0orders")
                .doc(weeklyOrders[i].id)
                .collection("list")

                const weeklyOrdersPromise = weeklyOrdersRef.get().then(snapshot => {
                    const data = snapshot.docs.map(doc => doc.data())
                    weeklyOrders[i].items = data
                })
                promises.push(weeklyOrdersPromise)
            }
            await Promise.all(promises)
        } else {
            for (let i = 0; i < weeklyOrders.length; i++) {
                const weeklyOrdersRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("members")
                .collection("full_list")
                .doc(userID)
                .collection("orders")
                .doc(weekStartingYearString)
                .collection("0orders")
                .doc(weeklyOrders[i].id)
                .collection("list")

                const weeklyOrdersPromise = weeklyOrdersRef.get().then(snapshot => {
                    const data = snapshot.docs.map(doc => doc.data())
                    weeklyOrders[i].items = data
                })
                promises.push(weeklyOrdersPromise)
            }
            await Promise.all(promises)

            this.setState({memberTransactions: weeklyOrders}) 
        }
    }

    loadMemberOrderInformation = (orderPeriod) => {

        let firstWeekDay = this.getFirstDayOfWeek(new Date())
        let lastWeekDay = this.getLastDayOfWeek(new Date())

        class OrderInfo {
            constructor(date, earningPolicy, earningPolicyEndDate, earningPolicyMoneyValue, earningPolicyPercentageChange, earningPolicyPointsValue, id, total) {
                this.date = date
                this.earningPolicy = earningPolicy
                this.earningPolicyEndDate = earningPolicyEndDate
                this.earningPolicyMoneyValue = earningPolicyMoneyValue
                this.earningPolicyPercentageChange = earningPolicyPercentageChange
                this.earningPolicyPointsValue = earningPolicyPointsValue
                this.id = id
                this.total = total
            }
            toString () {
                return this.date + ', ' +
                this.earningPolicy + ', ' +
                this.earningPolicyEndDate + ', ' +
                this.earningPolicyMoneyValue + ', ' +
                this.earningPolicyPercentageChange + ', ' +
                this.earningPolicyPointsValue + ', ' +
                this.id + ', ' +
                this.total
            }
        }
        var orderConverter = {
            toFirestore : function(order) {
                return {
                    date: order.date,
                    earningPolicy: order.earningPolicy,
                    earningPolicyEndDate: order.earningPolicyEndDate,
                    earningPolicyMoneyValue: order.earningPolicyMoneyValue,
                    earningPolicyPercentageChange: order.earningPolicyPercentageChange,
                    earningPolicyPointsValue: order.earningPolicyPointsValue,
                    id: order.id,
                    total: order.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new OrderInfo(data.date, data.earningPolicy, data.earningPolicyEndDate, data.earningPolicyMoneyValue, data.earningPolicyPercentageChange, data.earningPolicyPointsValue, data.id, data.total)
            }
        }

        // fire.firestore().collection("clients")
        // .doc("artcaffe")
        // .collection("admin")
        // .doc("members")
        // .collection("full_list")
        // .doc(this.state.searchingUserID)
        // .collection("orders")        
        // .doc(orderPeriod)
        // .collection("list")
        // .withConverter(orderConverter)
        // .get().then(snapshot => {
        //     const data = snapshot.docs.map(doc => doc.data())
        //     console.log(data)
        //     this.setState({
        //         memberTransactions: data
        //     })
        // })
        this.getOrdersCurrentWeek(firstWeekDay, lastWeekDay, this.state.searchingUserID)

    };

    handleSelectedOrderPeriod = (selectedOption) => {
        this.loadMemberOrderInformation(selectedOption.value)
        this.setState({
            showMemberTransactions: false,
            showNoTransactionsMsg: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showNoTransactionsMsg: false,
                    showMemberTransactions: true
                })
            }, 2000)
        })
    }

    renderTransactions = () => {
        if (this.state.memberTransactions.length != 0) {
            return (this.state.memberTransactions.map(orders => {
                var {date, earningPolicy, earningPolicyEndDate, earningPolicyMoneyValue, 
                    earningPolicyPercentageChange, earningPolicyPointsValue, id, total} = orders

                    let uID = shortid.generate()

                    let timeComponents = id.split('-')
                    let timeOfOrder = `${timeComponents[4]}:${timeComponents[5]}`

                    return (
                        <div style={{display: "flex", justifyContent:"space-between", borderBottom: "1.5px solid #0930cb"}} className='memberTransactionCell'>
                            <div style={{marginLeft: "3%"}} className='memberTransactionPara' onClick={() => this.transactionIDClicked(id, earningPolicyPercentageChange, date, timeOfOrder, total, earningPolicyPointsValue, earningPolicyMoneyValue)}><p style={{ color: "#0930cb", fontFamily: "gabarito"}}>Transaction-{id}</p></div>
                            <p style={{marginRight: "3%", color: "black", fontFamily: "gabarito", fontSize: "14px", fontWeight: "bold", paddingTop: "0.5%"}}>{date} {timeOfOrder}</p>
                        </div>
                    )
            }))
        } else {
            return (
                <div style={{textAlign: "center"}} className='memberTransactionsEmpty'>
                    <h2 style={{paddingTop: "16%", color: "#0930cb", fontFamily: "arvo"}}>No transactions within this period</h2>
                </div>
            )
        }
    }

    transactionIDClicked = (id, EPPercentage, date, timeOfOrder, total, EPPointsValue, EPMoneyValue) => {
        class Order {
            constructor(category, date, item, qty) {
                this.category = category
                this.date = date
                this.item = item
                this.qty = qty
            }
            toString () {
                return this.category + ', ' +
                this.date + ', ' +
                this.item + ', ' +
                this.qty
            }
        }
        var orderConverter = {
            toFirestore : function(order) {
                return {
                    category: order.category,
                    date: order.date,
                    item: order.item,
                    qty: order.qty
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Order (data.category, data.date, data.item, data.qty)
            }
        }

        let tempOrderPeriod = "month1"

        // this.setState({
        //     memberCurrentOrderDate: `${date} ${timeOfOrder}`,
        // })

            //* - - SET ALL ORDER INFORMATION DETAILS HERE - - *//

        let pointsAdding
        if (EPPercentage !== "") {
            pointsAdding = total * (EPPointsValue / EPMoneyValue)
        } else {
            pointsAdding = total * (this.state.savedPointsValue / this.state.savedMoneyValue)
        }

        if (EPPercentage == "") {
            EPPercentage = 0
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list")
        .doc(this.state.searchingUserID)
        .collection("orders")
        .doc(tempOrderPeriod)
        .collection("list")
        .doc(id)
        .collection("list")
        .withConverter(orderConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                showMemberOrderInformationHeader: true,
                memberCurrentEarningPolicy: EPPercentage,
                memberCurrentTotal: total,
                memberCurrentPoints: Math.round(pointsAdding),
                memberCurrentOrderDate: `${date} ${timeOfOrder}`,
                memberCurrentOrderItems: data.length,
                memberTransactionOrder: data
            })
        })
    }

    renderTransactionOrder = () => {
        if (this.state.memberTransactionOrder.length != 0) {
            return (this.state.memberTransactionOrder.map(orderDetails => {
                var {category, date, item, qty} = orderDetails
                return (
                    <div className='memberTransactionOrderCell'>
                        <p><label style={{marginRight: "2%"}}>{qty}x</label>{item}</p>
                    </div>
                )
            }))
        } else {
            return (
                <div style={{textAlign: "center"}}>
                    <h3 style={{fontFamily: "arvo", color: "#0930cb", marginTop: "46%"}}>Select a transaction</h3>
                </div>
            )
        }
    }

    backToSearch = () => {
        this.setState({
            showMemberProfile: false,
            showMemberLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showMemberLoading: false,
                    showMemberSearch: true
                }) 
            }, 2000)
        })
    }

            //* - - MEMBER SEGMENT - - *//

    goToSegmentMembersDashboard = () => {
        this.setState({
            showMembersBtns: false,
            showMembersDashboardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showMembersDashboardLoading: false,
                    showSegmentDashboard: true,
                })
            }, 2000)
        })
    }

        //! - - YEARLY DATA - - !//

    getCurrentYearHighestRepeatPurchases = (year) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            this.setState({
                segmentedMembers: sortedArray
            })
        })
    }

    getCurrentYearLowestRepeatPurchases = (year) => {
        this.setState({
            segmentedMembers: []
        })
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => a.qty - b.qty)
            this.setState({
                segmentedMembers: sortedArray
            })
        })
    }

    getCurrentYearHighestTotalSpend = (year) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            this.setState({
                segmentedMembers: sortedArray
            })
        })
    }

    getCurrentYearLowestTotalSpend = (year) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => a.total - b.total)
            this.setState({
                segmentedMembers: sortedArray
            })
        })
    }

        //! - - MONTHLY DATA - - !//

    getCurrentMonthHighestRepeatPurchases = async (month) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.segmentCurrentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            if (!snapshot.empty) {
                const data = snapshot.docs.map(doc => doc.data())
                const sortedArray = data.sort((a, b) => b.qty - a.qty)
                this.setState({
                    segmentedMembers: sortedArray
                })
            }
        })
    }

    getCurrentMonthLowestRepeatPurchases = async (month) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.segmentCurrentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            if (!snapshot.empty) {
                const data = snapshot.docs.map(doc => doc.data())
                const sortedArray = data.sort((a, b) => a.qty - b.qty)
                this.setState({
                    segmentedMembers: sortedArray
                })
            }
        })
    }

    getCurrentMonthHighestTotalSpend = async (month) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.segmentCurrentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            if (!snapshot.empty) {
                const data = snapshot.docs.map(doc => doc.data())
                const sortedArray = data.sort((a, b) => b.total - a.total)
                this.setState({
                    segmentedMembers: sortedArray
                })
            }
        })
    }

    getCurrentMonthLowestTotalSpend = async (month) => {
        this.setState({
            segmentedMembers: []
        })
        class User {
            constructor(id, email, name, qty, total) {
                this.id = id
                this.email = email
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.email + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.email, data.name, data.qty, data.total)
            }
        }

        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.segmentCurrentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            if (!snapshot.empty) {
                const data = snapshot.docs.map(doc => doc.data())
                const sortedArray = data.sort((a, b) => a.total - b.total)
                this.setState({
                    segmentedMembers: sortedArray
                })
            }
        })
    }

        //! - - SELECT HANDLERS - - !//

    handleSegmentYearChanged = (selectedOptions) => {
        if (selectedOptions.value !== this.state.segmentCurrentYear) {
            if (this.state.segmentCurrentType === "highest-repeat-purchases") {
                this.getCurrentYearHighestRepeatPurchases(selectedOptions.value)
                this.setState({
                    segmentCurrentYear: selectedOptions.value,
                    segmentCurrentTitle: `${selectedOptions.value} Highest Repeat Purchases`
                })
            } else if (this.state.segmentCurrentType === "lowest-repeat-purchases") {
                this.getCurrentYearLowestRepeatPurchases(selectedOptions.value)
                this.setState({
                    segmentCurrentYear: selectedOptions.value,
                    segmentCurrentTitle: `${selectedOptions.value} Lowest Repeat Purchases`
                })
            } else if (this.state.segmentCurrentType === "highest-total-spending") {
                this.getCurrentYearHighestTotalSpend(selectedOptions.value)
                this.setState({
                    segmentCurrentYear: selectedOptions.value,
                    segmentCurrentTitle: `${selectedOptions.value} Highest Total Spending`
                })
            } else if (this.state.segmentCurrentType === "lowest-total-spending") {
                this.getCurrentYearLowestTotalSpend(selectedOptions.value)
                this.setState({
                    segmentCurrentYear: selectedOptions.value,
                    segmentCurrentTitle: `${selectedOptions.value} Lowest Total Spending`
                })
            }
            this.setState({
                showSegmentData: false,
                showSegmentTitle: false,
                showSegmentTitleLoading: true,
                showSegmentDataLoading: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSegmentDataLoading: false,
                        showSegmentTitleLoading: false,
                        showSegmentTitle: true,
                        showSegmentData: true,
                    })
                }, 2000)
            })
        } 
    }
    
    handleSegmentTypeChanged = (selectedOptions) => {
        if (selectedOptions.value === "highest-repeat-purchases") { 
            if ((this.state.segmentCurrentMonth === "" || this.state.segmentCurrentMonth === "empty") && ((this.state.segmentFilterFromMonth === "" || this.state.segmentFilterFromMonth === "empty") && this.state.segmentFilterFromDay === "") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY YEAR - - *//
                this.getCurrentYearHighestRepeatPurchases(this.state.segmentCurrentYear)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentYear} Highest Repeat Purchases`
                })
            } else if ((this.state.segmentCurrentMonth !== "" || this.state.segmentCurrentMonth !== "empty") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY MONTH - - *//
                this.getCurrentMonthHighestRepeatPurchases(this.state.segmentCurrentMonth)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentMonth.charAt(0).toUpperCase() + this.state.segmentCurrentMonth.slice(1)} Highest Repeat Purchases`
                })
                console.log(this.state.segmentCurrentMonth)
            } else if (((this.state.segmentFilterFromMonth !== "" || this.state.segmentFilterFromMonth) !== "empty" && this.state.segmentFilterFromDay !== "") && ((this.state.segmentFilterToMonth !== "" || this.state.segmentFilterToMonth !== "empty") && this.state.segmentFilterToDay !== "")) {
                //* - - ONLY FROM / TO DATE - - *//
                if (this.state.segmentFilterFromMonth === this.state.segmentFilterToMonth) {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => b.qty - a.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} Highest Repeat Purchases`
                    })
                } else {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => b.qty - a.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterToMonth.charAt(0).toUpperCase() + this.state.segmentFilterToMonth.slice(1)} Highest Repeat Purchases`
                    })
                }
            }
        } else if (selectedOptions.value === "lowest-repeat-purchases") {    
            if ((this.state.segmentCurrentMonth === "" || this.state.segmentCurrentMonth === "empty") && ((this.state.segmentFilterFromMonth === "" || this.state.segmentFilterFromMonth === "empty") && this.state.segmentFilterFromDay === "") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY YEAR - - *//
                this.getCurrentYearLowestRepeatPurchases(this.state.segmentCurrentYear)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentYear} Lowest Repeat Purchases`
                })
            } else if ((this.state.segmentCurrentMonth !== "" || this.state.segmentCurrentMonth !== "empty") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY MONTH - - *//
                this.getCurrentMonthLowestRepeatPurchases(this.state.segmentCurrentMonth)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentMonth.charAt(0).toUpperCase() + this.state.segmentCurrentMonth.slice(1)} Lowest Repeat Purchases`
                })
            } else if (((this.state.segmentFilterFromMonth !== "" || this.state.segmentFilterFromMonth !== "empty") && this.state.segmentFilterFromDay !== "") && ((this.state.segmentFilterToMonth !== "" || this.state.segmentFilterToMonth !== "empty") && this.state.segmentFilterToDay !== "")) {
                //* - - ONLY FROM / TO DATE - - *//
                if (this.state.segmentFilterFromMonth === this.state.segmentFilterToMonth) {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => a.qty - b.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} Lowest Repeat Purchases`
                    })
                } else {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => a.qty - b.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterToMonth.charAt(0).toUpperCase() + this.state.segmentFilterToMonth.slice(1)} Lowest Repeat Purchases`
                    })
                }
            }
        } else if (selectedOptions.value === "highest-total-spending") {
            if ((this.state.segmentCurrentMonth === "" || this.state.segmentCurrentMonth === "empty") && ((this.state.segmentFilterFromMonth === "" || this.state.segmentFilterFromMonth === "empty") && this.state.segmentFilterFromDay === "") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY YEAR - - *//
                this.getCurrentYearHighestTotalSpend(this.state.segmentCurrentYear)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentYear} Highest Total Spending`
                })
            } else if ((this.state.segmentCurrentMonth !== "" || this.state.segmentCurrentMonth !== "empty") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY MONTH - - *//
                this.getCurrentMonthHighestTotalSpend(this.state.segmentCurrentMonth)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentMonth.charAt(0).toUpperCase() + this.state.segmentCurrentMonth.slice(1)} Highest Total Spending`
                })
            } else if (((this.state.segmentFilterFromMonth !== "" || this.state.segmentFilterFromMonth !== "empty") && this.state.segmentFilterFromDay !== "") && ((this.state.segmentFilterToMonth !== "" || this.state.segmentFilterToMonth !== "empty") && this.state.segmentFilterToDay !== "")) {
                //* - - ONLY FROM / TO DATE - - *//
                if (this.state.segmentFilterFromMonth === this.state.segmentFilterToMonth) {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => b.qty - a.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} Highest Repeat Purchases`
                    })
                } else {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => b.total - a.total),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterToMonth.charAt(0).toUpperCase() + this.state.segmentFilterToMonth.slice(1)} Highest Repeat Purchases`
                    })
                }
            }
        } else if (selectedOptions.value === "lowest-total-spending") {
            if ((this.state.segmentCurrentMonth === "" || this.state.segmentCurrentMonth === "empty") && ((this.state.segmentFilterFromMonth === "" || this.state.segmentFilterFromMonth === "empty") && this.state.segmentFilterFromDay === "") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY YEAR - - *//
                this.getCurrentYearLowestTotalSpend(this.state.segmentCurrentYear)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentYear} Lowest Total Spending`
                })
            } else if ((this.state.segmentCurrentMonth !== "" || this.state.segmentCurrentMonth !== "empty") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY MONTH - - *//
                this.getCurrentMonthLowestTotalSpend(this.state.segmentCurrentMonth)
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentMonth.charAt(0).toUpperCase() + this.state.segmentCurrentMonth.slice(1)} Lowest Total Spending`
                })
            } else if (((this.state.segmentFilterFromMonth !== "" || this.state.segmentFilterFromMonth !== "empty") && this.state.segmentFilterFromDay !== "") && ((this.state.segmentFilterToMonth !== "" || this.state.segmentFilterToMonth !== "empty") && this.state.segmentFilterToDay !== "")) {
                //* - - ONLY FROM / TO DATE - - *//
                if (this.state.segmentFilterFromMonth === this.state.segmentFilterToMonth) {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => b.qty - a.qty),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} Highest Repeat Purchases`
                    })
                } else {
                    this.setState({
                        segmentedMembers: this.state.segmentedMembers.sort((a, b) => a.total - b.total),
                        segmentCurrentType: selectedOptions.value,
                        segmentCurrentTitle: `${this.state.segmentFilterFromDay} ${this.state.segmentFilterFromMonth.charAt(0).toUpperCase() + this.state.segmentFilterFromMonth.slice(1)} - ${this.state.segmentFilterToDay} ${this.state.segmentFilterToMonth.charAt(0).toUpperCase() + this.state.segmentFilterToMonth.slice(1)} Highest Repeat Purchases`
                    })
                }
            }
        } else if (selectedOptions.value === "inactive-customers") {
            if ((this.state.segmentCurrentMonth === "" || this.state.segmentCurrentMonth === "empty") && ((this.state.segmentFilterFromMonth === "" || this.state.segmentFilterFromMonth === "empty") && this.state.segmentFilterFromDay === "") && ((this.state.segmentFilterToMonth === "" || this.state.segmentFilterToMonth === "empty") && this.state.segmentFilterToDay === "")) {
                //* - - ONLY YEAR - - *//
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentYear} Inactive Customers`
                })
            } else if (this.state.segmentCurrentMonth !== "" || this.state.segmentCurrentMonth !== "empty") {
                //* - - ONLY MONTH - - *//
                this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentCurrentMonth} Inactive Customers`
                })
            } else if (((this.state.segmentFilterFromMonth !== "" || this.state.segmentFilterFromMonth !== "empty") && this.state.segmentFilterFromDay !== "") && ((this.state.segmentFilterToMonth !== "" || this.state.segmentFilterToMonth !== "empty") && this.state.segmentFilterToDay !== "")) {
                 //* - - ONLY FROM / TO DATE - - *//
                 this.setState({
                    segmentCurrentType: selectedOptions.value,
                    segmentCurrentTitle: `${this.state.segmentFilterFromMonth} ${this.state.segmentFilterFromDay} - ${this.state.segmentFilterToMonth} ${this.state.segmentFilterToDay} Inactive Customers`
                 })
            }
        }
        this.setState({
            showSegmentData: false,
            showSegmentTitle: false,
            showSegmentTitleLoading: true,
            showSegmentDataLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSegmentDataLoading: false,
                    showSegmentTitleLoading: false,
                    showSegmentTitle: true,
                    showSegmentData: true,
                })
            }, 2000)
        })
    }

    handleSegmentTimelineChanged = (selectedOptions) => {
        if (this.state.segmentCurrentType === "highest-repeat-purchases") {
            this.getCurrentMonthHighestRepeatPurchases(selectedOptions.value)
            this.setState({
                segmentCurrentMonth: selectedOptions.value,
                segmentCurrentTitle: `${selectedOptions.value.charAt(0).toUpperCase() + selectedOptions.value.slice(1)} Highest Repeat Purchases`
            })
        } else if (this.state.segmentCurrentType === "lowest-repeat-purchases") {
            this.getCurrentMonthLowestRepeatPurchases(selectedOptions.value)
            this.setState({
                segmentCurrentMonth: selectedOptions.value,
                segmentCurrentTitle: `${selectedOptions.value.charAt(0).toUpperCase() + selectedOptions.value.slice(1)} Lowest Repeat Purchases`
            })
        } else if (this.state.segmentCurrentType === "highest-total-spending") {
            this.getCurrentMonthHighestTotalSpend(selectedOptions.value)
            this.setState({
                segmentCurrentMonth: selectedOptions.value,
                segmentCurrentTitle: `${selectedOptions.value.charAt(0).toUpperCase() + selectedOptions.value.slice(1)} Highest Total Spending`
            })
        } else if (this.state.segmentCurrentType === "lowest-total-spending") {
            this.getCurrentMonthLowestTotalSpend(selectedOptions.value)
            this.setState({
                segmentCurrentMonth: selectedOptions.value,
                segmentCurrentTitle: `${selectedOptions.value.charAt(0).toUpperCase() + selectedOptions.value.slice(1)} Lowest Total Spending`
            })
        } else if (this.state.segmentCurrentType === "inactive-customers") {
            this.setState({
                segmentCurrentMonth: selectedOptions.label,
                segmentCurrentTitle: `${selectedOptions.value.charAt(0).toUpperCase() + selectedOptions.value.slice(1)} Inactive Customers`
            })
        }
        this.setState({
            segmentSearchErrMsg: "",
            showSegmentData: false,
            showSegmentTitle: false,
            showSegmentTitleLoading: true,
            showSegmentDataLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSegmentDataLoading: false,
                    showSegmentTitleLoading: false,
                    showSegmentTitle: true,
                    showSegmentData: true,
                })
            }, 2000)
        })
    }

    handleSegmentFromMonthChanged = (selectedOptions) => {
        this.setState({
            segmentFilterFromMonth: selectedOptions.value
        })
    }

    handleSegmentToMonthChanged = (selectedOptions) => {
        this.setState({
            segmentFilterToMonth: selectedOptions.value
        })
    }

    handleDateChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value.replace(/\s/g, '')
        })
    }

    handleSegmentFilterOptionsChanged = (selectedOptions) => {
        if (selectedOptions.value === "purchase-quantity") {
            this.setState({
                segmentFromOptionPlaceholder: "1",
                segmentToOptionPlaceholder: "25"
            })
        } else if (selectedOptions.value === "total-amount-spent") {
            this.setState({
                segmentFromOptionPlaceholder: "KES 4000",
                segmentToOptionPlaceholder: "KES 25000"
            })
        } else if (selectedOptions.value === "ranking") {
            this.setState({
                segmentFromOptionPlaceholder: "1",
                segmentToOptionPlaceholder: "50"
            })
        }
        this.setState({
            selectedSegmentLabel: selectedOptions.label,
            selectedSegment: selectedOptions.value
        })
    }

        //! - - RENDER SEGMENT DATA - - !//

    renderSegmentData = () => {
        if (this.state.segmentedMembers.length !== 0) {
            return (this.state.segmentedMembers.map((users, index) => {
                var {id, name, qty, total} = users
                return (
                    <div style={{display: "flex", justifyContent: "space-between"}} className='dataDisplayCell'>
                        <p style={{marginTop: "0px", paddingTop: "1.5%", textAlign: "left", color: "#0930cb", fontFamily: "sora", marginLeft: "1%", marginBottom: "0px", fontSize: "90%"}}><strong>{index + 1}. {name}</strong>  <label style={{color: "black", fontWeight: "bold"}}>({qty})</label></p>
                        <h4 style={{marginTop: "0px", paddingTop: "1.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginBottom: "1%", fontSize: "90%"}}>KES {total}</h4>
                    </div>
                )
            }))
        } else {
            return (
                <div>
                    <h3 style={{fontFamily: "sora", color: "#0930cb", paddingTop: "10%", textAlign: "center"}}>No transactions within this period</h3>
                </div>
            )
        }
    }

    renderSegmentOptionsData = () => {
        if (this.state.segmentedOptionsMembers.length !== 0) {
            return (this.state.segmentedOptionsMembers.map((users, index) => {
                var {id, name, qty, total} = users
                return (
                    <div style={{display: "flex", justifyContent: "space-between"}} className='dataDisplayCell'>
                        <p style={{marginTop: "0px", paddingTop: "1.5%", textAlign: "left", color: "#0930cb", fontFamily: "sora", marginLeft: "1%", marginBottom: "0px", fontSize: "90%"}}><strong>{index + 1}. {name}</strong>  <label style={{color: "black", fontWeight: "bold"}}>({qty})</label></p>
                        <h4 style={{marginTop: "0px", paddingTop: "1.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginBottom: "1%", fontSize: "90%"}}>KES {total}</h4>
                    </div>
                )
            }))
        } else {
            return (
                <div>
                    <h3 style={{fontFamily: "sora", color: "#0930cb", paddingTop: "10%", textAlign: "center"}}>No transactions within this period</h3>
                </div>
            )
        }
    }

    searchSegmentFilters = async () => {
        //* - - ONLY FROM / TO DATE - - *//
        if ((this.state.segmentFilterFromMonth !== "" && this.state.segmentFilterFromDay !== "") && (this.state.segmentFilterToMonth !== "" && this.state.segmentFilterToDay !== "")) {
            if (this.state.segmentFilterFromMonth !== "empty" && this.state.segmentFilterToMonth !== "empty") {
                if (this.isNumeric(this.state.segmentFilterFromDay) && this.isNumeric(this.state.segmentFilterToDay)) {
                    if (parseInt(this.state.segmentFilterFromDay) < 32 || parseInt(this.state.segmentFilterToDay) < 32) {
                        const fromDate = new Date(`${this.state.segmentFilterFromMonth}/${parseInt(this.state.segmentFilterFromDay)}/${this.state.segmentCurrentYear}`)
                        const toDate = new Date(`${this.state.segmentFilterToMonth}/${parseInt(this.state.segmentFilterToDay)}/${this.state.segmentCurrentYear}`)
                        if (this.isDateBeforeOnly(fromDate, toDate) && this.isDateBefore(toDate, new Date())) {
    
                            const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
                            const startSearchMonth = monthAbbreviations[fromDate.getMonth()];
                            const endSearchMonth = monthAbbreviations[toDate.getMonth()];
                            const startSearchDay = fromDate.getDate();
                            const endSearchDay = toDate.getDate();
                            let segmentCurrentType = this.state.segmentCurrentType.split('-')
                            let updatedSegment = `${segmentCurrentType[0] !== "" ? segmentCurrentType[0].charAt(0).toUpperCase() + segmentCurrentType[0].slice(1) : ""} ${segmentCurrentType[1] !== "" ? segmentCurrentType[1].charAt(0).toUpperCase() + segmentCurrentType[1].slice(1) : ""} ${segmentCurrentType[2] !== undefined ? segmentCurrentType[2].charAt(0).toUpperCase() + segmentCurrentType[2].slice(1) : ""}`
                            
                            let segmentCurrentTitle
                            if (startSearchMonth === endSearchMonth) {
                                segmentCurrentTitle = `[${startSearchDay} - ${endSearchDay} ${startSearchMonth.charAt(0).toUpperCase() + startSearchMonth.slice(1)}]  ${updatedSegment}`
                            } else {
                                segmentCurrentTitle = `[${startSearchDay} ${startSearchMonth.charAt(0).toUpperCase() + startSearchMonth.slice(1)} - ${endSearchDay} ${endSearchMonth.charAt(0).toUpperCase() + endSearchMonth.slice(1)}]  ${updatedSegment}`
                            }
    
                            this.setState({
                                segmentSearchErrMsg: "",
                                showSegmentData: false,
                                showSegmentTitle: false,
                                showSegmentTitleLoading: true,
                                showSegmentDataLoading: true,
                            })
    
                            const segmentedMembers = await this.getSegmentDateSearchData(fromDate, toDate)
    
                            this.setState({
                                segmentedMembers: segmentedMembers,
                                segmentCurrentTitle: segmentCurrentTitle,
                                showSegmentDataLoading: false,
                                showSegmentTitleLoading: false,
                                showSegmentTitle: true,
                                showSegmentData: true,
                            })
    
                        } else {
                            this.setState({
                                segmentSearchErrMsg: "(Filter by date): Invalid date - 'to' date can't be before 'from' date AND 'to' date can't be after today's date."
                            })
                        }
                    } else {
                        this.setState({
                            segmentSearchErrMsg: "(Filter by date): Invalid date - enter a valid calendar date"
                        })
                    }
                } else {
                    this.setState({
                        segmentSearchErrMsg: "(Filter by date): Invalid search - 'from' month and 'to' month can't be empty."
                    })
                }
                } else {
                    this.setState({
                        segmentSearchErrMsg: "(Filter by date): Invalid search - only enter numeric values for dates."
                    })
                }
        } else {
            this.setState({
                segmentSearchErrMsg: "(Filter by date): Invalid search - enter a 'from' and a 'to' date."
            })
        }
    }

    getSegmentDateSearchData = async (fromDate, toDate) => {

        return new Promise(async (resolve, reject) => {
            try {
                const year = fromDate.getFullYear();
                const month = fromDate.getMonth();
                const firstDayOfNextMonth = new Date(year, month + 1, 1);
                const lastDayOfMonth = new Date(firstDayOfNextMonth - 1);

                const yearString = year.toString()

                const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
                const startSearchMonth = monthAbbreviations[lastDayOfMonth.getMonth()];
                const endSearchMonth = monthAbbreviations[toDate.getMonth()];

                const fromStartDate = fromDate.getDate();
                const fromLastDayOfMonth = lastDayOfMonth.getDate();

                const endSearchDate = toDate.getDate();

                class User {
                    constructor(id, email, name, qty, total) {
                        this.id = id
                        this.email = email
                        this.name = name
                        this.qty = qty
                        this.total = total 
                    }
                    toString () {
                        return this.id + ', ' +
                        this.email + ', ' +
                        this.name + ', ' +
                        this.qty + ', ' +
                        this.total
                    }
                }
                var userConverter = {
                    toFirestore : function(user) {
                        return {
                            id: user.id,
                            email: user.email,
                            name: user.name,
                            qty: user.qty,
                            total: user.total,
                        }
                    },
                    fromFirestore : function(snapshot, options) {
                        const data = snapshot.data(options)
                        return new User(data.id, data.email, data.name, data.qty, data.total)
                    }
                }

                const allUsers = []

                if (startSearchMonth !== endSearchMonth) {
                        //* - - Get the data from the current day to the end of that month

                    const promises = []

                    for (let i = fromStartDate; i <= fromLastDayOfMonth; i++) {
                        const dailyPromise = await fire.firestore().collection("clients")
                        .doc("artcaffe")
                        .collection("admin")
                        .doc("transactions")
                        .collection("members")
                        .doc(yearString)
                        .collection(startSearchMonth)
                        .doc("activity")
                        .collection(`${i}`)
                        .withConverter(userConverter)
                        .get().then(snapshot => {
                            if (!snapshot.empty) {
                                const data = snapshot.docs.map(doc => doc.data())
                                allUsers.push(...data)
                            }
                        })
                        promises.push(dailyPromise)
                    }
                    Promise.all(promises)
                    .then(async() => {

                        const promises2 = []
                        let startSearchIndex = monthAbbreviations.indexOf(startSearchMonth) + 1
                        let endSearchIndex = monthAbbreviations.indexOf(endSearchMonth) + 1
                        for (let i = startSearchIndex+1; i < endSearchIndex; i++) {
                            const monthlyPromise = await fire.firestore().collection("clients")
                            .doc("artcaffe")
                            .collection("admin")
                            .doc("transactions")
                            .collection("members")
                            .doc(yearString)
                            .collection(monthAbbreviations[i-1])
                            .withConverter(userConverter)
                            .get().then(snapshot => {
                                if (!snapshot.empty) {
                                    const data = snapshot.docs.map(doc => doc.data())
                                    allUsers.push(...data)
                                }
                            })
                            promises2.push(monthlyPromise)
                        }
                        Promise.all(promises2)
                        .then(async() => {
                            
                            const promises3 = []
                            for (let i = 1; i <= endSearchDate; i++) {
                                const dailyPromise = await fire.firestore().collection("clients")
                                .doc("artcaffe")
                                .collection("admin")
                                .doc("transactions")
                                .collection("members")
                                .doc(yearString)
                                .collection(endSearchMonth)
                                .doc("activity")
                                .collection(`${i}`)
                                .withConverter(userConverter)
                                .get().then(snapshot => {
                                    if (!snapshot.empty) {
                                        const data = snapshot.docs.map(doc => doc.data())
                                        allUsers.push(...data)
                                    }
                                })
                                promises3.push(dailyPromise)
                            }

                            Promise.all(promises3)
                            .then(() => {
                                const result = allUsers.reduce((accumulator, user) => {
                                    const existingUser = accumulator.find((item) => item.id === user.id);
                                    if (existingUser) {
                                        // If the user with the same 'id' exists, update the 'qty' and 'total'
                                        existingUser.qty += user.qty;
                                        existingUser.total += user.total;
                                    } else {
                                        // If the user with the 'id' doesn't exist, add it to the accumulator
                                        accumulator.push(user);
                                    }
                                    return accumulator;
                                }, []);
                                if (this.state.segmentCurrentType === "highest-repeat-purchases") {
                                    result.sort((a, b) => b.qty - a.qty)
                                } else if (this.state.segmentCurrentType === "lowest-repeat-purchases") {
                                    result.sort((a, b) => a.qty - b.qty)
                                } else if (this.state.segmentCurrentType === "highest-total-spending") {
                                    result.sort((a, b) => b.total - a.total)
                                } else if (this.state.segmentCurrentType === "lowest-total-spending") {
                                    result.sort((a, b) => a.total - b.total)
                                }
                                resolve(result);
                            })
                        })
                    })
                } else {
                    const promises = []
                    for (let i = fromStartDate; i <= endSearchDate; i++) {
                        const sameMonthCollection = await fire.firestore().collection("clients")
                        .doc("artcaffe")
                        .collection("admin")
                        .doc("transactions")
                        .collection("members")
                        .doc(yearString)
                        .collection(endSearchMonth)
                        .doc("activity")
                        .collection(`${i}`)
                        .withConverter(userConverter)
                        .get().then(snapshot => {
                            if (!snapshot.empty) {
                                const data = snapshot.docs.map(doc => doc.data())
                                allUsers.push(...data)
                            }
                        })
                        promises.push(sameMonthCollection)
                    }
                    Promise.all(promises)
                    .then(() => {
                        const result = allUsers.reduce((accumulator, user) => {
                            const existingUser = accumulator.find((item) => item.id === user.id);
                            if (existingUser) {
                                // If the user with the same 'id' exists, update the 'qty' and 'total'
                                existingUser.qty += user.qty;
                                existingUser.total += user.total;
                            } else {
                                // If the user with the 'id' doesn't exist, add it to the accumulator
                                accumulator.push(user);
                            }
                            return accumulator;
                        }, []);

                        if (this.state.segmentCurrentType === "highest-repeat-purchases") {
                            result.sort((a, b) => b.qty - a.qty)
                        } else if (this.state.segmentCurrentType === "lowest-repeat-purchases") {
                            result.sort((a, b) => a.qty - b.qty)
                        } else if (this.state.segmentCurrentType === "highest-total-spending") {
                            result.sort((a, b) => b.total - a.total)
                        } else if (this.state.segmentCurrentType === "lowest-total-spending") {
                            result.sort((a, b) => a.total - b.total)
                        }

                        console.log(result)
                        resolve(result);
                    })
                }
            } catch (error) {
                console.error("Error in getSegmentDateSearchData:", error);
                reject(error); // Reject with the error
            }
        });
    }

    segmentDataClicked = () => {  
        this.setState({
            showSegmentYear: false,
            showSegmentDataBtn: false,
            showSegmentFilterData: false,
            showSegmentData: false,
            showCloseSegmentDashboardBtn: false,
            showSegmentDataLoading: true,
            showSegmentOptionsLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSegmentOptionsLoading: false,
                    showSegmentDataLoading: false,
                    showSegmentData: true,
                    showSegmentOptions: true,
                    showCloseSegmentOptionsBtn: true,
                    showSaveSegmentBtn: true,
                    showDownloadCSVBtn: true,
                })
            }, 2000)
        })
    }

    isNumeric = (input) => {
        // Use a regular expression to match only numeric values
        var numericRegex = /^[0-9]+$/;
        
        // Test the input against the regular expression
        return numericRegex.test(input);
    }

    segmentOptionsClicked = () => {

        if (this.state.selectedSegment === "select segment") {
            this.setState({
                selectedSegmentBorderColor: "red"
            })
        } else {
            this.setState({
                selectedSegmentBorderColor: "#2584ff"
            })
        }

        if (this.state.segmentOptionFromValue === "" && this.state.segmentOptionToValue === "") {
            this.setState({
                segmentOptionFromBorderColor: "red",
                segmentOptionToBorderColor: "red"
            })
        } else {
            this.setState({
                segmentOptionFromBorderColor: "#cccccc",
                segmentOptionToBorderColor: "#cccccc"
            })
        }

        if (this.state.segmentOptionFromValue === "" && this.state.segmentOptionToBorderColor !== "") {
            this.setState({
                segmentOptionFromBorderColor: "red",
            })
        } else {
            this.setState({
                segmentOptionFromBorderColor: "#cccccc"
            })
        }
        
        if (this.state.selectedSegment !== "select segment" && this.state.segmentOptionFromValue !== "") {
            if (this.state.segmentOptionToValue === "") {
                //* - - SPECIFIC VALUE SEGMENT - - *//
                if (this.isNumeric(this.state.segmentOptionFromValue)) {
                    if (this.state.selectedSegment === "purchase-quantity") {
                        this.getSingleSegmentByPurchaseQuantity(parseInt(this.state.segmentOptionFromValue))
                    } else if (this.state.selectedSegment === "total-amount-spent") {
                        this.getSingleSegmentByTotalSpending(parseInt(this.state.segmentOptionFromValue))
                    } else if (this.state.selectedSegment === "ranking") {
                        this.getSingleSegmentByRanking(parseInt(this.state.segmentOptionFromValue))
                    }
                } else {
                    this.setState({
                        segmentOptionsErrMsg: "Invalid segment - only enter numeric values."
                    })
                }
            } else {
                //* - - RANGE VALUE SEGMENT - - *//
                if (this.isNumeric(this.state.segmentOptionToValue) && this.isNumeric(this.state.segmentOptionToValue)) {
                    if (this.state.selectedSegment === "purchase-quantity") {
                        this.getRangeSegmentByPurchaseQuantity(parseInt(this.state.segmentOptionFromValue), parseInt(this.state.segmentOptionToValue))
                    } else if (this.state.selectedSegment === "total-amount-spent") {
                        this.getRangeSegmentByTotalSpending(parseInt(this.state.segmentOptionFromValue),parseInt(this.state.segmentOptionToValue))
                    } else if (this.state.selectedSegment === "ranking") {
                        this.getRangeSegmentByRanking(parseInt(this.state.segmentOptionFromValue), parseInt(this.state.segmentOptionToValue))
                    }
                } else {
                    this.setState({
                        segmentOptionsErrMsg: "Invalid segment - only enter numeric values."
                    })
                }
                
            }
        }
    }

    filterByRanking = (array, fromVal) => {
        return array.filter((obj, index) => index + 1 === fromVal);
    };

    getSingleSegmentByPurchaseQuantity = (fromVal) => {
        //* - - Figure out how to FILTER the list based on (to only display) 'fromVal' (in this case by 'qty').
        this.setState({ 
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true 
        });

        const filteredArray = this.state.segmentedMembers.filter(obj => obj.qty === fromVal);
        
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true
        })
    }

    getSingleSegmentByTotalSpending = (fromVal) => {
        //* - - Figure out how to FILTER the list based on (to only display) 'fromVal' (in this case by 'total').
        this.setState({ 
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true 
        });
        
        const filteredArray = this.state.segmentedMembers.filter(obj => obj.total === fromVal);
        
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true
        })
    }

    getSingleSegmentByRanking = (fromVal) => { 
        //* - - Get the specific rank being searched for (in this case, it's ONLY ONE RESULT).
        this.setState({
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true,
        });
        
          // Filter the array based on ranking (in this case, 'total')
        const filteredArray = this.filterByRanking(this.state.segmentedMembers, fromVal);
        
          // Update state with the filtered array
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true,
        })    
    }

    getRangeSegmentByPurchaseQuantity = (fromVal, toVal) => {
        //* - - Figure out how to FILTER the list based on (to only display) values between 'fromVal' and 'toVal' (in this case by 'qty').
        // Set initial state
        this.setState({
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true,
        });

        // Filter the array based on the range (in this case, 'qty')
        const filteredArray = this.state.segmentedMembers.filter(
            (obj) => obj.qty >= fromVal && obj.qty <= toVal
        );

        // Update state with the filtered array
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true,
        });
    }

    getRangeSegmentByTotalSpending = (fromVal, toVal) => {
        //* - - Figure out how to FILTER the list based on (to only display) values between 'fromVal' and 'toVal' (in this case by 'total').
        // Set initial state
        this.setState({
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true,
        });

        // Filter the array based on the range (in this case, 'qty')
        const filteredArray = this.state.segmentedMembers.filter(
            (obj) => obj.total >= fromVal && obj.total <= toVal
        );

        // Update state with the filtered array
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true,
        });
    }

    getRangeSegmentByRanking = (fromVal, toVal) => {
        //* - - Figure out how to FILTER the list based on (to only display) values between 'fromVal' and 'toVal' (in this case by list ranking numbers).
        // Set initial state
        this.setState({
            segmentedOptionsMembers: [],
            showSegmentData: false,
            showSegmentDataLoading: true,
        });

        // Filter the array based on the index range
        const filteredArray = this.state.segmentedMembers.filter(
            (_, index) => index + 1 >= fromVal && index + 1 <= toVal
        );

        // Update state with the filtered array
        this.setState({
            segmentedOptionsMembers: filteredArray,
            showSegmentDataLoading: false,
            showSegmentOptionsData: true,
        });
    }

    closeSegmentOptions = () => {
        this.setState({
            segmentedOptionsMembers: [],
            showSegmentOptions: false,
            showCloseSegmentOptionsBtn: false,
            // showSaveSegmentBtn: false,
            showDownloadCSVBtn: false,
            showSegmentData: false,
            showSegmentOptionsData: false,
            showSegmentDataLoading: true,
            showSegmentOptionsLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSegmentOptionsLoading: false,
                    showSegmentDataLoading: false,
                    showSegmentDataBtn: true,
                    showSegmentYear: true,
                    showCloseSegmentDashboardBtn: true,
                    showSegmentData: true,
                    showSegmentFilterData: true
                })
            }, 2000)
        })
    }

    convertToCSV = (data) => {
        if (data.length !== 0) {
            // Specify the header with separate columns for first name and last name
            const header = 'First Name,Last Name,Email';
            
            // Map the array of objects to a CSV string
            const csv = data.map(obj => {
                // Split the full name into first and last names
                const [firstName, lastName] = obj.name.split(' ');
                
                // Return a string with first name, last name, and email
                return `${firstName || ''},${lastName || ''},${obj.email}`;
            }).join('\n');
            
            // Return the CSV string with the header
            return `${header}\n${csv}`;
        }
    };

    downloadCSV = () => {
        const { segmentedOptionsMembers } = this.state; // Replace with your array of objects
        const { segmentedMembers } = this.state; // Replace with your array of objects
    
        this.setState(
            {
              showDownloadCSVBtn: false,
              showDownloadCSVBtnLoading: true,
            },
            () => {
              let csvString;
              if (this.state.segmentedOptionsMembers.length !== 0) {
                csvString = this.convertToCSV(segmentedOptionsMembers);
              } else {
                csvString = this.convertToCSV(segmentedMembers);
              }
          
              // Update state after CSV conversion is complete
              this.setState({
                showDownloadCSVBtn: true,
                showDownloadCSVBtnLoading: false,
              });
          
              // Create a Blob and download the file
              const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
              const link = document.createElement('a');
          
              if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, 'data.csv');
              } else {
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download', 'data.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }
        );
    };

    closeSegmentDashboard = () => {
        this.setState({
            segmentSearchErrMsg: "",
            showSegmentDashboard: false,
            showMembersDashboardLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showMembersDashboardLoading: false,
                    showMembersBtns: true,
                })
            }, 2000)
        })
    }

    loadPointsRedeemed = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                redeemedPoints: data
            })
        })
    }

    updatePointsCellUIClicked = (id) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("rewards")
        .doc("locations")
        .collection("the_hub")
        .doc("nonVerified")
        .collection("list")
        .doc(id)
        .update({
            bgColor: "#E7ECFE"
        })
        if (this.state.prevClickedPoints !== "" && this.state.prevClickedPoints !== id) {
            const prevClickedRef = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("rewards")
            .doc("locations")
            .collection("the_hub")
            .doc("nonVerified")
            .collection("list")
            .doc(this.state.prevClickedPoints)

            prevClickedRef.get().then(doc => {
                if (doc.exists){
                    prevClickedRef.update({
                        bgColor: "white"
                    })
                }
            })
        }
        if (this.state.prevClickedPoints !== id || this.state.prevClickedPoints == "") {
            //! - - SAVE CURRENT CLICKED RECEIPT DATABASE ID TO DATABASE - SO WE KNOW WHERE LEFT OF - - !//
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("rewards")
            .doc("locations")
            .collection("the_hub")
            .doc("nonVerified")
            .set({
                lastClicked: id
            })
            .then(() => {
                this.loadPointsRedeemed()
            })
            this.setState({
                prevClickedPoints: id
            })
            
        }
        
    }

    userPointsClicked = (id, customerRewardValue, date, email, name, rewardDiscountPrice, rewardPoints, rewardName, rewardType, rewardValue, userID) => {
        this.updatePointsCellUIClicked(id)

        let rewardTypeLabel
        if (rewardType === "percentage-off") {
            rewardTypeLabel = "Percentage Off"
        } else if (rewardType === "amount-off") {
            rewardTypeLabel = "Amount Off"
        } else if (rewardType === "free-item") {
            rewardTypeLabel = "Free Item"
            rewardValue = "Free"
        } else if (rewardType === "custom-reward") {
            rewardTypeLabel = "Custom Reward"
        }

        let dateReward = date.split(' ')[0]
        let timeReward = date.split(' ')[1] 

        let dateComponents = dateReward.split('-')
        let timeComponents = timeReward.split(':')

        let rewardNameID = `${rewardName}-${dateComponents[0]}-${dateComponents[1]}-${dateComponents[2]}-${timeComponents[0]}-${timeComponents[1]}-${timeComponents[2]}`

        this.setState({
            showPointsRedeemPlaceholder: false,
            showPointsClickedInfo: false,
            showPointsRedeemLoading: true,
            rewardCustomerValue: customerRewardValue,
            rewardDateDatabase: date,
            rewardUserName: name,
            rewardUserEmail: email,
            rewardUserID: userID,
            rewardRedeemID: id,
            rewardDiscountPrice: rewardDiscountPrice,
            rawRewardType: rewardType,
            rewardType: rewardTypeLabel,
            rewardValue: rewardValue,
            rewardPointsValue: rewardPoints,
            rewardName: rewardName,
            rewardNameID: rewardNameID
        }, () => {
            setTimeout(() => {
                this.setState({
                    showPointsRedeemLoading: false,
                    showPointsClickedInfo: true,
                })
            }, 1000)
        })
    }

    renderPendingPoints = () => {
        if (this.state.redeemedPoints.length !== 0) {
            return this.state.redeemedPoints.map(users => {
                var {bgColor, customRewardValue, date, email, id, name, rewardDiscountPrice, 
                    rewardPoints, rewardName, rewardType, rewardValue, userID} = users

                return (
                    <div style={{borderBottom: "1px solid black", backgroundColor: bgColor, paddingTop: "1.5%", cursor: "pointer"}} 
                    onClick={() => this.userPointsClicked(id, customRewardValue, date, email, name, rewardDiscountPrice, rewardPoints, rewardName, rewardType, rewardValue, userID)}
                    className='pendingPointsCell'>
                        <h3 style={{paddingBottom: "7.5%"}}>{name}</h3>
                        <h4 style={{textAlign: "right", marginRight: "2%", color: "black", fontFamily: "sora"}}>{date}</h4>
                    </div>
                )
            })
        }
    }

    render () {
    
        let redeemPointsCategories = {
            marginTop: "0px !important",
            textAlign: "left",
            marginLeft: "2.5%",
            width: "90%",
            border: `2px solid transparent`
        }

        let segmentYearOptions = [
            {value: "2023", label: "2023"},
            {value: "2024", label: "2024"},
        ]

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        let yearOptionsDefaultValue 
        if (segmentYearOptions[0].value === currentYear) {
           yearOptionsDefaultValue = segmentYearOptions[0]
        } else {
            yearOptionsDefaultValue = segmentYearOptions[1]
        }

        let segmentTypeOptions = [
            {value: "highest-repeat-purchases", label: "Highest Repeat Purchases"},
            {value: "lowest-repeat-purchases", label: "Lowest Repeat Purchases"},
            {value: "highest-total-spending", label: "Highest Total Spending"},
            {value: "lowest-total-spending", label: "Lowest Total Spending"},
            // {value: "inactive-customers", label: "Inactive Customers"},
        ]

        let segmentFilterOptions = [
            {value: "purchase-quantity", label: "Purchase Quantity"},
            {value: "total-amount-spent", label :"Total Amount Spent"},
            {value: "ranking", label: "List Ranking"}
        ]

        const options5 = [
            {value: '1', label: '1'},
            {value: '2', label: '2'},
            {value: '3', label: '3'},
            {value: '4', label: '4'},
            {value: '5', label: '5'},
            {value: '6', label: '6'},
            {value: '7', label: '7'},
            {value: '8', label: '8'},
            {value: '9', label: '9'},
            {value: '10', label: '10'},
            {value: '11', label: '11'},
            {value: '12', label: '12'},
            {value: '13', label: '13'},
            {value: '14', label: '14'},
            {value: '15', label: '15'},
            {value: '16', label: '16'},
            {value: '17', label: '17'},
            {value: '18', label: '18'},
            {value: '19', label: '19'},
            {value: '20', label: '20'},
            {value: '21', label: '21'},
            {value: '22', label: '22'},
            {value: '23', label: '23'},
            {value: '24', label: '24'},
            {value: '25', label: '25'},
            {value: '26', label: '26'},
            {value: '27', label: '27'},
            {value: '28', label: '28'},
            {value: '29', label: '29'},
            {value: '30', label: '30'},
            {value: '31', label: '31'},
            {value: '32', label: '32'},
            {value: '33', label: '33'},
            {value: '34', label: '34'},
            {value: '35', label: '35'},
            {value: '36', label: '36'},
            {value: '37', label: '37'},
            {value: '38', label: '38'},
            {value: '39', label: '39'},
            {value: '40', label: '40'},
            {value: '41', label: '41'},
            {value: '42', label: '42'},
            {value: '43', label: '43'},
            {value: '44', label: '44'},
            {value: '45', label: '45'},
            {value: '46', label: '46'},
            {value: '47', label: '47'},
            {value: '48', label: '48'},
            {value: '49', label: '49'},
            {value: '50', label: '50'},
        ]

        const profileOptions = [
            {value: 'thisDay', label: 'Today'},           
            {value: 'thisWeek', label: 'This Week'},           
            {value: 'thisMonth', label: 'This Month'},           
            {value: 'month1', label: '1 mo. ago'},           
            {value: 'month2', label: '2 mo. ago'},           
            {value: 'month3', label: '3 mo. ago'},           
            {value: 'month4', label: '4 mo. ago'},           
            {value: 'month5', label: '5 mo. ago'},           
            {value: 'month6', label: '6 mo. ago'},           
            {value: 'month7', label: '7 mo. ago'},           
            {value: 'month8', label: '8 mo. ago'},           
            {value: 'month9', label: '9 mo. ago'},           
            {value: 'month10', label: '10 mo. ago'},           
            {value: 'month11', label: '11 mo. ago'},           
            {value: 'month12', label: '12 mo. ago'},                   
        ]

        const profileOptionsDefaultValue = profileOptions[1];

        let tPendingApprovalBtn = {
            backgroundColor: this.state.pendingApprovalBtnBgColor,
            color: this.state.pendingApprovalBtnTxtColor
        }

        let tApprovedBtn = {
            backgroundColor: this.state.approvedBtnBgColor,
            color: this.state.approvedBtnTxtColor
        }

        let selectedSegmentStyle = {
            backgroundColor: "white", 
            paddingTop: "1%", 
            marginLeft: "1.5%", 
            paddingLeft: "1%", 
            paddingRight: "1%", 
            paddingBottom: "1%", 
            borderRadius: "8px", 
            border: `1px solid ${this.state.selectedSegmentBorderColor}`, 
            color: "#000", 
            fontWeight: "normal", 
            fontFamily: "gabarito"
        }

        let segmentOptionFromStyle = {
            width: "8.5%", 
            textAlign: "center", 
            padding: "0px", 
            marginLeft: "1%", 
            borderRadius: "8px", 
            border: `1px solid  ${this.state.segmentOptionFromBorderColor}`, 
            outlineColor: "#2584ff", 
            fontFamily: "gabarito", 
            color: "#0930cb", 
            fontSize: "100%"
        }

        let segmentOptionToStyle = {
            width: "8.5%", 
            textAlign: "center", 
            padding: "0px", 
            marginLeft: "1%", 
            borderRadius: "8px", 
            border: `1px solid  ${this.state.segmentOptionToBorderColor}`, 
            outlineColor: "#2584ff", 
            fontFamily: "gabarito", 
            color: "#0930cb", 
            fontSize: "100%"
        }

        const { imageText } = this.state;

        return (
            <Styles>
                <div className='parentContainer'>
                    {/* <input type="file" accept="image/*" onChange={this.handleFileChange} />
                    <div>
                        <h2>Extracted Text:</h2>
                        <p>{imageText}</p>
                    </div> */}
                    {this.state.showMemberSearch && 
                        <div>
                            <div className='searchBoxResults'>
                                <SearchBox
                                placeholder="Search..."
                                onChange={this.handleSearch}
                                value={this.state.searchTerm}
                                />
                                {/* Render your search results here */}
                                <ul>
                                {this.state.searchResults.map((result) => (
                                    <li onClick={() => this.searchResultClicked(result.id)} key={result.id}>{result.value}<label style={{marginLeft: "1%"}}>{result.key}</label></li>
                                ))}
                                </ul>
                            </div>
                            {this.state.showMembersDashboardLoading && 
                                <div style={{textAlign: "center", marginTop: "20%"}}>
                                    <ClipLoader
                                    color="#0930cb"
                                    loading={true}
                                    // cssOverride={override}
                                    size={30}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            }
                            {this.state.showMembersBtns && 
                                <div>
                                    <div className='challengesContainer'>
                                        <div 
                                        className='challengeBox'
                                        onClick={this.goToSegmentMembersDashboard}
                                        >
                                            <h1>📬</h1>
                                            <h4>Segment customer data for targeted email marketing</h4>
                                            {/* <h4>(Card details)</h4>
                                            <h4>(Referral codes)</h4>
                                            <h4>(Recent activity)</h4> */}
                                            <h2 style={{paddingRight: "1.5%"}}>Segment Customers</h2>
                                        </div>
                                        {/* <div 
                                        className='challengeBox'
                                        onClick={this.challengeBox2Clicked}
                                        >
                                            <h1>🎊</h1>
                                            <h4>(Offer cards)</h4>
                                            <h2>Latest Offers</h2>
                                        </div>
                                        <div 
                                        className='challengeBox'
                                        onClick={this.challengeBox3Clicked}
                                        >
                                            <h1>🎁</h1>
                                            <h4>(Rewards)</h4>
                                            <h4>(Challenges)</h4>
                                            <h4>(Earning chart)</h4>
                                            <h4>(Wish list)</h4>
                                            <h4>(Secret menu)</h4>
                                            <h2>Rewards</h2>
                                        </div> */}
                                    </div>
                                </div>
                            }
                            {this.state.showSegmentDashboard && 
                                <div style={{width: "100%", height: "67vh", backgroundColor: "#f0f0f0", paddingBottom: "1.25%"}} className='segmentedUsers'>
                                    <div style={{display: "flex", flexDirection: 'row'}}>
                                        <h2>Segment Customers</h2>
                                        {this.state.showSegmentYear && 
                                            <Select 
                                            className='segmentYear'
                                            defaultValue={yearOptionsDefaultValue}
                                            placeholder="Year"
                                            onChange={this.handleSegmentYearChanged}
                                            options={segmentYearOptions}/>
                                        }
                                        {this.state.showSegmentTitle && 
                                            <span style={{backgroundColor: "white", marginLeft: "1.5%", height: "auto", paddingLeft: "1%", paddingRight: "2%", paddingTop: '1%', paddingBottom: '1%', marginTop: "1.25%", borderRadius: "8px", border: '1px solid #cccccc'}}>
                                                <h5 style={{color: "#000", fontFamily: "sora", paddingTop: "0.5%", marginLeft: "1.5%", width: "100%", marginBottom: "0px", marginTop: "0px", height: "100%"}}><label style={{paddingRight: "7.5px"}}>🔎 </label>{this.state.segmentCurrentTitle}</h5>
                                            </span>
                                        }
                                        {this.state.showSegmentTitleLoading && 
                                            <span style={{backgroundColor: "white", marginLeft: "1.5%", height: "auto", paddingLeft: "1%", paddingRight: "2%", paddingTop: '1%', paddingBottom: '0%', marginTop: "1.25%", borderRadius: "8px", border: '1px solid #cccccc', width: "25%", textAlign: "center"}}>
                                                <ClipLoader
                                                color="#0930cb"
                                                loading={true}
                                                // cssOverride={override}
                                                size={20}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </span>
                                        }
                                        {this.state.showCloseSegmentDashboardBtn && 
                                            <span className='segmentOptionsCloseBtn'>
                                                <button
                                                style={{width: "20%"}}
                                                onClick={this.closeSegmentDashboard}
                                                ><strong>Exit</strong></button>
                                            </span>
                                        }
                                        {this.state.showCloseSegmentOptionsBtn && 
                                            <span className='segmentOptionsCloseBtn'>
                                                <button
                                                onClick={this.closeSegmentOptions}
                                                >Close Segment Options</button>
                                            </span>
                                        }
                                    </div>
                                    {this.state.showSegmentFilterData && 
                                        <div>
                                            <div style={{display: "flex", justifyContent: "space-between", marginBottom: "1%"}}>
                                                <p><strong>Segment your customers for better targeted email marketing <label style={{paddingLeft: "4px", paddingRight: "5px", fontSize: "20.5px"}}>💌</label> </strong></p>
                                                <Select 
                                                className='segmentType'
                                                defaultValue={segmentTypeOptions[0]}
                                                placeholder="Segment by..."
                                                onChange={this.handleSegmentTypeChanged}
                                                options={segmentTypeOptions}/>
                                            </div>
                                            <div className='segmentFilters' style={{display: "flex", flexDirection: "row", marginBottom: "0.5%"}}>
                                                <label style={{marginLeft: "1.5%", paddingTop: '0.75%', fontFamily: "gabarito", color: "#0930cb",}}>(Filter by month)</label>
                                                <Select 
                                                className='segmentTimeline'  
                                                placeholder="Select..."
                                                onChange={this.handleSegmentTimelineChanged} 
                                                options={this.state.segmentTimelineOptions}
                                                value={this.state.segmentCurrentMonth}
                                                />
                                                <h3 style={{marginLeft: "2.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginTop:"0px", marginBottom: "0px", paddingTop: "0.75%"}}>OR</h3>
                                                <label style={{marginLeft: "0%", paddingTop: '0.75%', fontFamily: "gabarito", color: "#0930cb",}}>(Filter by date)</label>
                                                <label style={{marginLeft: "1.5%", paddingTop: '0.8%', fontFamily: "gabarito", color: "#0930cb", fontWeight: "bold"}}>from</label>
                                                <Select 
                                                className='segmentMonthTimeline'  
                                                placeholder="MM"
                                                onChange={this.handleSegmentFromMonthChanged} 
                                                options={this.state.segmentMonthFromTimelineOptions}/>
                                                <input
                                                id="segmentFilterFromDay"
                                                value={this.state.segmentFilterFromDay}
                                                placeholder='DD'
                                                style={{width: "4%", textAlign: "center", padding: "0px", marginLeft: "1%", borderRadius: "8px", border: "1px solid #cccccc", outlineColor: "#2584ff", fontFamily: "gabarito", color: "#0930cb", fontSize: "100%"}}
                                                onChange={this.handleDateChange}
                                                />
                                                <label style={{marginLeft: "1.5%", paddingTop: '0.8%', fontFamily: "gabarito", color: "#0930cb", fontWeight: "bold"}}>to</label>
                                                <Select 
                                                className='segmentMonthTimeline'  
                                                placeholder="MM"
                                                onChange={this.handleSegmentToMonthChanged} 
                                                options={this.state.segmentMonthToTimelineOptions}/>
                                                <input
                                                id="segmentFilterToDay"
                                                value={this.state.segmentFilterToDay}
                                                placeholder='DD'
                                                style={{width: "4%", textAlign: "center", padding: "0px", marginLeft: "1%", borderRadius: "8px", border: "1px solid #cccccc", outlineColor: "#2584ff", fontFamily: "gabarito", color: "#0930cb", fontSize: "100%"}}
                                                onChange={this.handleDateChange}
                                                />
                                                <button
                                                onClick={this.searchSegmentFilters}
                                                style={{marginLeft: "2%", width: "10%"}}
                                                >Search</button>
                                            </div>
                                        </div>
                                    }
                                    {this.state.showSegmentOptions && 
                                        <div className='segmentOptions'>
                                                {/* THREE OPTIONS */}
                                                <p style={{fontFamily: "gabarito", marginBottom: "0.5%", fontSize: "110%"}}>Select a segment criteria & range:</p>
                                                <div style={{display: "flex", flexDirection: "row"}}>
                                                    <Select 
                                                    className='segmentFilterOptions'  
                                                    placeholder="Segment by..."
                                                    onChange={this.handleSegmentFilterOptionsChanged} 
                                                    options={segmentFilterOptions}/>
                                                    <h5 style={{marginTop: "1%", marginLeft: "1%", marginRight: "2%", fontFamily: "gabarito", color: "#0930cb", fontSize: "80%"}}>NOTE: To filter by a specific number (instead of a range) - input that number into the 'from' input (only) and click 'Segment'.</h5>
                                                </div>
                                                <div className='segmentFilters' style={{display: "flex", flexDirection: "row", marginBottom: "0.5%"}}>
                                                    <span style={selectedSegmentStyle}>({this.state.selectedSegmentLabel})</span>
                                                    <label style={{marginLeft: "1.5%", paddingTop: '1%', fontFamily: "gabarito", color: "#0930cb", fontWeight: "bold"}}>from</label>
                                                    {/* <Select 
                                                    className='segmentMonthTimeline'  
                                                    placeholder="MM"
                                                    onChange={this.handleSegmentFromMonthChanged} 
                                                    options={this.state.segmentMonthFromTimelineOptions}/> */}
                                                    <input
                                                    id="segmentOptionFromValue"
                                                    value={this.state.segmentOptionFromValue}
                                                    placeholder={this.state.segmentFromOptionPlaceholder}
                                                    style={segmentOptionFromStyle}
                                                    onChange={this.handleDateChange}
                                                    />
                                                    <label style={{marginLeft: "1.5%", paddingTop: '1%', fontFamily: "gabarito", color: "#0930cb", fontWeight: "bold"}}>to</label>
                                                    {/* <Select 
                                                    className='segmentMonthTimeline'  
                                                    placeholder="MM"
                                                    onChange={this.handleSegmentToMonthChanged} 
                                                    options={this.state.segmentMonthToTimelineOptions}/> */}
                                                    <input
                                                    id="segmentOptionToValue"
                                                    value={this.state.segmentOptionToValue}
                                                    placeholder={this.state.segmentToOptionPlaceholder}
                                                    style={segmentOptionToStyle}
                                                    onChange={this.handleDateChange}
                                                    />
                                                    <button
                                                    onClick={this.segmentOptionsClicked}
                                                    style={{marginLeft: "2%", width: "10%"}}
                                                    >Segment</button>
                                                    <h4 style={{marginLeft: "1.5%", color: "red", fontSize: "90%", fontFamily: "gabarito", marginTop: "1%", marginBottom: "1%"}}>{this.state.segmentOptionsErrMsg}</h4>
                                                </div>
                                        </div>
                                    }
                                    {this.state.showSegmentOptionsLoading && 
                                        <div style={{textAlign: "center", paddingTop: "3.5%", paddingBottom: "2%"}}>
                                            <ClipLoader
                                            color="#0930cb"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                    <h4 style={{marginLeft: "1.5%", color: "red", fontSize: "80%", fontFamily: "gabarito", marginTop: "1%", marginBottom: "1%"}}>{this.state.segmentSearchErrMsg}</h4>
                                    <div style={{height: "55%", backgroundColor: "white", marginLeft: "1.5%", marginRight: "1.5%", marginTop: "1.5%", borderRadius: "8px", border: "1px solid #0930cb", overflowY: "scroll"}}>
                                        {this.state.showSegmentData && 
                                            <div>
                                                {this.renderSegmentData()}
                                            </div>
                                        }
                                        {this.state.showSegmentOptionsData && 
                                            <div>
                                                {this.renderSegmentOptionsData()}
                                            </div>
                                        }
                                        {this.state.showSegmentDataLoading && 
                                            <div style={{textAlign: "center", marginTop: "12%"}}>
                                                <ClipLoader
                                                color="#0930cb"
                                                loading={true}
                                                // cssOverride={override}
                                                size={35}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className='segmentCSVBtn' style={{textAlign: "right", marginTop: "0.75%", marginRight: "1.5%"}}>
                                        {/* {this.state.showSaveSegmentBtn && 
                                            <button
                                            >Save Segment</button>
                                        } */}
                                        {this.state.showDownloadCSVBtn && 
                                            <button
                                            style={{marginLeft: "2%"}}
                                            onClick={this.downloadCSV}
                                            >Download CSV File</button>
                                        }
                                        {this.state.showDownloadCSVBtnLoading && 
                                            <button>
                                                <ClipLoader
                                                color="#fff"
                                                loading={true}
                                                // cssOverride={override}
                                                size={12}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </button>
                                        }
                                        {this.state.showSegmentDataBtn &&
                                            <button
                                            onClick={this.segmentDataClicked}
                                            >Segment Data</button>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {this.state.showMemberLoading && 
                        <div className='memberLoadingScreen'>
                            <ClipLoader
                            color="#0930cb"
                            loading={true}
                            // cssOverride={override}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                    {this.state.showMemberProfile && 
                        <div className='memberProfile'>
                            <div className='memberProfileHeader'>
                                <div className='memberBackToSearchBtn' style={{marginBottom: '0.5%', marginTop: "0.5%"}}>
                                    <button
                                    onClick={this.backToSearch}
                                    // style={{}}
                                    >Back to Search</button>
                                </div>
                                <div style={{display: "flex", justifyContent: "space-between", marginRight: "2.5%"}}>
                                    <h1 style={{ fontFamily: "gabarito", color: "black", marginTop: "0px"}}>{this.state.memberCurrentFirstName} {this.state.memberCurrentLastName}<span style={{color: "transparent"}}>-</span><label style={{fontSize: "80%", fontFamily: "kanit", color: "#0930cb"}}> 💳 - {this.renderMemberCardNumber()}</label></h1>
                                    <span style={{backgroundColor: "#0930cb", fontFamily: "arvo", paddingTop: "1.5%", paddingBottom: "1.5%", paddingLeft: "2.5%", paddingRight: "2.5%", borderRadius: "50px"}}>
                                        <h1 style={{color: "white"}}>{this.state.memberCurrentTotalPoints} pts</h1>
                                    </span>
                                </div>
                                <div className='memberProfileHeaderContainers'>
                                    <div className='memberProfileHeaderCol'>
                                        <div className='memberProfileHeaderSection'>
                                            <div className='memberProfileHeaderSectionCol1'>
                                                <img alt='' src='/assets/memberVerified.png'/>
                                            </div>
                                            <div className='memberProfileHeaderSectionCol2'>
                                                <h5>VERIFICATION STATUS</h5>
                                                <h4>{this.state.memberVerificationStatus}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='memberProfileHeaderCol'>
                                        <div className='memberProfileHeaderSection'>
                                            <div className='memberProfileHeaderSectionCol1'>
                                                <img alt='' src='/assets/memberRegistered2.png'/>
                                            </div>
                                            <div className='memberProfileHeaderSectionCol2'>
                                                <h5>REGISTRATION DATE</h5>
                                                <h4>{this.state.memberRegistrationDate}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='memberProfileHeaderCol'>
                                        <div className='memberProfileHeaderSection'>
                                            <div className='memberProfileHeaderSectionCol1'>
                                                <img alt='' src='/assets/memberRecentActive.png'/>
                                            </div>
                                            <div className='memberProfileHeaderSectionCol2'>
                                                <h5>LAST ACTIVE</h5>
                                                <h4>{this.state.memberLastActive}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='memberProfileHeaderCol'>
                                        <div className='memberProfileHeaderSection'>
                                            <div className='memberProfileHeaderSectionCol1'>
                                                <img alt='' src='/assets/memberPhone.png'/>
                                            </div>
                                            <div className='memberProfileHeaderSectionCol2'>
                                                <h5>PHONE NUMBER</h5>
                                                <h4>{this.state.memberPhoneNumber}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='memberProfileData'>
                                <div className='memberProfileDataCol1'>
                                    <div style={{display: "flex", justifyContent: "space-between"}} className='memberProfileDataHeader'>
                                        <h3 style={{marginTop: "0px"}}>Transactions</h3>
                                        <span style={{paddingTop: "3%", marginRight: "15%"}}>
                                            <Select 
                                            className='profileOptionsMenu'
                                            defaultValue={profileOptionsDefaultValue} 
                                            placeholder="Select a time period"
                                            onChange={this.handleSelectedOrderPeriod}
                                            options={profileOptions}/>
                                        </span>
                                    </div>
                                    <div className='memberProfileDataSection'>
                                        {this.state.showNoTransactionsMsg &&
                                            <div className='memberTransactionsLoading'>
                                                <ClipLoader
                                                color="#0930cb"
                                                loading={true}
                                                // cssOverride={override}
                                                size={40}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                            
                                        }
                                        {this.state.showMemberTransactions &&
                                            <div style={{overflowY: "scroll"}}>
                                                {this.renderTransactions()}
                                            </div>
                                            
                                        }
                                    </div>
                                </div>
                                <div className='memberProfileDataCol2'>
                                    <div className='memberProfileDataHeader'>
                                        <h3 style={{marginTop: "6.75%"}}>Order Information</h3>

                                    </div>
                                    <div style={{width: "90%", overflowY: "scroll"}} className='memberProfileDataSection'>
                                        {this.state.showMemberOrderInformationHeader && 
                                            <div style={{borderBottom: "1px solid black", paddingBottom: "5%"}} className='memberOrderInformationHeader'>
                                                <p style={{color: "#000", fontFamily: "gabarito", fontWeight: "bold", marginLeft: "2%"}}>Location:<label style={{ marginLeft: "2.5%"}}></label><label style={{fontWeight: "bold", color: "#0930cb"}}>The Hub</label></p>
                                                <p style={{color: "#000", fontFamily: "gabarito", fontWeight: "bold", marginLeft: "2%"}}>Date:<label style={{ marginLeft: "2.5%"}}></label><label style={{fontWeight: "bold", color: "#0930cb"}}>{this.state.memberCurrentOrderDate}</label></p>
                                                <p style={{color: "#000", fontFamily: "gabarito", fontWeight: "bold", marginLeft: "2%"}}>Policy:<label style={{ marginLeft: "2.5%"}}></label><span><label style={{fontWeight: "bold", color: "white"}}>{this.state.memberCurrentEarningPolicy}%</label></span></p>
                                            </div>
                                        }
                                        {this.renderTransactionOrder()}
                                        {this.state.showMemberOrderInformationHeader &&
                                            <div style={{borderTop: "1px solid black", marginTop: "1.5%"}} className='memberOrderInformationHeader'>
                                                <h3 style={{marginBottom: "1.5%", textAlign: "right", color: "#000", fontFamily: "gabarito", fontWeight: "bold", marginRight: "3%"}}>Total:<label style={{ marginLeft: "2.5%"}}></label><label style={{fontWeight: "bold", color: "#0930cb"}}>KES {this.state.memberCurrentTotal}</label></h3>
                                                <h3 style={{marginTop: "0px", textAlign: "right", color: "#000", fontFamily: "gabarito", fontWeight: "bold", marginRight: "3%"}}>Points earned:<label style={{ marginLeft: "2.5%"}}></label><label style={{fontWeight: "bold", color: "#0930cb"}}>+{this.state.memberCurrentPoints} pts</label></h3>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.showTransactionsDashboard && 
                        <div className='transactionsDashboard'>
                            <div className='tDashboardLeft'>
                                {this.state.showReceiptDashboard && 
                                    <div className='tDashboardLeftContainer'>
                                        <div className='tReceiptSide'>
                                            <h3>Pending approval ⏳</h3>
                                            {this.state.showReceiptPlaceholder && 
                                                <div className='receiptPlaceholder'>
                                                    <img />
                                                </div>
                                            }
                                            {this.state.showReceiptImage && 
                                                <div className='receiptImgContainer'>
                                                    <img className='receiptImg' src={this.state.clickedReceiptImg} alt='No image found'/>
                                                </div>
                                            }
                                        </div>
                                        <div className='tDetailSide'>
                                            {this.state.showTransactionDetails &&
                                                <div className='transactionDetails'>
                                                    <div className='tDetailInputs'>
                                                        <div className='tDetailLabel'>
                                                            <p>Invoice no.:</p>
                                                        </div>
                                                        <div className='tDetailInput'>
                                                            <input
                                                            id='invoiceNumber'
                                                            value={this.state.invoiceNumber}
                                                            onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='tDetailInputs'>
                                                        <div className='tDetailLabel'>
                                                            <p>Date of purchase:</p>
                                                        </div>
                                                        <div className='tDetailInput'>
                                                            <input
                                                            id='dateOfPurchase'
                                                            value={this.state.dateOfPurchase}
                                                            onChange={this.handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='tDetailInputs'>
                                                        <div className='tDetailLabel'>
                                                            <p>Location:</p>
                                                        </div>
                                                        <div className='tDetailInput'>
                                                            <input
                                                            value={this.state.storeLocation}
                                                            />
                                                        </div>
                                                    </div>
                                                    {this.state.showEarningPolicy && 
                                                        <div className='tDetailInputs'>
                                                            <div className='tDetailLabel' style={{marginTop: "1.5%"}}>
                                                                <p style={{marginTop: "0px"}}>Earning Policy:</p>
                                                            </div>
                                                            <div className='tDetailInput' style={{paddingTop: "1.5%"}}>
                                                                <label style={{marginLeft: "3%"}}>{this.state.earningPolicyPointsValue} → {this.state.earningPolicyMoneyValue} </label><span><label style={{color: "white"}}>↑ {this.state.earningPolicyPercentageChange}%</label></span>
                                                            </div>
                                                            {/* <div className='validEarningPolicies'>
                                                                {this.renderValidEarningPolicies()}
                                                            </div> */}
                                                        </div>
                                                    }
                                                    <div className='tDetailInputs'>
                                                        <div className='tDetailLabel'>
                                                            <p>Order:</p>
                                                        </div>
                                                        <div className='tDetailInput'>
                                                            {this.state.showAddOrderBtn && 
                                                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                    <button
                                                                    onClick={this.addReceiptOrderClicked}
                                                                    >Add item</button>
                                                                    {this.state.showClearMenuOrdersBtn && 
                                                                        <button
                                                                        onClick={this.clearMenuOrders}
                                                                        style={{backgroundColor: "#E5E5E5", width: "25%", color: "red", marginRight: "7.5%", borderRadius: "20px", paddingLeft: "3%", paddingRight: "3%"}}
                                                                        >Clear</button>
                                                                    }
                                                                </div>
                                                            }
                                                            {this.state.showOrderStatus && 
                                                                <div className='orderStatus' style={{display: "flex", justifyContent: "space-between"}}>
                                                                    <p style={{marginTop: "1%", color: "black"}}>Item(s): {this.state.currentOrderCount}</p>
                                                                    <img onClick={this.closeOrderWindow} src='/assets/exit-baseline-alert.png'/>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {this.state.showMenuOrdersLoading && 
                                                        <div className='menuOrdersLoading'>
                                                            <ClipLoader
                                                            color="#0930cb"
                                                            loading={true}
                                                            // cssOverride={override}
                                                            size={20}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                            />
                                                        </div>
                                                    }
                                                    {this.state.showReceiptOrders && 
                                                        <div className='tDetailInputs'>
                                                            <div className='tDetailLabel'>
                                                                <p style={{color: "transparent"}}>Order List</p>
                                                            </div>
                                                            <div className='tDetailInput'>
                                                                {this.renderReceiptOrders()}
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.showOrderInputFields &&
                                                        <div>
                                                            <div className='orderSelectionContainer'>
                                                                <div style={redeemPointsCategories} className='pointsInput'>
                                                                    {this.state.showRewardsCategories && 
                                                                        <div className='rewardCategories'>
                                                                            <h5>Menu Category <label>*</label></h5>
                                                                            <Select
                                                                            className='selectMenu'
                                                                            // components={animatedComponents}
                                                                            placeholder="Select a menu category"
                                                                            // isMulti
                                                                            options={this.state.menuCategories}
                                                                            onChange={this.handleMenuCategoryClicked}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    {this.state.showCoffeeAndTea &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Coffee & Tea <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showIcedCoffeeAndTea &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Iced Teas & Coffee <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showBreakfast &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Breakfast <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showStartersAndSharing &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Starters & Sharing <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showLunchAndDinner &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Lunch & Dinner <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showBurgers &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Burgers <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showChips &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Chips <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showWings &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Wings <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSandwiches &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Sandwiches <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSalads &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Salads <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showArtPizzas &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Art Pizza (Italian Style) <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                options={this.state.selectedMenuCategory}/>
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showPasta &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Pasta <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showBakery &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Bakery <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showCakesAndDesserts &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Cakes & Desserts <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showColdPressJuices &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Cold-Press Juices <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSoftDrinks &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Soft Drinks <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showKidsMenu &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Kids Menu <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showWholeCakes &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Whole Cakes <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showPowerSmoothies &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Power Smoothies <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSteaks &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Steaks <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSoup &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Soup <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showMocktails &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Mocktails <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showHotNBoozy &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Hot N Boozy <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showBeer &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Beer <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showWhiteWine &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>White Wine <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSangria &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Sangria <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showRedWine &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Red Wine <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSparkling &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Sparkling <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showRose &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Rosé <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showArtCocktails &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Art Cocktails <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showCocktails &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Classic Cocktails <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showSpiritsAndLiquer &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Spirits and Liquer <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showMilkshakes &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Milkshakes <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {this.state.showQuiches &&
                                                                        <div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quiches <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an item"
                                                                                options={this.state.selectedMenuCategory}
                                                                                onChange={this.rewardMenuItemSelected}
                                                                                />
                                                                            </div>
                                                                            <div className='rewardCategories'>
                                                                                <h5>Quantity <label>*</label></h5>
                                                                                <Select 
                                                                                className='selectMenu' 
                                                                                placeholder="Select an quantity"
                                                                                onChange={this.selectedMenuItemQuantity}
                                                                                options={options5}/>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {this.state.showReceiptMeals && 
                                                                <div>
                                                                    {this.state.menuOrders.map((order, index) => (
                                                                        <p style={{color: "black"}} key={index}><li>{order}</li></p>
                                                                    ))}
                                                                </div>
                                                            }
                                                            {this.state.showMealInputInformation && 
                                                                <div>
                                                                    <h5>Input Meal Details</h5>
                                                                </div>
                                                            }
                                                        </div>
                                                    }   
                                                    {this.state.showReceiptTotalCost && 
                                                        <div>
                                                            <div className='tDetailInputs'>
                                                                <div className='tDetailLabel' style={{marginTop: "2.5%"}}>
                                                                    <p>Total cost:</p>
                                                                </div>
                                                                <div className='tDetailInput' style={{paddingTop: "3%"}}>
                                                                    <label style={{marginLeft: "3%"}}>KES {this.state.totalCost}</label>
                                                                </div>
                                                                {/* <div className='validEarningPolicies'>
                                                                    {this.renderValidEarningPolicies()}
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.showRejectionCustomerMsg && 
                                                        <div className='rejectionCustomerMsg'>
                                                            <textarea
                                                            id='rejectionCustomerMessage'
                                                            value={this.state.rejectionCustomerMessage}
                                                            onChange={this.handleChange}
                                                            placeholder='Enter reason for rejected receipt request'
                                                            />
                                                            <div style={{marginTop: "2.5%"}}>
                                                                <button
                                                                onClick={this.rejectionReason1Clicked}
                                                                >Image is not clear enough</button>
                                                            </div>
                                                            <div>
                                                                <button
                                                                onClick={this.rejectionReason2Clicked}
                                                                >Image doesn't capture all relevant details</button>
                                                            </div>
                                                            <div style={{marginBottom: "5%"}}>
                                                                <button
                                                                onClick={this.rejectionReason3Clicked}
                                                                >Store location is not registered yet</button>
                                                            </div>
                                                            <div style={{marginTop: "3%"}} id='rejectionCustomerMsgScroll'></div>
                                                        </div>
                                                    }
                                                    {this.state.showOrderAddedConfirmation && 
                                                        <div className='rewardsErrorMsg'>
                                                            <div className='baselineValueAlert'>
                                                                <div className='baselineValueMsg'>
                                                                    <h5>{this.state.showOrderAlertMessage}</h5>
                                                                </div>
                                                                <div className='baselineValueClose'>
                                                                    <button
                                                                    onClick={this.closeOrderNotification}
                                                                    ><img src='assets/exit-baseline-alert.png'/></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.showCompleteAddOrderButton && 
                                                        <div className='completeAddOrderBtn'>
                                                            <button
                                                            onClick={this.completeAddOrderClicked}
                                                            >Add Order
                                                            </button>
                                                        </div>
                                                    }
                                                    {this.state.showCompleteAddOrderButtonLoading && 
                                                        <div className='completeAddOrderBtn'>
                                                            <button
                                                            style={{backgroundColor: "white", border: "2px solid #0930cb", cursor: "not-allowed"}}
                                                            >
                                                            <ClipLoader
                                                            color="#0930cb"
                                                            loading={true}
                                                            // cssOverride={override}
                                                            size={10}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                            />
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {this.state.showTransactionDetailsLoading && 
                                                <div className='transactionDetailsLoading'>
                                                    <div style={{marginTop: "42.5%"}}>
                                                        <ClipLoader
                                                        color="#0930cb"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={40}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                        <div style={{fontFamily: "gabarito", color: "#0930cb"}}>
                                                            <p>{this.state.approvalLoadingMsg}</p>
                                                        </div>
                                                    </div>
                                                    {/* <div className='validEarningPolicies'>
                                                        {this.renderValidEarningPolicies()}
                                                    </div> */}
                                                </div>
                                            }
                                            {this.state.showApproveRecjetionBtns && 
                                                <div style={{display: "flex", justifyContent: "space-between", marginLeft: "7.5%"}} className='transactionCompletionBtns'>
                                                    <button 
                                                    className='rejectTransactionBtn'
                                                    onClick={this.rejectOrderClicked}
                                                    >Reject Order</button>
                                                    <button className='approveTransactionBtn'
                                                    onClick={this.approveOrderClicked}
                                                    >Approve Order</button>
                                                </div>
                                            }
                                            {this.state.showRejectionConfirmBtns && 
                                                <div style={{display: "flex", justifyContent: "space-between", marginLeft: "7.5%"}} className='transactionCompletionBtns'>
                                                    <button style={{backgroundColor: "white", color: "#0930cb", border: "2px solid #0930cb"}} className='rejectTransactionBtn'
                                                    onClick={this.cancelRejectRequest}
                                                    >Cancel</button>
                                                    <button 
                                                    onClick={this.rejectConfirmClicked}
                                                    style={{backgroundColor: "red", color: "white", border: "2px solid red"}} className='approveTransactionBtn'>Reject Order</button>
                                                </div>
                                            }
                                            {this.state.showApproveConfirmBtns && 
                                                <div style={{display: "flex", justifyContent: "space-between", marginLeft: "7.5%"}} className='transactionCompletionBtns'>
                                                    <button style={{backgroundColor: "white", color: "#0930cb", border: "2px solid #0930cb"}} className='rejectTransactionBtn'
                                                    onClick={this.cancelApproveRequest}
                                                    >Cancel</button>
                                                    <button style={{backgroundColor: "green", color: "white", border: "2px solid green"}} className='approveTransactionBtn'
                                                    onClick={this.approveConfirmClicked}
                                                    >Approve Order</button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.showReceiptDashboardPlaceholder && 
                                    <div className='tDashboardLeftContainer'>
                                        <div className='tDashboardPlaceholderContainer'>
                                            <h1>Select a receipt request to review it</h1>
                                            <img src='/assets/receipt-request-placeholder.png'/>
                                        </div>
                                    </div>
                                }
                                {this.state.showReceiptDashboardLoading && 
                                    <div className='tDashboardLeftContainer'>
                                        <div className='tDashboardLeftLoading'>
                                            <ClipLoader
                                            color="#0930cb"
                                            loading={true}
                                            // cssOverride={override}
                                            size={50}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className='tDashboardRight'>
                                <div className='tVerifiedButtons'>
                                    <button
                                    onClick={this.tPendingApprovalBtnClicked}
                                    style={tPendingApprovalBtn}
                                    className='pendingApprovalBtn'
                                    >Pending Appr. ({this.state.nonVerifiedReceipts.length})</button>
                                    <button
                                    onClick={this.tApprovedBtnClicked}
                                    style={tApprovedBtn}
                                    className='approvalBtn'
                                    >Approved</button>
                                </div>
                                <div className='tDashboardRightContainer'>
                                    <div className='tSearchContainer'>
                                        <div className='tSearchBar'>
                                            <input/>
                                        </div>
                                        <div className='tSearchButton'>
                                            <button
                                            >Search</button>
                                        </div>
                                    </div>
                                    <div className='tReceiptList'>
                                        {this.renderNonVerifiedReceipts()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.showPointsManager && 
                        <div style={{padding: "1%"}} className='pointsManager'>
                            <div className='pointsManagerInnerContainer' style={{width: "100%", height: "100%"}}>
                                <div style={{border: "1px solid #0930cb", height: "100%", overflowY: "scroll", backgroundColor: "white", borderRadius: "6px"}} className='pointsManagerCol1'>
                                    {this.renderPendingPoints()}
                                </div>
                                <div className='pointsManagerCol2'>
                                    {this.state.showPointsClickedInfo && 
                                        <div>
                                            <div className='pointsRedeemInfo'>
                                                <h2 style={{textAlign: "left", fontFamily: "sora", color: "#0930cb"}}>Points Information:</h2>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Reward Type:</h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardType}</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Reward Value:</h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardCustomerValue !== "" ? "Custom" : this.state.rewardValue }</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Reward Discount Price:</h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4><label style={{color: "black", marginRight: "2%"}}>KES</label>{this.state.rewardDiscountPrice}</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Date: </h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardDateDatabase}</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Name:</h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardUserName}</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Customer Reward Value: </h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardCustomerValue !== "" ? this.state.rewardCustomerValue : "None" }</h4>
                                                </div>
                                            </div>
                                            <div className='pointsRedeemInfo'>
                                                <div className='pointsRedeemInfoCol1'> 
                                                    <h4>Points Redeemed: </h4>
                                                </div>
                                                <div className='pointsRedeemInfoCol2'>
                                                    <h4>{this.state.rewardPointsValue}</h4>
                                                </div>
                                            </div>
                                            <div style={{textAlign: "right", marginTop: "3%"}}>
                                                <button
                                                style={{
                                                    backgroundColor: "#0930cb",
                                                    color: "white",
                                                    fontFamily: "sora",
                                                    padding: "2.5%",
                                                    width: "25%",
                                                    border: "2px solid #0930cb",
                                                    borderRadius: "30px",
                                                    cursor: "pointer"
                                                }}
                                                onClick={this.saveRewardData}
                                                >Save Data</button>
                                            </div>
                                        </div>
                                    }
                                    {this.state.showPointsRedeemPlaceholder && 
                                        <div className='tDashboardPlaceholderContainer'>
                                            <h1>Select a redeem request</h1>
                                            <img src='/assets/receipt-request-placeholder.png'/>
                                        </div>
                                    }
                                    {this.state.showPointsRedeemLoading && 
                                        <div style={{textAlign: "center", marginTop: "34.5%"}}>
                                            <ClipLoader
                                            color="#0930cb"
                                            loading={true}
                                            // cssOverride={override}
                                            size={40}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}